webpackJsonp([1],{

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(1282)
}
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue___default.a,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.resize),expression:"resize"}],staticClass:"viewport treeclass"})}
var staticRenderFns = []


/***/ }),

/***/ 1228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"treeviewer"},[_c('splitpane',{attrs:{"leftPaneStyle":"width:900px"}},[_c('div',{staticStyle:{"width":"900px"},attrs:{"slot":"left"},slot:"left"},[_c('d3tree',{ref:"tree",staticClass:"tree",staticStyle:{"height":"calc(100vh - 26px)"},attrs:{"reset":_vm.reset,"openDepth":_vm.openDepth,"zoomable":_vm.zoomable,"data":_vm.data,"node-text":_vm.nodeText,"margin-x":_vm.Marginx,"margin-y":_vm.Marginy,"type":_vm.type,"layout-type":_vm.layoutType,"duration":_vm.duration},on:{"clicked":_vm.onClick}})],1),_vm._v(" "),_c('contentpane',{attrs:{"slot":"right"},slot:"right"})],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 1229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8f6a04c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(1230)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c8f6a04c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8f6a04c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8f6a04c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1230:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings"},[_c('div',[_c('h1',{staticStyle:{"margin-left":"0"}},[_vm._v("LeoVue")]),_vm._v(" "),_c('div',[_vm._v("Version 2.0.0")]),_vm._v(" "),_c('div',{staticClass:"hshim"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"hshim"}),_vm._v(" "),(_vm.staticSite)?_c('div',[_vm._m(1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hshim"}),_vm._v(" "),_c('div',[_c('div',{staticClass:"link",on:{"click":_vm.main}},[_vm._v("Return to Main")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":"https://github.com/kaleguy/leoviewer"}},[_vm._v("LeoVue on Github")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":"static/site/index.html"}},[_vm._v("HTML Site")])])}]


/***/ }),

/***/ 1232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccordionViewer_vue__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccordionViewer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccordionViewer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccordionViewer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccordionViewer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41c4777b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccordionViewer_vue__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(1233)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccordionViewer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41c4777b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccordionViewer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41c4777b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccordionViewer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1233:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordionviewer"},[_c('div',{staticClass:"panes-container"},[_c('div',{staticClass:"center-pane",attrs:{"id":"center-pane"}},[_c('ul',{style:(_vm.ulStyle)},_vm._l((_vm.data),function(itemdata,index){return _c('div',[_c('item',{staticClass:"item",attrs:{"top":_vm.getTop(index),"model":itemdata,"textItems":_vm.text,"targetEl":false,"open":false}})],1)}))])])])}
var staticRenderFns = []


/***/ }),

/***/ 1235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NestedViewer_vue__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NestedViewer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NestedViewer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NestedViewer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NestedViewer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2847815e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NestedViewer_vue__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(1236)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NestedViewer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2847815e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NestedViewer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2847815e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NestedViewer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1236:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nestedviewer"},[_c('splitpane',{attrs:{"leftPaneStyle":_vm.leftPaneStyle}},[_c('ul',{style:(_vm.ulStyle),attrs:{"slot":"left"},slot:"left"},_vm._l((_vm.data),function(itemdata){return _c('div',[_c('item',{staticClass:"item",attrs:{"model":itemdata,"top":false,"textItems":_vm.text,"accordion":true,"targetEl":_vm.target.el}})],1)})),_vm._v(" "),_c('contentpane',{attrs:{"slot":"right"},slot:"right"})],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 1238:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(155);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = __webpack_require__(79);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(66);

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__(77);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(1239);

var _vuex2 = _interopRequireDefault(_vuex);

var _leo = __webpack_require__(1240);

var _router = __webpack_require__(218);

var _router2 = _interopRequireDefault(_router);

var _axios = __webpack_require__(354);

var _axios2 = _interopRequireDefault(_axios);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

var _jsYaml = __webpack_require__(143);

var _jsYaml2 = _interopRequireDefault(_jsYaml);

var _papaparse = __webpack_require__(1259);

var _papaparse2 = _interopRequireDefault(_papaparse);

var _xsl = __webpack_require__(1270);

var _xsl2 = _interopRequireDefault(_xsl);

var _velocityAnimate = __webpack_require__(228);

var _velocityAnimate2 = _interopRequireDefault(_velocityAnimate);

var _lodashTemplate = __webpack_require__(232);

var _lodashTemplate2 = _interopRequireDefault(_lodashTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parserURI = __webpack_require__(1271);
var HTML5Outline = __webpack_require__(1272);
var util = __webpack_require__(31);
var md = __webpack_require__(146)({
  html: true,
  linkify: true,
  typographer: true
});

var lunr = __webpack_require__(1279);
function loadIndex(titles, text) {
  var docs = loadIndexItems([], titles, text);

  var idx = lunr(function () {
    this.ref('id');
    this.field('text');
    docs.forEach(function (doc) {
      this.add(doc);
    }, this);
  });
  return { idx: idx, docs: docs };
}
function loadIndexItems(arr, titles, textItems) {
  if (!titles) {
    return arr;
  }
  titles.forEach(function (item) {
    arr.push({
      id: item.id,
      name: item.name.replace(/^@(.*?)\s/, '').replace(/^set(.*?)\s/, ''),
      text: textItems[item.t]
    });
    loadIndexItems(arr, item.children, textItems);
  });
  return arr;
}
function goToAdjacentItem(context, item) {
  if (item && item[0] && item[0].id) {
    var id = item[0].id;
    context.dispatch('setCurrentItem', { id: id });
    return true;
  } else {
    return false;
  }
}

_vue2.default.use(_vuex2.default);
var spinnerHTML = '<div class="spin-box"><div class="single10"></div></div>';

function showText(context, text, id, nowrapper, params) {
  if (params && params.displayType === 'board') {
    context.commit('CONTENT_PANE', { type: 'board' });
    nowrapper = true;
  } else {
    context.commit('CONTENT_PANE', { type: 'text' });
  }
  if (!text) {
    text = '';
    context.commit('CURRENT_ITEM_CONTENT', { text: text });
    return;
  }
  text = util.formatText(text, nowrapper);

  context.commit('CURRENT_ITEM_CONTENT', { text: text });

  var newItem = { id: id, t: text };
  context.commit('CONTENT_ITEM', { item: newItem });
  context.commit('CONTENT_ITEM_UPDATE');
}

function getRoots(acc, p, startIndex) {
  var i = p.indexOf('-', startIndex);
  if (i < 0) {
    return acc;
  }
  acc.push(p.substring(0, i));
  return getRoots(acc, p, i + 1);
}

function isRelative(url) {
  var ok = true;
  if (/^[xh]ttp/.test(url)) {
    return false;
  }
  if (/^\//.test(url)) {}
  if (window.lconfig.filename) {
    return false;
  }
  return ok;
}

function loadLeoNode(context, item) {
  console.log('LOADING SUBTREE');
  var p = new _promise2.default(function (resolve, reject) {
    var title = item.name;
    var id = item.id;

    var _getUrlFromTitle = getUrlFromTitle(title),
        url = _getUrlFromTitle.url,
        label = _getUrlFromTitle.label;

    if (!url) {
      return;
    }

    (0, _leo.getLeoJSON)(url, id).then(function (data) {
      var text = data.textItems;
      data = data.data;
      context.commit('ADDTEXT', { text: text });
      if (data.length === 1) {
        context.commit('RESET');
        console.log('SUBTREE RESET', id);
        data = data[0];
        item.children = data.children;
        item.t = data.t;
        item.name = label;
        context.dispatch('setCurrentItem', { id: id, reset: true });
      } else {
        item.name = label;
        item.children = data;
      }
      resolve(true);
    });
  }).catch(function (e) {
    return console.log('Error: ', e);
  });
  return p;
}

function getUrlFromTitle(title, dataType) {
  var url = '';
  var label = '';
  title = title.replace(/^@[a-zA-Z-]*? /, '');
  var dataParams = null;
  var re = /^\[(.*?)\]\((.*?)\)$/;
  var match = re.exec(title);
  if (dataType) {
    dataType = dataType.replace('-', '');
    dataParams = window.lconfig.dataSources[dataType];
    if (!dataParams) {
      console.log('No match for dataType:', dataType);
      return { url: url, label: label };
    }
    url = dataParams.host + title;
    if (match) {
      label = match[1];
      url = dataParams.host + match[2];
    } else {
      label = title.replace(/_/g, ' ').replace(/^\d+/, '');
    }
    return { url: url, label: label };
  }
  if (!match) {
    return { url: url, label: label };
  }
  url = match[2];
  label = match[1];
  if (!url) {
    return null;
  }
  if (isRelative(url)) {}

  if (/^[xh]ttp/.test(url)) {
    return { url: url, label: label };
  }

  var cname = window.lconfig.filename;

  if (cname.indexOf('/') < 0) {
    cname = '';
  }
  if (cname && cname.indexOf('http') > -1) {
    var u = window.lconfig.filename;
    u = util.chop(u, '#');
    u = util.chop(u, '?');
    u = util.chop(u, '/');
    url = u + '/' + url;
  }

  return { url: url, label: label };
}
function showPresentation(context, title, id) {
  var dummy = Math.random();
  var iframeHTML = '\n    <div style="width:100%">\n    <iframe\n       src="about:blank" height="100%" width="100%"\n       marginwidth="0" marginheight="0"\n       hspace="0" vspace="0"\n       dummy="' + dummy + '"\n       frameBorder="0" />\n    </div>\n  ';
  context.commit('IFRAME_HTML', { iframeHTML: iframeHTML });
  context.commit('CONTENT_PANE', { type: 'site' });
}
function showKanban(context, title, id) {
  var text = '<kanban/>';
  context.commit('CURRENT_ITEM_CONTENT', { text: text });
  var newItem = { id: id, t: text };
  context.commit('CONTENT_ITEM', { item: newItem });
  context.commit('CONTENT_ITEM_UPDATE');
  context.commit('CONTENT_PANE', { type: 'board' });
}
function showMermaid(context, title, id) {
  var text = '<mermaid-board/>';
  context.commit('CURRENT_ITEM_CONTENT', { text: text });
  var newItem = { id: id, t: text };
  context.commit('CONTENT_ITEM', { item: newItem });
  context.commit('CONTENT_ITEM_UPDATE');
  context.commit('CONTENT_PANE', { type: 'board' });
}

function checkCache(context, item, url) {
  if (item.loaded) {
    console.log('Retrieving', url, ' content from cache.');
    var text = context.state.leotext[item.t];
    context.commit('CURRENT_ITEM_CONTENT', { text: text });
    return true;
  }
  return false;
}

function showFormattedData(context, id, url, xslType, dataType, params, t) {
  var query = url;

  if (/^xttp/.test(url)) {
    url = url.replace(/^xttp/, 'http');
    query = 'https://query.yahooapis.com/v1/public/yql?q=' + encodeURIComponent('select * from xml where url="' + url + '"') + '&format=xml';
  }

  context.commit('CURRENT_ITEM_CONTENT', { text: spinnerHTML });
  return _axios2.default.get(query).then(function (response) {
    var data = response.data;
    if (dataType === 'json') {
      data.params = params;
      if (params.nodeList) {
        data.params.displayType = 'board';
      }
    }

    var text = (0, _stringify2.default)(data, null, 2);
    context.state.leotext[t] = text;

    if (dataType === 'xml') {
      return _xsl2.default.render(data, xslType).then(function (html) {
        showText(context, html, id, null, params);
      });
    }
    var html = _lodashTemplate2.default.render(data, xslType);
    showText(context, html, id, null, params);
    if (params && params.nodeList) {
      var nodeList = params.nodeList;
      var dataArray = data[nodeList.listKey];
      if (params.filter) {
        var filter = params.filter;
        dataArray = _lodash2.default.filter(dataArray, function (o) {
          return _lodash2.default.get(o, filter.key, '') === filter.value;
        });
      }
      var template = nodeList.template || '';
      addChildNodes(context.state, id, dataArray, template, nodeList.hrefIsQueryString, nodeList.hrefKey, nodeList.template, nodeList.titleKey);
    }
  }).catch(function (error) {
    console.log(error);
  });
}

function addChildNodes(context, parentId, data, template, urlIsQueryString, hrefKey, childTemplate, titleKey) {
  if (!_lodash2.default.isArray(data)) {
    return;
  }
  var item = JSON.search(context.leodata, '//*[id="' + parentId + '"]')[0];
  var children = [];
  if (template) {
    template = '-' + template;
  }
  data.forEach(function (n, index) {
    _lodash2.default.set(n, 'params.template', childTemplate);
    var id = parentId + '-' + index;
    titleKey = titleKey || 'title.text';
    var titleText = _lodash2.default.get(n, titleKey, 'NO TITLE');
    var name = titleText;
    var vtitle = titleText;
    if (n.title) {
      vtitle = n.title.text;
    }

    if (hrefKey) {
      var url = _lodash2.default.get(n, hrefKey);
      if (urlIsQueryString) {
        url = '/' + url;
        url = url.substring(url.lastIndexOf('/') + 1);
      }

      name = '@json' + template + ' [' + titleText + '](' + url + ')';
    } else {
      name = '@dataSet set' + id + ' ' + titleText;
    }
    vtitle = vtitle.replace(/<</g, '\xAB').replace(/>>/g, '\xBB');
    var t = id;
    context.leotext[t] = (0, _stringify2.default)(n);
    children.push({ name: name, id: id, vtitle: vtitle, t: t });
  });

  item.children = children;
  return true;
}

function showBook(context, item, url, params) {
  var id = item.id;
  url = 'https://openlibrary.org/api/books?format=json&jscmd=data&bibkeys=ISBN:' + url;
  context.commit('CURRENT_ITEM_CONTENT', { text: spinnerHTML });
  _axios2.default.get(url).then(function (response) {
    var data = response.data;
    var bookData = data[(0, _keys2.default)(data)[0]];
    item.name = bookData.title.split(' ').map(function (w) {
      return _lodash2.default.capitalize(w);
    }).join(' ');
    item.loaded = true;
    data.params = params;
    var html = _lodashTemplate2.default.render(data, 'openbooks');
    showText(context, html, id, null, params);
    context.commit('CONTENT_ITEM_UPDATE');
    context.state.leotext[item.t] = html;
  }).catch(function (error) {
    console.log(error);
  });
}

function showPageOutline(context, item, id, subpath) {
  if (!id) {
    id = item.id;
  }
  return new _promise2.default(function (resolve, reject) {
    var _getUrlFromTitle2 = getUrlFromTitle(item.name),
        url = _getUrlFromTitle2.url,
        label = _getUrlFromTitle2.label;

    if (!url) {
      return;
    }
    var site = url;
    var t = parserURI(url);
    var host = t.host;
    var yql = "select * from htmlstring where url='" + site + "' AND xpath='//*'";
    var resturl = "https://query.yahooapis.com/v1/public/yql?q=" + encodeURIComponent(yql) + "&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys";
    context.commit('CURRENT_ITEM_CONTENT', { text: spinnerHTML });
    _axios2.default.get(resturl).then(function (response) {
      var dummy = document.getElementById('dummy');
      if (dummy) {
        dummy.outerHTML = '';
      }
      dummy = document.createElement('section');
      dummy.setAttribute('id', 'dummy');
      dummy.style.display = 'none';
      document.body.appendChild(dummy);
      var html = response.data.query.results.result;

      var bad1 = html.indexOf('<div class="toccolours searchaux"');
      if (bad1) {
        var bad2 = html.indexOf('<div class="hatnote navigation-not-searchable"', bad1);
        html = html.substring(0, bad1) + html.substring(bad2);
      }
      html = cleanHTML(html, host);
      dummy.innerHTML = html;
      var contentHTML = html;

      var wikiContentEl = dummy.getElementsByClassName('mw-content-ltr')[0];
      if (wikiContentEl) {
        contentHTML = wikiContentEl.innerHTML;
      }

      var gbContentEl = dummy.getElementsByClassName('markdown-section')[0];
      if (gbContentEl) {
        contentHTML = gbContentEl.innerHTML;
        dummy = gbContentEl;
      }

      contentHTML = '<div class="outline-pane">' + '<div class="note-box">' + 'Downloaded from ' + site + '</div>' + contentHTML + '</div>';
      var outline = HTML5Outline(dummy);
      var outlineItem = {};
      var textItems = {};
      counter = 0;
      outlineToItem(outline.sections[0], outlineItem, item.id, textItems, host);

      _lodash2.default.remove(outlineItem.children, function (c) {
        return c.name === 'Contents';
      });
      var fullContentItem = {
        id: item.id + '-0',
        name: 'Full Page Content',
        t: item.id + '-0'
      };
      outlineItem.children.unshift(fullContentItem);
      var lines = [];

      var toc = document.getElementById('toc');
      if (toc && toc.previousElementSibling) {
        getPriorContent(toc.previousElementSibling, lines, host);
      }
      var priorContent = lines.reverse().join('');
      textItems[item.id + '-' + 1] = '<div class="fp-pane">' + priorContent + textItems[item.id + '-' + 1] + '</div>';
      textItems[item.id] = textItems[id + '-' + 1];
      textItems[item.id + '-0'] = contentHTML;
      item.t = item.id;
      context.commit('ADDTEXT', { text: textItems });
      item.children[0] = outlineItem;
      context.commit('RESET');
      if (window.lconfig.path) {
        subpath = window.lconfig.path;
      }
      if (subpath) {
        var pathObj = translatePath(subpath, context.state.leodata);
        id = pathObj.npath;
      }
      context.commit('CURRENT_ITEM', { id: id });
      context.commit('CURRENT_ITEM_CONTENT', { text: textItems[id] });
      item.children = outlineItem.children;
      resolve(true);
    }).catch(function (error) {
      console.log(error);
      reject(error);
    });
  });
}

function replaceRelLinks(host, content) {
  if (!host || !content) {
    return content;
  }

  content = content.replace(/href="([a-zA-Z])/g, 'target="_blank" href="//' + host + '/$1');
  content = content.replace(/src="\/([a-zA-Z])/g, 'src="//' + host + '/$1');
  content = content.replace(/srcset="\//g, 'srcset="//' + host + '/');
  content = content.replace(/, \/static\/images/g, ', ' + '//' + host + '/static/images');
  return content;
}

function getLeadContent(startNode, lines, host) {
  var sectionTags = ['H1', 'H2', 'H3', 'H4', 'H5'];
  if (sectionTags.indexOf(startNode.tagName) > -1) {
    return;
  }
  var nextSibling = startNode.nextElementSibling;
  if (!nextSibling) {
    return;
  }
  var cleanedHTML = cleanHTML(startNode.outerHTML, host);
  lines.push(cleanedHTML);
  getLeadContent(nextSibling, lines, host);
}

function cleanHTML(html, host) {
  html = html.replace(/<script(?:(?!\/\/)(?!\/\*)[^'"]|"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\/\/.*(?:\n)|\/\*(?:(?:.|\s))*?\*\/)*?<\/script>/g, '');
  html = html.replace(/>\s+?,/g, '>,');
  html = html.replace(/>\s+?\./g, '>.');
  html = html.replace(/>\s+?["]/g, '>,"');
  html = html.replace(/&amp;#27;/g, "'");
  html = html.replace(/\( "/g, '("');
  html = html.replace(/" \)/g, '")');
  html = replaceRelLinks(host, html);

  return html;
}

function getPriorContent(startNode, lines, host) {
  var sectionTags = ['H1', 'H2', 'H3', 'H4', 'H5'];
  if (sectionTags.indexOf(startNode.tagName) > -1) {
    return;
  }
  var prevSibling = startNode.previousElementSibling;
  if (!prevSibling) {
    return;
  }
  lines.push(cleanHTML(startNode.outerHTML, host));
  getPriorContent(prevSibling, lines);
}

var counter = 0;
function outlineToItem(outline, item, idBase, textItems, host) {
  if (!outline.heading) {
    return;
  }
  counter = +counter + 1;
  item.id = idBase + '-' + counter;
  item.name = getHeadingText(outline.heading.innerText);
  item.t = item.id;
  var sections = outline.sections;
  var html = getHTMLFromSection(outline, host);
  textItems[item.id] = html;
  item.children = [];
  sections.forEach(function (section, i) {
    var childItem = {};
    outlineToItem(section, childItem, +idBase, textItems, host);
    item.children.push(childItem);
  });
  return item;
}
function getHeadingText(h) {
  if (!h) {
    h = '';
  }
  try {
    h = h.replace(/\n/g, '').replace(/\[.*?\]/i, '').trim();
  } catch (e) {
    console.log('Error in outline parse heading:', e);
  }
  return h;
}
function getHTMLFromSection(outline, host) {
  var html = [];
  var sections = outline.sections;
  var content = '';
  var nextSibling = outline.startingNode.nextElementSibling;
  if (nextSibling) {
    var contentArray = [];
    getLeadContent(nextSibling, contentArray, host);
    content = contentArray.join('');
  }
  if (content) {
    html.push(content);
  }
  sections.forEach(function (section) {
    var heading = getHeadingText(section.heading.innerText);
    if (heading === 'Contents') {
      return;
    }
    heading = '<sectionlink :title="\'' + heading + '\'"/>';
    if (heading) {
      html.push(heading);
    }
  });
  return '<div class="outline-pane">' + html.join('<br>') + '</div>';
}
function showD3Board(context, title, id) {
  var text = '<d3-board/>';
  context.commit('CURRENT_ITEM_CONTENT', { text: text });
  var newItem = { id: id, t: text };
  context.commit('CONTENT_ITEM', { item: newItem });
  context.commit('CONTENT_ITEM_UPDATE');
  context.commit('CONTENT_PANE', { type: 'board' });
}
function showSite(context, title, id) {
  var _getUrlFromTitle3 = getUrlFromTitle(title),
      url = _getUrlFromTitle3.url,
      label = _getUrlFromTitle3.label;

  if (!url) {
    return;
  }
  var ext = util.getFileExtension(url);
  var base = url.substring(0, url.lastIndexOf('/'));
  if (ext === 'md') {
    _axios2.default.get(url).then(function (response) {
      var html = md.render(response.data);
      html = '@language md\n<div class="md">' + html + '</div>';
      html = util.replaceRelUrls(html, base);
      showText(context, html, id);
      context.commit('CONTENT_PANE', { type: 'text' });
    }).catch(function (error) {
      console.log(error);
    });
  }
  if (ext === 'xml') {
    showFormattedData(context, id, url, null, 'xml');
  }
  var iframeHTML = '\n    <div class=iframe-' + ext + ' style="width:100%">\n    <iframe\n       src="' + url + '" height="100%" width="100%"\n       marginwidth="0" marginheight="0"\n       hspace="0" vspace="0"\n       frameBorder="0" />\n    </div>\n  ';
  context.commit('IFRAME_HTML', { iframeHTML: iframeHTML });
  context.commit('CONTENT_PANE', { type: 'site' });
}

function setSiteItem(context, title, id) {
  var _getUrlFromTitle4 = getUrlFromTitle(title),
      url = _getUrlFromTitle4.url,
      label = _getUrlFromTitle4.label;

  if (!url) {
    return;
  }
  var ext = util.getFileExtension(url);
  var base = url.substring(0, url.lastIndexOf('/'));
  context.commit('CURRENT_ITEM_CONTENT', { text: '<div class="spin-box"><div class="single10"></div></div>' });
  if (ext === 'md') {
    _axios2.default.get(url).then(function (response) {
      var html = md.render(response.data);
      html = '@language md\n<div class="md">' + html + '</div>';
      html = util.replaceRelUrls(html, base);

      var newItem = {
        id: id,
        t: html
      };
      context.commit('CONTENT_ITEM_UPDATE');
      context.commit('CONTENT_ITEM', { item: newItem });
    }).catch(function (error) {
      console.log('Unable to get MD file for processing!', error);
    });
    return;
  }
  var iframeHTML = '\n    <div class="vinline">\n    <iframe\n       src="' + url + '" height="100%" width="100%"\n       marginwidth="0" marginheight="0"\n       hspace="0" vspace="0"\n       frameBorder="0" />\n    </div>\n  ';
  var newItem = {
    id: id,
    t: iframeHTML
  };

  context.commit('CONTENT_ITEM', { item: newItem });
  context.commit('CONTENT_ITEM_UPDATE');
}

function extractCover(ldata) {
  var cover = '';
  if (ldata.data[0].name.indexOf('@cover') > -1) {
    cover = ldata.textItems[ldata.data[0].t];
    ldata.data.shift();
  }

  return cover.replace('@language html', '');
}

function setData(context, ldata, filename, route) {
  context.commit('RESET');
  context.commit('INIT_DATA');
  var cover = extractCover(ldata);
  var text = ldata.textItems;
  context.commit('LEO', {
    data: ldata.data,
    text: text,
    filename: filename,
    cover: cover
  });
  loadDataSets(context, ldata);
  loadDataTables(context, ldata);
  if (_lodash2.default.isArray(ldata.data)) {
    ldata.data.forEach(function (d) {
      loadPresentations(d);
    });
  } else {
    loadPresentations(ldata.data);
  }
  setLanguageNodes(context, ldata);
  setChildDirectives(context, ldata);
  if (_lodash2.default.isArray(ldata.data)) {
    ldata.data.forEach(function (d) {
      loadPages(d, text);
    });
  } else {
    loadPages(ldata.data, text);
  }
  getTagList(context, ldata);
  cleanText(text);
  var parentTable = {};
  buildParentTable(ldata.data, text, parentTable);
  context.commit('PARENTTABLE', { parentTable: parentTable });

  var id = route.params.id;

  var pathObj = translatePath(id, ldata.data);
  id = pathObj.npath;
  if (!id) {
    id = '1';
  }

  var match = route.path.match(/\/(\w)\//);
  var pathType = 't';
  if (match) {
    pathType = match[0];
  }
  pathType = pathType.replace(/\//g, '');
  context.commit('VIEW_TYPE', { type: pathType });
  var path = route.path;

  var npath = null;
  if (path) {
    npath = path.substring(path.indexOf('/', 2) + 1);
  }
  var subtrees = [];
  var subpath = '';
  if (npath) {
    var _translatePath = translatePath(npath, ldata.data);

    npath = _translatePath.npath;
    subpath = _translatePath.subpath;

    subtrees = getRoots([], npath);
  }
  loadSubtrees(context, subtrees, ldata.data, id, subpath, npath).then(function () {
    console.log('SUBPATH', subpath);
    context.commit('SUBPATH', { subpath: subpath });
    var openItems = JSON.search(ldata.data, '//*[id="' + id + '"]/ancestor::*');
    if (!openItems) {
      return;
    }
    if (!openItems.length) {
      return;
    }
    var openItemIds = openItems.reduce(function (acc, o) {
      if (o.id) {
        acc.push(o.id + '');
      }
      return acc;
    }, []);
    openItemIds.push(id + '');
    context.commit('OPEN_ITEMS', { openItemIds: openItemIds });
    var ids = openItemIds;
    context.dispatch('setContentItems', { ids: ids });
    context.dispatch('setCurrentItem', { id: id });
  });
  loadLocalMD(context, ldata);
}

function loadLocalMD(context, ldata) {
  var titles = ldata.data;
  var textItems = ldata.textItems;
  var paths = getLocalMDPaths(titles, []);
  paths.forEach(function (path) {
    var base = path.url.substring(0, path.url.lastIndexOf('/'));
    _axios2.default.get(path.url).then(function (response) {
      var html = md.render(response.data);
      html = '@language md\n<div class="md">' + html + '</div>';
      html = util.replaceRelUrls(html, base);
      path.item.name = path.label;
      textItems[path.item.t] = html;
      indexPaths(context, paths, path);
    }).catch(function (error) {
      indexPaths(context, paths, path);
      console.log('Cache load error:', error);
    });
  });
}

function indexPaths(context, paths, path) {
  path.complete = true;
  var complete = true;
  paths.forEach(function (p) {
    if (!p.complete) {
      complete = false;
    }
  });
  if (complete) {
    console.log('local md files loaded, resetting index.');
    context.commit('RESETINDEX');
  }
}
function getLocalMDPaths(data, arr) {
  if (arr.length > 20) {
    return arr;
  }
  data.name = data.name || '';

  var _getUrlFromTitle5 = getUrlFromTitle(data.name),
      url = _getUrlFromTitle5.url,
      label = _getUrlFromTitle5.label;

  if (/\.md$/.test(url) && !/http/.test(url)) {
    var id = data.id;
    var item = data;
    arr.push({ url: url, id: id, label: label, item: item });
  }
  var children = data.children;
  if (_lodash2.default.isArray(data)) {
    children = data;
  }
  if (!children) {
    return arr;
  }
  children.forEach(function (d) {
    getLocalMDPaths(d, arr);
  });
  return arr;
}

function translatePath(p, d) {
  var item = null;
  var subpath = '';
  if (/^[A-Za-z]/.test(p)) {
    var uArray = p.split('*');
    if (uArray.length > 1) {
      p = uArray[0];
      subpath = _lodash2.default.last(uArray);
    }
    var pArray = p.split('~');
    var p2 = '';
    if (pArray.length === 2) {
      p = _lodash2.default.last(pArray);
      p2 = pArray[0];
    }
    if (p2) {
      item = JSON.search(d, '//*[name="' + p + '" and boolean(ancestor::*[name="' + p2 + '"])]');
    } else {
      item = JSON.search(d, '//*[name[contains(.,"' + p + '")]]');
    }
    if (item && item[0]) {
      p = item[0].id;
    } else {
      p = '1';
    }
  }
  return { npath: p, subpath: subpath };
}

function loadPages(item, textItems) {
  var p = /^@page /.test(item.name);
  if (p) {
    console.log('loading paged/inline items', item.name);
    loadPage(item, textItems);
  }
  item.children.forEach(function (d) {
    return loadPages(d, textItems);
  });
}
function loadPage(item, textItems) {
  var id = item.id;
  var t = item.t;
  var pages = item.children;
  item.page = { pid: id, id: id, index: 0 };
  if (!pages) {
    return;
  }

  var title = '<h1  id="x' + id + '-' + id + '" class="x-section">' + item.vtitle + '</h1>';
  var content = util.formatText(textItems[t], true, title);
  var arr = [];
  pages.forEach(function (page, index) {
    var title = '<h2 id="x' + id + '-' + page.id + '" class="x-section">' + page.name + '</h2>\n';
    arr.push(util.formatText(textItems[page.t], true, title));
    page.page = { pid: id, id: page.id, index: index + 1 };
  });

  content = content + arr.join('');
  textItems[t] = content;
}

function loadPresentations(data, loadSections) {
  var p = /@presentation ([a-zA-Z0-9]*)(.*)$/.test(data.name);
  if (p) {
    loadSections = true;
  }
  var a = /^« /.test(data.name);
  if (p || a && loadSections) {
    console.log('loading', data.name);
    loadPresentation(data.id, data.children);
  }
  data.children.forEach(function (d) {
    return loadPresentations(d, loadSections);
  });
}
function loadPresentation(id, pages) {
  if (!pages) {
    return;
  }
  pages.forEach(function (page, index) {
    page.presentation = { pid: id, index: index };
  });
}

function loadSubtrees(context, trees, data, topId, subpath) {
  if (!trees.length) {
    return _promise2.default.resolve();
  }
  var item = JSON.search(data, '//*[id="' + trees[0] + '"]')[0];

  var _getUrlFromTitle6 = getUrlFromTitle(item.name),
      url = _getUrlFromTitle6.url,
      label = _getUrlFromTitle6.label;

  if (url.match(/\.json$/)) {
    var itemText = context.state.leotext[item.t].replace(/^@.*?\n/, '');
    var params = _jsYaml2.default.load(itemText) || {};
    var template = params.template || '';
    if (params.params) {
      params = params.params;
    }

    item.name = '@dataSet set' + item.id + ' ' + label;
    return showFormattedData(context, item.id, url, template, 'json', params, item.t, topId);
  }
  context.commit('CURRENT_ITEM_CONTENT', { text: '<div class="spin-box"><div class="single10"></div></div>' });

  if (/^@outline/.test(item.name)) {
    return showPageOutline(context, item, topId, subpath);
  }
  var p = new _promise2.default(function (resolve, reject) {
    loadLeoNode(context, item).then(function (res) {
      resolve(res);

      console.log('ITEM', topId, item);
    });
  });
  return p;
}
function extractTags(textItems, textIndex) {
  var text = textItems[textIndex];
  var tags = [];
  var startIndex = text.indexOf('@t\n');
  if (startIndex < 1) {
    return tags;
  }
  var endIndex = text.indexOf('\n\n', startIndex);
  var mText = null;
  if (endIndex === -1) {
    mText = text.substring(startIndex + 3);
  } else {
    mText = text.substring(startIndex + 3, endIndex);
  }
  tags = mText.split('\n');

  return tags;
}
function extractMetaData(textItems, textIndex) {
  var text = textItems[textIndex];
  var metadata = {};
  var startIndex = text.indexOf('@m\n');
  if (startIndex < 0) {
    return null;
  }
  var endIndex = (text + '\n\n').indexOf('\n\n', startIndex);
  var mText = text.substring(startIndex + 3, endIndex);
  var cText = text.substring(0, startIndex) + text.substring(endIndex);
  textItems[textIndex] = cText;
  try {
    if (mText.indexOf('}') === -1) {
      metadata = _jsYaml2.default.load(mText) || {};
    } else {
      metadata = JSON.parse(mText);
    }
  } catch (e) {
    console.log('Bad metadata:', mText, startIndex, endIndex, e);
  }

  return metadata;
}

function getTagList(context, data) {
  var tags = {};
  data.data.forEach(function (d) {
    pushTags(d, tags);
  });
  context.commit('SETTAGLIST', { tags: tags });
}
function pushTags(d, tags) {
  d.tags && d.tags.forEach(function (tag) {
    tags[tag.text] = 1;
  });
  d.children.forEach(function (child) {
    return pushTags(child, tags);
  });
}

function cleanText(textItems) {
  var keys = (0, _keys2.default)(textItems);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    textItems[key] = removeMetadata(textItems[key]);
  }
}
function buildParentTable(item, textItems, table) {
  _lodash2.default.isArray(item) ? item.forEach(function (i) {
    return buildParentTable(i, textItems, table);
  }) : item.children.forEach(function (child) {
    return buildParentTable(child, textItems, table);
  });
  var t = item.t;
  if (table[t]) {}
  table[t] = table[t] ? table[t].push(item.id) && table[t] : [item.id];
}
function removeMetadata(text) {
  var lines = text.split(/\n/);
  var cleanLines = [];
  var flag = true;
  var commentFlag = false;
  for (var i = 0; i < lines.length; i++) {
    var line = lines[i];
    if (/^```/.test(line)) {
      commentFlag = !commentFlag;
    }
    if (/^@[tm]/.test(line)) {
      flag = false;
    }
    if (!flag && !line) {
      flag = true;
    }
    if (flag || commentFlag) {
      cleanLines.push(line);
    }
  }
  return cleanLines.join('\n');
}

function setChildDirectives(context, data) {
  var textItems = data.textItems;
  data.data.forEach(function (d) {
    setChildDirective(context, d, textItems);
  });
}
function setChildDirective(context, d, textItems, parentDirective) {
  d.metadata = extractMetaData(textItems, d.t);
  d.tags = extractTags(textItems, d.t).map(function (t) {
    return { 'text': t };
  });
  var text = textItems[d.t];

  var title = d.name;
  var rex = /@group-(.*?) /;
  var match = rex.exec(title);
  if (match && match[1]) {
    d.group = match[1];
  }
  rex = /@mgroup-(.*?) /;
  match = rex.exec(title);
  if (match && match[1]) {
    d.mgroup = match[1];
  }

  var re = /^(@language \w+)/;
  var languageDirective = re.exec(text);
  if (languageDirective) {
    languageDirective = languageDirective[1];
  }
  if (parentDirective && !languageDirective) {
    if (/^{/.test(textItems[d.t])) {
      return;
    }
    textItems[d.t] = parentDirective + '\n' + textItems[d.t];
    languageDirective = parentDirective;
  }
  d.children.forEach(function (child) {
    setChildDirective(context, child, textItems, languageDirective);
  });
}

function setLanguageNodes(context, data) {
  var textItems = data.textItems;
  data.data.forEach(function (d) {
    setLanguageNode(context, d, textItems);
  });
}
function setLanguageNode(context, d, textItems) {
  var title = d.name;
  var language = '';
  if (/^\s*@clean/.test(title)) {
    var re = /(?:\.([^.]+))?$/;
    var ext = re.exec(title)[1];
    var ng = ['txt', 'md', 'html'];
    if (ng.indexOf(ext) === -1) {
      language = ext;
    }
    var langs = {
      js: 'javascript',
      ts: 'typescript',
      py: 'python',
      java: 'java',
      c: 'c'
    };
    if (langs[ext]) {
      language = langs[ext];
    }
  }
  if (language) {
    return addDirectiveToSubTree(d, '@language ' + language, textItems);
  }
  d.children.forEach(function (child) {
    setLanguageNode(context, child, textItems);
  });
}

function addDirectiveToSubTree(subtree, directive, textItems) {
  var text = textItems[subtree.t];
  if (!/^@/.test(text)) {
    textItems[subtree.t] = directive + '\n' + text;
  }
  subtree.children.forEach(function (child) {
    addDirectiveToSubTree(child, directive, textItems);
  });
}

function loadDataSets(context, data) {
  var textItems = data.textItems;
  data.data.forEach(function (d) {
    loadDataSet(context, d, textItems);
  });
  window.lconfig.dataSets = context.state.dataSets;
}
function loadDataSet(context, item, textItems) {
  var text = textItems[item.t];
  var matches = item.name.match(/@dataSet ([a-zA-Z0-9-]*)(.*)$/);
  if (matches) {
    var k = _lodash2.default.trim(matches[1]);
    var v = text.replace(/^@language (\w+)/, '');
    try {
      v = JSON.parse(v);
    } catch (e) {
      console.log('Unable to parse data for: ' + item.name + ' ' + e);
    }
    context.commit('ADDDATASET', { k: k, v: v });
  }
  item.children.forEach(function (child) {
    loadDataSet(context, child, textItems);
  });
}

function loadDataTables(context, data) {
  var textItems = data.textItems;
  data.data.forEach(function (d) {
    loadDataTable(context, d, textItems);
  });
  window.lconfig.dataTables = context.state.dataTables;
}
function loadDataTable(context, item, textItems) {
  var text = textItems[item.t];
  var matches = item.name.match(/@dataTable ([a-zA-Z0-9]*)(.*)$/i);
  if (matches) {
    var k = _lodash2.default.trim(matches[1]);
    var title = matches[2] || '';
    var v = text.replace(/^@language (\w+)/, '');
    var arr = null;
    try {
      arr = _papaparse2.default.parse(v).data;
    } catch (e) {
      arr = [];
      console.log('Unable to parse dataTable for: ' + item.name + ' ' + e);
    }
    arr.forEach(function (r) {
      r.forEach(function (c, i) {
        r[i] = _lodash2.default.trim(c);
      });
    });
    var objArr = [];
    var cols = arr[0];
    for (var r = 1; r < arr.length; r++) {
      var row = arr[r];
      var rowObj = {};
      for (var c = 0; c < row.length; c++) {
        var colName = cols[c];
        if (colName.indexOf('$') === -1) {
          rowObj[colName] = row[c];
        }
      }

      objArr.push(rowObj);
    }
    v = { title: title, arr: arr, objArr: objArr };
    context.commit('ADDDATATABLE', { k: k, v: v });
    textItems[item.t] = '<div class="hcode"><pre>' + text + '</pre></div>';
  }
  item.children.forEach(function (child) {
    loadDataTable(context, child, textItems);
  });
}

exports.default = new _vuex2.default.Store({
  state: {
    leotext: {},
    leodata: {},
    parentTable: {},
    filename: '',
    initialized: false,
    initializedData: false,
    contentPane: 'text',
    viewType: 't',
    cover: '',
    currentItem: {
      id: 0,
      next: 0,
      prev: 0,
      type: 'item'
    },
    currentItemContent: '',
    contentItems: {},
    currentPage: {
      id: 0
    },
    dataSets: {},
    dataTables: {},
    openItemIds: [],
    history: [0],
    historyIndex: 0,
    iframeHTML: '',
    contentItemsUpdateCount: 0,
    idx: null,
    accordion: false,
    accordionPrev: false,
    searchFlag: false,
    selecting: false,
    subpath: ''
  },
  mutations: {
    ADDDATASET: function ADDDATASET(state, o) {
      state.dataSets[o.k] = o.v;
    },
    ADDDATATABLE: function ADDDATATABLE(state, o) {
      if (state.dataTables[o.k]) {
        return;
      }
      state.dataTables[o.k] = o.v;
    },
    TOGGLEACCORDION: function TOGGLEACCORDION(state) {
      state.accordion = !state.accordion;
    },
    SETSEARCHFLAG: function SETSEARCHFLAG(state) {
      state.searchFlag = true;
    },
    SELECTINGON: function SELECTINGON(state) {
      if (!state.searchFlag) {
        state.accordionPrev = state.accordion;
      }
      state.accordion = true;
    },
    SELECTINGOFF: function SELECTINGOFF(state) {
      state.searchFlag = false;
      state.accordion = state.accordionPrev;
    },
    LEO: function LEO(state, o) {
      state.leodata = o.data;
      state.leotext = o.text;
      var c = loadIndex(o.data, o.text);
      state.idx = c.idx;
      state.idxDocs = c.docs;
      state.cover = o.cover;
      state.filename = o.filename;
      window.lconfig.leodata = o.data;
      window.lconfig.leotext = o.text;
    },
    RESETCOVER: function RESETCOVER(state, o) {
      state.cover = o.cover;
    },
    RESETINDEX: function RESETINDEX(state, o) {
      var c = loadIndex(state.leodata, state.leotext);
      state.idx = c.idx;
      state.idxDocs = c.docs;
    },
    ADDTEXT: function ADDTEXT(state, o) {
      var text = o.text;
      for (var k in text) {
        state.leotext[k] = text[k];
      }
    },
    SETTAGLIST: function SETTAGLIST(state, o) {
      state.tags = (0, _keys2.default)(o.tags);
    },
    INIT: function INIT(state) {
      state.initialized = true;
    },
    INIT_DATA: function INIT_DATA(state) {
      state.initializedData = true;
    },
    RESET: function RESET(state) {
      state.initialized = false;
    },
    CONTENT_PANE: function CONTENT_PANE(state, o) {
      state.contentPane = o.type;
    },
    IFRAME_HTML: function IFRAME_HTML(state, o) {
      state.iframeHTML = o.iframeHTML;
    },
    VIEW_TYPE: function VIEW_TYPE(state, o) {
      state.viewType = o.type;
    },
    CURRENT_ITEM_CONTENT: function CURRENT_ITEM_CONTENT(state, o) {
      state.currentItemContent = o.text;
    },
    CURRENT_PAGE: function CURRENT_PAGE(state, o) {
      var id = o.id;
      state.currentPage.id = id;
      if (+id === 0) {
        return;
      }
      var routeName = state.route.name;
      if (routeName === 'Top') {
        routeName = 'Node';
      }
      _router2.default.replace({ name: routeName, params: { id: id } });
    },
    CONTENT_ITEM: function CONTENT_ITEM(state, o) {
      var item = o.item;
      state.contentItems[item.id] = item.t;
    },
    CONTENT_ITEM_UPDATE: function CONTENT_ITEM_UPDATE(state, o) {
      state.contentItemsUpdateCount = state.contentItemsUpdateCount + 1;
    },
    CURRENT_ITEM: function CURRENT_ITEM(state, o) {
      var id = o.id;

      if (o.id === state.currentItem.id) {
        return;
      }

      var nextSibling = JSON.search(state.leodata, '//children[id="' + id + '"]/following-sibling::*');
      var prevSibling = JSON.search(state.leodata, '//children[id="' + id + '"]/preceding-sibling::children');
      var next = 0;
      var prev = 0;
      if (nextSibling[0]) {
        next = nextSibling[0].id;
      }
      if (prevSibling[0]) {
        prev = prevSibling[prevSibling.length - 1].id;
      }
      if (id - prev !== 1) {
        prev = 0;
      }
      if (next - id !== 1) {
        next = 0;
      }
      state.currentItem.id = id;
      state.currentItem.prev = prev;
      state.currentItem.next = next;
      var routeName = state.route.name;
      if (routeName === 'Top') {
        routeName = 'Node';
      }
      _router2.default.replace({ name: routeName, params: { id: id } });

      if (typeof o.historyIndex !== 'undefined') {
        state.historyIndex = o.historyIndex;
      } else {
        state.history.push(id);
        state.historyIndex = state.historyIndex + 1;
      }
      state.initialized = false;
    },
    OPEN_ITEMS: function OPEN_ITEMS(state, o) {
      var ids = state.openItemIds;
      ids.splice(0, ids.length);
      ids.push.apply(ids, (0, _toConsumableArray3.default)(o.openItemIds));
    },
    SUBPATH: function SUBPATH(state, o) {
      state.subpath = o.subpath;
    },
    PARENTTABLE: function PARENTTABLE(state, o) {
      state.parentTable = o.parentTable;
    }
  },
  actions: {
    setMessages: function setMessages(context) {
      window.addEventListener('message', function (event) {
        if (!event.data) {
          return;
        }
        if (!(0, _keys2.default)(event.data).length) {
          return;
        }
        var data = {};
        if (_lodash2.default.isObject(event.data)) {
          data = event.data;
        } else {
          try {
            data = JSON.parse(event.data);
          } catch (e) {
            console.log('msg:', event.data);
          }
        }

        if (data.namespace === 'leovue' && data.eventName === 'setcurrentsection') {
          var id = data.state.indexh;
          context.dispatch('setCurrentPageSection', { id: id });
        }

        if (data.namespace === 'leovue' && data.eventName === 'setcurrentitem') {
          var _id = data.state.id;
          context.dispatch('setCurrentItem', { id: _id });
        }

        if (data.namespace === 'reveal' && data.eventName === 'slidechanged') {
          var _id2 = data.state.indexh;
          context.dispatch('setCurrentPage', { id: _id2 });
        }
      });
    },
    loadLeo: function loadLeo(context, o) {
      (0, _leo.getLeoJSON)(o.filename, o.id).then(function (ldata) {
        setData(context, ldata, o.filename, o.route);
      });
    },
    loadLeoFromXML: function loadLeoFromXML(context, o) {
      (0, _leo.transformLeoXML)(o.xml).then(function (ldata) {
        setData(context, ldata, 'dnd', o.route);
      });
    },
    setContentItems: function setContentItems(context, o) {
      var ids = o.ids;
      ids.forEach(function (id) {
        var item = JSON.search(context.state.leodata, '//children[id="' + id + '"]');
        if (item && item[0]) {
          item = item[0];

          if (/^\[/.test(item.name)) {
            setSiteItem(context, item.name, item.id);
          } else {
            var text = context.state.leotext[item.t];
            text = util.formatText(text);
            var newItem = {
              t: text,
              id: id
            };
            context.commit('CONTENT_ITEM', { item: newItem });
            context.commit('CONTENT_ITEM_UPDATE');
          }
        }
      });
    },
    changeCurrentItem: function changeCurrentItem(context, o) {
      var id = context.state.currentItem.id;
      var currentItem = JSON.search(context.state.leodata, '//*[id="' + id + '"]')[0];
      if (!currentItem) {
        console.log('No current item!');
        return;
      }
      switch (o.direction) {
        case 'down':
          if (currentItem.children && currentItem.children.length) {
            id = currentItem.children[0].id;
            return context.dispatch('setCurrentItem', { id: id });
          }
          var nextSibling = JSON.search(context.state.leodata, '//children[id="' + id + '"]/following-sibling::*');
          if (!goToAdjacentItem(context, nextSibling)) {
            var parent = JSON.search(context.state.leodata, '//*[id="' + id + '"]/parent::*');
            if (parent && parent[0] && parent[0].id) {
              var parentSibling = JSON.search(context.state.leodata, '//children[id="' + parent[0].id + '"]/following-sibling::*');
              goToAdjacentItem(context, parentSibling);
            }
          }
          break;
        case 'up':
          var prevSibling = JSON.search(context.state.leodata, '//children[id="' + id + '"]/preceding-sibling::children');
          if (!prevSibling || !prevSibling.length) {
            var _parent = JSON.search(context.state.leodata, '//*[id="' + id + '"]/parent::*');
            if (_parent && _parent[0]) {
              id = _parent[0].id;
              context.dispatch('setCurrentItem', { id: id });
            }
            console.log('PARENT', _parent);
          }
          if (prevSibling && prevSibling.length) {
            id = prevSibling[prevSibling.length - 1].id;
            console.log('new id', id);
            context.dispatch('setCurrentItem', { id: id });
          }
          break;
        default:
      }
    },
    setCurrentPageSection: function setCurrentPageSection(context, o) {
      var id = o.id;
      context.commit('CURRENT_PAGE', { id: id });
    },
    setCurrentPage: function setCurrentPage(context, o) {
      var page = +o.id;
      var id = context.state.currentItem.id;

      var presentationNode = JSON.search(context.state.leodata, '//*[id="' + id + '"]')[0];
      var pageNode = presentationNode.children[page];
      if (!pageNode) {
        id = 0;
      } else {
        id = pageNode.id;
      }
      context.commit('CURRENT_PAGE', { id: id });
    },
    setCurrentItem: function setCurrentItem(context, o) {
      var id = o.id;
      if (o.id === context.state.currentItem.id && !o.reset) {
        return;
      }

      if (window.parent !== window.self) {
        return;
      }

      var openItems = JSON.search(context.state.leodata, '//*[id="' + id + '"]/ancestor::*');
      var openItemIds = openItems.reduce(function (acc, o) {
        if (o.id) {
          acc.push(o.id + '');
        }
        return acc;
      }, []);
      openItemIds.push(id + '');
      if (context.state.accordion) {
        context.commit('OPEN_ITEMS', { openItemIds: openItemIds });
        var ids = openItemIds;
        context.dispatch('setContentItems', { ids: ids });
      } else {
        var currentOpenItemIds = context.state.openItemIds;
        openItemIds = _lodash2.default.uniq(currentOpenItemIds.concat(openItemIds));
        context.commit('OPEN_ITEMS', { openItemIds: openItemIds });
      }
      var item = JSON.search(context.state.leodata, '//*[id="' + id + '"]');
      var itemObj = { id: id };
      if (o.historyIndex) {
        itemObj = { id: id, historyIndex: o.historyIndex };
      }
      context.commit('CURRENT_ITEM', itemObj);

      if (_lodash2.default.get(item, '[0].presentation')) {
        context.commit('CURRENT_PAGE', { id: 0 });
      }
      if (_lodash2.default.get(item, '[0].page')) {
        context.commit('CURRENT_PAGE', { id: 0 });
      }
      if (item) {
        item = item[0];
        if (!item) {
          console.log('No item[0] for item:', item);
          return;
        }
        util.sendGTag(item);
        var itemText = context.state.leotext[item.t];
        if (/^@presentation /.test(item.name)) {
          return showPresentation(context, item.name, id);
        }
        if (/^@kanban /.test(item.name)) {
          return showKanban(context, item.name, id);
        }
        if (/^@mermaid/.test(item.name)) {
          return showMermaid(context, item.name, id);
        }

        if (/^@dataSet/.test(item.name)) {
          itemText = itemText.replace(/^@.*?\n/, '');
          var itemData = JSON.parse(itemText);
          var template = _lodash2.default.get(itemData, 'params.template', '');
          if (template) {
            var html = _lodashTemplate2.default.render(itemData, template);
            return showText(context, html, id, null, _lodash2.default.get(itemData, 'params', {}));
          }
        }
        if (/^@rss/.test(item.name)) {
          var _getUrlFromTitle7 = getUrlFromTitle(item.name),
              url = _getUrlFromTitle7.url,
              label = _getUrlFromTitle7.label;

          if (!url) {
            return;
          }
          return showFormattedData(context, id, url, 'rss', 'xml');
        }
        if (/^@from/.test(item.name)) {
          var params = _jsYaml2.default.load(itemText) || {};
          var rex = /@from-(.*?) /;
          var match = rex.exec(item.name);
          var group = null;
          if (match && match[1]) {
            group = match[1];
          } else {
            return;
          }
          item.name = item.name.replace(rex, '');
          var groupItem = JSON.search(context.state.leodata, '//*[group="' + group + '"]')[0];
          var children = groupItem.children;
          var items = [];
          children.forEach(function (child) {
            var t = context.state.leotext[child.t];
            var textData = {};
            try {
              textData = JSON.parse(t);
            } catch (e) {}
            items.push(textData);
          });
          var nodeList = params.nodeList;
          items = JSON.search(items, '//' + nodeList.listKey);

          var itemHash = {};
          items.forEach(function (item) {
            var k = item[nodeList.titleKey];
            itemHash[k] = item;
          });

          items = [];
          (0, _keys2.default)(itemHash).sort().forEach(function (key) {
            items.push(itemHash[key]);
          });
          addChildNodes(context.state, id, items, nodeList.template, nodeList.hrefIsQueryString, nodeList.hrefKey, nodeList.template, nodeList.titleKey);
        }
        if (/^@(xml|json)/.test(item.name)) {
          var re = /^@(xml|json)(-.*?)?\s/;
          var _match = re.exec(item.name);
          var dataType = _match[1];
          var dataSubType = _match[2];

          var _getUrlFromTitle8 = getUrlFromTitle(item.name, dataSubType),
              _url = _getUrlFromTitle8.url,
              _label = _getUrlFromTitle8.label;

          item.name = '@dataSet set' + id + ' ' + _label;
          if (!_url) {
            return;
          }
          itemText = itemText.replace(/^@.*?\n/, '');
          var _params = _jsYaml2.default.load(itemText) || {};
          var _template = _params.template || '';
          if (_params.params) {
            _params = _params.params;
          }
          if (dataSubType) {
            dataSubType = dataSubType.replace('-', '');
            _template = dataSubType;
            _params.template = _template;
          }
          return showFormattedData(context, id, _url, _template, dataType, _params, item.t);
        }
        if (/^@sort/.test(item.name)) {
          var sortDirection = 'asc';
          var _re = /^@sort-(.*?\s)/;
          var _match2 = _re.exec(item.name);
          var sortType = '';
          if (_match2 && _match2[1]) {
            sortType = _match2[1];
            console.log('sort type', sortType);
          }
          var _children = item.children;

          if (sortType) {
            sortDirection = 'desc';
            sortType = sortType.trim();
            _children.forEach(function (child) {
              var childText = context.state.leotext[child.t];
              childText = childText.replace(/^@.*?\n/, '');
              var params = _jsYaml2.default.load(childText);
              child.sname = _lodash2.default.get(params, sortType, '');
            });
          } else {
            _children.forEach(function (c) {
              return c.sname = c.name.replace(/^\d+_/g, '').toLowerCase().replace(/^(a_|the_|an_)/i, '');
            });
          }
          item.children = _lodash2.default.orderBy(_children, function (o) {
            return o.sname;
          }, sortDirection);
        }
        if (/^@book/.test(item.name)) {
          var _getUrlFromTitle9 = getUrlFromTitle(item.name),
              _url2 = _getUrlFromTitle9.url,
              _label2 = _getUrlFromTitle9.label;

          _url2 = _url2.replace('static/', '');
          if (!_url2) {
            return;
          }
          itemText = itemText.replace(/^@.*?\n/, '');
          var _params2 = _jsYaml2.default.load(itemText);
          if (_lodash2.default.isUndefined(_params2)) {
            _params2 = {};
          }
          return showBook(context, item, _url2, _params2);
        }

        if (/^@outline/.test(item.name)) {
          var mySubpath = context.state.subpath;
          context.commit('SUBPATH', { subpath: '' });
          return showPageOutline(context, item, id, mySubpath).then(function (res) {
            return context.commit('RESETINDEX');
          });
        }
        if (/^@d3board /.test(item.name)) {
          return showD3Board(context, item.name, id);
        }
        if (/^« /.test(item.name) && _lodash2.default.has(item.children[0], 'presentation')) {
          return showPresentation(context, item.name, id);
        }

        if (/^\[/.test(item.name)) {
          if (/\.leo\)$/.test(item.name)) {
            console.log('load leo');
            loadLeoNode(context, item, true).then(function (res) {
              return context.commit('RESETINDEX');
            });
          } else {
            console.log('load site');
            showSite(context, item.name, id);
            setSiteItem(context, item.name, id);
          }
        } else {
          var _params3 = {};
          if (/^@board/.test(item.name)) {
            _params3.displayType = 'board';
          }
          showText(context, context.state.leotext[item.t], id, null, _params3);
        }
        if (item.page) {
          var page = item.page;
          context.dispatch('setCurrentItem', { id: page.pid });
          context.dispatch('setCurrentPageSection', { id: page.id });

          var ff = function ff() {
            var sectionId = 'x' + page.pid + '-' + page.id;
            var sectionEl = document.getElementById(sectionId);
            var container = document.getElementById('content-inner-containerb');
            (0, _velocityAnimate2.default)(sectionEl, 'scroll', { container: container });
          };
          setTimeout(ff, 500);
          return;
        }

        if (item.presentation) {
          context.commit('CURRENT_ITEM', { id: item.presentation.pid });
          context.commit('CURRENT_PAGE', { id: id });
          return showPresentation(context, item.name, id);
        }
        context.commit('CURRENT_PAGE', { id: 0 });
      }
    }
  }
});

/***/ }),

/***/ 1240:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transform = exports.transformLeoXML2XML = exports.transformLeoXML = exports.getLeoJSON = undefined;

var _promise = __webpack_require__(66);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(354);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var util = __webpack_require__(31);

var xslTemplate = '\n<xsl:stylesheet version="1.0" xmlns:xsl="http://www.w3.org/1999/XSL/Transform">\n\n  <xsl:template match="/">\n    <xsl:apply-templates/>\n  </xsl:template>\n\n  <xsl:template match="v">\n    <xsl:variable name="t" select="@t"/>\n    <xsl:variable name="nodeSet" select="//v[@t=$t]"/>\n    <xsl:variable name="double_quote">"</xsl:variable>\n    <xsl:variable name="apos">\'</xsl:variable>\n    {\n    "id":  <xsl:value-of select="@id"/>,\n    "t":   "<xsl:value-of select="translate(@t,\'.\',\'_\')"/>",\n    "name":"<xsl:value-of select="translate($nodeSet[1]/vh,concat(\'\',$double_quote),concat(\'|\',$apos))"/>",\n    "children":[<xsl:apply-templates select="$nodeSet[1]/v"/>]\n    }\n    <xsl:if test="position()!=last()">,</xsl:if>\n  </xsl:template>\n\n  <xsl:template match="text()"/>\n\n</xsl:stylesheet>\n';
var outlineInfoTemplate = '\n\n<h2>Outline Information</h2>\n<% if (url) { %>\n<p>\nThis outline was downloaded from <strong><%- url %>/</strong>.\n</p>\n<p>\nOutline displayed via <a href="kaleguy.github.io">LeoVue</a>\n</p>\n<% } else { %>\n<p>\nNo url specified!\n</p>\n<p>\nUrl parameter format:\n</p>\n<p>?outlineUrl=https://www.mysite.com&outlineTitle=the outline\n</p>\n\n<% } %>\n';
var outlineInfoError = '\n\n#Error\n\nNo url specified!\n\nUrl parameter format:\n\nurl=www.mysite.com&name=the outline\n  \n';
function transform(xml, xslString, transformer, serializer) {
  function serverTransform(resolve, reject) {
    var xmlString = new serializer().serializeToString(xml);
    var config = {
      xslt: xslString,
      source: xmlString,
      result: String,
      props: {
        indent: 'yes'
      }
    };
    transformer.transform(config, function (err, result) {
      if (err) {
        console.log('ERROR:', err);
        return reject();
      }
      resolve(result);
    });
  }

  function clientTransform(resolve, reject) {
    var oParser = new DOMParser();
    var xsl = oParser.parseFromString(xslString, 'text/xml');
    var xsltProcessor = new XSLTProcessor();
    xsltProcessor.importStylesheet(xsl);
    var resultDocument = xsltProcessor.transformToFragment(xml, document);
    resolve(resultDocument.textContent);
  }

  var p = new _promise2.default(function (resolve, reject) {
    if (transformer) {
      return serverTransform(resolve, reject);
    } else {
      return clientTransform(resolve, reject);
    }
  });
  return p;
}

function loadDoc(filename) {
  console.log('loading file:', filename, window.lconfig, 'test');

  var p = new _promise2.default(function (resolve, reject) {
    _axios2.default.get(filename).then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      console.log(error);
      reject();
    });
  });
  return p;
}
function cleanText(data, startId) {
  data.name = data.name.replace(/<</g, '\xAB');
  data.name = data.name.replace(/>>/g, '\xBB');
  data.name = data.name.replace(/'/g, '\x27');
  data.name = data.name.replace(/"/g, '\x22');

  data.name = data.name.replace(/&#39;/g, '\x27');
  data.id = data.id + '';
  var children = data.children;
  if (!children) {
    return;
  }
  for (var i = 0; i < children.length; i++) {
    cleanText(children[i], startId);
  }
  data.t = data.t.replace(/^.*?_/, '');
  if (startId) {
    data.t = startId + '-' + data.t + '';
  }
}

function isRelative(url) {
  var ok = true;
  if (/^http/.test(url)) {
    ok = false;
  }
  return ok;
}
function getLeoJSON(filename, id) {
  if (filename.indexOf('#') > 0) {
    filename = filename.substring(0, filename.indexOf('#'));
  }
  var p = new _promise2.default(function (resolve, reject) {
    if (!filename.match(/static/) && isRelative(filename)) {}

    if (!filename.match(/\.\w\w\w\w?$/)) {
      filename = filename + '.leo';
    }

    function fromOutline() {
      var url = lconfig.outlineUrl || '';
      url = url.replace('%3A', ':');
      var name = lconfig.outlineTitle;
      if (!name) {
        name = url.replace(/^http[s]?:\/\//, '');
      }
      var compiled = _.template(outlineInfoTemplate);
      var outlineInfoHTML = compiled({ url: url });
      var data = [];
      var textItems = {
        '2': outlineInfoHTML
      };
      var nodeTitle = '@outline [' + name + '](' + url + ')';
      if (!url) {
        nodeTitle = 'Empty Outline';
      }
      var item = {
        name: nodeTitle,
        id: '1',
        children: [],
        t: ''
      };
      var infoItem = {
        name: 'Information',
        id: '2',
        children: [],
        t: '2'
      };
      data.push(item);
      data.push(infoItem);
      resolve({
        data: data,
        textItems: textItems
      });
    }
    function fromJSONFile() {
      loadDoc(filename, 'Text').then(function (data) {
        return resolve(data);
      });
    }
    function fromLeoFile() {
      loadDoc(filename, 'Text').then(function (xmlString) {
        return transformLeoXML(xmlString, id);
      }).then(function (data) {
        return resolve(data);
      });
    }

    if (filename === '~outline.leo') {
      fromOutline();
    } else if (filename.match(/\.json/i)) {
      fromJSONFile();
    } else {
      fromLeoFile();
    }
  });
  return p;
}

function transformLeoXML2XML(xmlString, startId, parser) {
  var p = new _promise2.default(function (resolve, reject) {

    var oParser = null;
    if (parser) {
      oParser = new parser();
    } else {
      oParser = new DOMParser();
    }
    var xml = oParser.parseFromString(xmlString, 'text/xml');
    var tnodes = xml.getElementsByTagName('t');
    var textItems = {};
    for (var i = 0; i < tnodes.length; i++) {
      var el = tnodes[i];
      var elText = el.textContent;
      var a = el.getAttribute('tx');
      a = a.replace(/\./g, '_');
      a = a.replace(/^.*?_/, '');
      if (startId) {
        a = startId + '-' + a;
      }
      if (/^@language /.test(elText) && !/^@language html/.test(elText) && !/^@language md/.test(elText)) {}
      textItems[a] = elText;
    }
    var vnodes = xml.getElementsByTagName('v');
    function cloneNode(xml, node) {
      var t = node.getAttribute('t');
      var cloneNodes = xml.evaluate('//v[@t="' + t + '"]', xml, null, XPathResult.ANY_TYPE, null);
      var result = cloneNodes.iterateNext();
      if (!result) {
        return;
      }
      while (result) {
        var cnode = result;
        if (cnode && cnode.getElementsByTagName('v').length) {

          var _vnodes = cnode.getElementsByTagName('v');
          for (var _i = 0; _i < _vnodes.length; _i++) {
            node.appendChild(_vnodes[_i].cloneNode());
          }
          return;
        }
        result = cloneNodes.iterateNext();
      }
    }
    function cloneNodes(xml, nodes) {
      if (!nodes) {
        return;
      }
      for (var _i2 = 0; _i2 < nodes.length; _i2++) {
        var n = nodes[_i2];
        var children = n.getElementsByTagName('vh');
        if (!children.length) {
          cloneNode(xml, n);
        }
      }
    }
    var pid = void 0;
    for (var _i3 = 0; _i3 < vnodes.length; _i3++) {
      pid = _i3 + 1;
      if (startId) {
        pid = startId + '-' + pid;
      }
      vnodes[_i3].setAttribute('id', '"' + pid + '"');
    }
    resolve({ xml: xml, textItems: textItems });
  });
  return p;
}
var counter = 0;
function setIds(startId, d, parentId) {
  d.parentId = parentId || null;

  var vtitle = _.get(d, 'name', '');

  if (/@json-rg/.test(vtitle)) {
    vtitle = vtitle.replace(/@json-rg[\w]+ \d+/, '').replace(/_/g, ' ').toLowerCase().replace(/%27/g, "'");

    vtitle = util.toTitleCase(vtitle);
  }
  vtitle = vtitle.replace(/^@[a-zA-Z-]+\sset.*?\s/, '').replace(/@[a-zA-Z-\d]+\s/g, '').replace(/<</g, '\xAB').replace(/>>/g, '\xBB');

  var re = /^\[(.*?)\]\((.*?)\)$/;
  var match = re.exec(vtitle);
  if (match) {
    vtitle = match[1];
  }
  d.vtitle = vtitle;

  d.id = counter++;
  if (_.isArray(d)) {
    return d.forEach(function (i) {
      return setIds(startId, i, d.id);
    });
  }
  if (startId) {
    d.id = startId + '-' + d.id;
  }
  d.children.forEach(function (child) {
    return setIds(startId, child, d.id);
  });
}
function transformLeoXML2JSON(data, startId, parser, transformer, serializer) {
  var p = new _promise2.default(function (resolve, reject) {
    var xml = data.xml;
    var textItems = data.textItems;
    transform(xml, xslTemplate, transformer, serializer).then(function (jsdata) {
      jsdata = jsdata.replace(/<\?xml version="1\.0" encoding="UTF-8"\?>/, '');
      jsdata = jsdata.replace(/,\s?$/, '');
      jsdata = '[' + jsdata + ']';
      jsdata = JSON.parse(jsdata);
      setIds(startId, jsdata);
      jsdata.forEach(function (d) {
        return cleanText(d, startId);
      });
      var xdata = {};
      xdata.data = jsdata;
      xdata.textItems = textItems;
      return xdata;
    }).then(function (data) {
      return resolve(data);
    });
  });
  return p;
}
function transformLeoXML(xmlString, startId, parser, transformer, serializer) {
  return transformLeoXML2XML(xmlString, startId, parser).then(function (data) {
    return transformLeoXML2JSON(data, startId, parser, transformer, serializer);
  });
}

exports.getLeoJSON = getLeoJSON;
exports.transformLeoXML = transformLeoXML;
exports.transformLeoXML2XML = transformLeoXML2XML;
exports.transform = transform;

/***/ }),

/***/ 1261:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1263:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(66);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rss = '\n<xsl:stylesheet version="1.0" \n xmlns:xsl="http://www.w3.org/1999/XSL/Transform"\n xmlns:media="http://search.yahoo.com/mrss/"\n xmlns:rdf="http://purl.org/rss/1.0/"\n> \n<xsl:output method="html"/>\n  \n  <xsl:template match="/">\n    <xsl:apply-templates select="//item | //rdf:item" />\n  </xsl:template>\n\n  <xsl:template match="results">\n  </xsl:template>\n  \n  <xsl:template match="item | rdf:item">\n    <table>\n    <tr><td valign="top">\n      <xsl:apply-templates select="media:content[@medium=\'image\']"/>\n    </td>\n    <td valign="top">\n      <a target="_blank" href="{link}"><xsl:apply-templates select="title | rdf:title"/></a>\n      <xsl:apply-templates select="description | rdf:description"/>\n    </td></tr>\n    </table>   \n  </xsl:template>\n  \n  <xsl:template match="title | rdf:title">\n     <div class="rss-title"><xsl:value-of select="."/></div>\n  </xsl:template>\n\n  <xsl:template match="description | rdf:description">\n     <div class="rss-description"><xsl:value-of select="."/></div>\n  </xsl:template>\n  \n  <xsl:template match="media:content[@medium=\'image\']">\n    <img class="rss-img" height="{@height}" width="{@width}" src="{@url}" />\n  </xsl:template>\n\n  <xsl:template match="text()|@*">\n  </xsl:template>\n\n</xsl:stylesheet>\n\n';
var weather = '\n<xsl:stylesheet version="1.0" \n xmlns:xsl="http://www.w3.org/1999/XSL/Transform"\n xmlns:media="http://search.yahoo.com/mrss/"\n xmlns:rdf="http://purl.org/rss/1.0/"\n> \n<xsl:output method="html"/>\n  <xsl:template match="//current_observation">\n    <h2><xsl:value-of select="location"/></h2>\n    <div class="weather-report">\n      <table>   \n        <tr><td class="col-label">Observation Time:</td><td><xsl:value-of select="observation_time"/></td></tr>      \n        <tr><td class="col-label">Weather:</td><td><xsl:value-of select="weather"/></td></tr>      \n        <tr><td class="col-label">Temperature:</td><td><xsl:value-of select="temperature_string"/></td></tr>      \n        <tr><td class="col-label">Humidity:</td><td><xsl:value-of select="relative_humidity"/></td></tr>      \n        <tr><td class="col-label">Wind:</td><td><xsl:value-of select="wind_string"/>, \n                   <xsl:value-of select="wind_mph"/> mph, from \n                   <xsl:value-of select="wind_dir"/>\n        </td></tr>\n      </table>\n    </div>        \n  </xsl:template>\n\n  <xsl:template match="text()|@*">\n  </xsl:template>\n\n</xsl:stylesheet>\n\n';

var styleSheets = { rss: rss, weather: weather };

function render(xml, xslType) {
  var oParser = new DOMParser();
  if (!xslType) {
    xslType = 'rss';
  }
  var xslString = styleSheets[xslType];
  if (!xslString) {
    return _promise2.default.resolve('<div>No Matching XSL</div>');
  }
  return new _promise2.default(function (resolve, reject) {
    var resultDocument = null;
    try {
      xml = oParser.parseFromString(xml, 'text/xml');
      var descriptionNodes = xml.getElementsByTagName('description');
      for (var i = 0; i < descriptionNodes.length; i++) {
        var descriptionNode = descriptionNodes[i];

        var garbageIndex = descriptionNode.innerHTML.indexOf('&lt;');
        if (garbageIndex > 0) {
          descriptionNode.innerHTML = descriptionNode.innerHTML.substring(0, garbageIndex).replace(/&amp;amp;/g, '&amp;');
        }
      }
      var xsl = oParser.parseFromString(xslString, 'text/xml');
      var xsltProcessor = new XSLTProcessor();
      xsltProcessor.importStylesheet(xsl);
      resultDocument = xsltProcessor.transformToFragment(xml, document);
    } catch (e) {
      console.log('Error in xsl transform:', e);
    }
    if (!resultDocument) {
      resolve('<div>Error</div>');
    }
    var dummy = document.createElement('section');
    dummy.setAttribute('id', 'dummy');
    dummy.style.display = 'none';
    document.body.appendChild(dummy);
    dummy.appendChild(resultDocument);
    var html = dummy.innerHTML;
    html = '@language html\n' + html;
    dummy.outerHTML = '';
    resolve(html);
  });
}

exports.default = { render: render };

/***/ }),

/***/ 1282:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentPane_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentPane_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentPane_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentPane_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentPane_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7b3fa12_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentPane_vue__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(851)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentPane_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7b3fa12_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentPane_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7b3fa12_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentPane_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SplitPane_vue__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SplitPane_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SplitPane_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SplitPane_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SplitPane_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab4c5d10_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SplitPane_vue__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(854)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ab4c5d10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SplitPane_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab4c5d10_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SplitPane_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab4c5d10_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SplitPane_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cover = __webpack_require__(557);

var _Cover2 = _interopRequireDefault(_Cover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',
  components: {
    cover: _Cover2.default
  },
  computed: {
    hasGithubRibbon: function hasGithubRibbon() {
      if (window.lconfig.githubRibbon) {
        return true;
      }
      return false;
    },
    ribbonOptions: function ribbonOptions() {
      return window.lconfig.githubRibbon;
    }
  },
  methods: {
    dragover_handler: function dragover_handler(ev) {
      ev.preventDefault();
    },
    dragend_handler: function dragend_handler(ev) {
      var dt = ev.dataTransfer;
      if (dt.items) {
        for (var i = 0; i < dt.items.length; i++) {
          dt.items.remove(i);
        }
      } else {
        ev.dataTransfer.clearData();
      }
    },
    drop_handler: function drop_handler(ev) {
      var _this = this;

      ev.preventDefault();

      var dt = ev.dataTransfer;
      var i = void 0;
      var f = void 0;
      if (dt.items) {
        for (i = 0; i < dt.items.length; i++) {
          if (dt.items[i].kind === 'file') {
            f = dt.items[i].getAsFile();
          }
        }
      } else {
        for (i = 0; i < dt.files.length; i++) {
          f = dt.files[i];
        }
      }
      var reader = new FileReader();
      reader.onload = function (xml) {
        var xmlString = xml.srcElement.result;
        _this.$store.dispatch('loadLeoFromXML', { xml: xmlString, route: _this.$route });
      };
      reader.readAsText(f);
    }
  },
  mounted: function mounted() {
    var filename = 'static/docs';
    if (window.lconfig.filename) {
      filename = window.lconfig.filename;
    }
    if (!this.$store.initializedData) {
      this.$store.dispatch('loadLeo', { filename: filename, route: this.$route });
    }
    this.$store.dispatch('setMessages');
  }
};

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'cover',
  data: function data() {
    return {};
  },

  methods: {
    setup: function setup() {
      var ribbon = document.getElementsByClassName('github-ribbon');
      if (ribbon && ribbon[0]) {
        ribbon[0].style.display = 'none';
        window.lconfig.githubRibbon = false;
      }
    }
  },
  components: {},
  computed: {
    coverContent: function coverContent() {
      return this.$store.state.cover;
    },
    dynComponent: function dynComponent() {
      var current = _lodash2.default.get(this.$router, 'currentRoute.params.id', 1);

      if (/[A-Za-z-]/.test(current)) {
        return this.$store.commit('RESETCOVER', { cover: '' });
      }

      if (+current > 2) {
        this.setup();
        return this.$store.commit('RESETCOVER', { cover: '' });
      }
      var blank = '<div></div>';
      var template = this.coverContent ? this.coverContent : blank;
      return {
        template: template
      };
    }
  },
  mounted: function mounted() {
    if (window.lconfig.coverPage) {
      var dboard = document.getElementById('dashboard');
      if (dboard) {
        this.$nextTick(function () {
          setTimeout(function () {
            dboard.style.display = 'block';
          }, 1000);
        });
      }
    }
  },
  updated: function updated() {}
};

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'appBase',
  data: function data() {
    return {
      slideContent: '',
      initialized: false,
      currentContent: null
    };
  },
  methods: {},
  mounted: function mounted() {
    if (window.lconfig.filename) {}

    if (!this.$store.initializedData) {}

    this.currentContent = this.dynComponent;
  },
  updated: function updated() {
    if (!this.initialized) {}
    this.initialized = true;
  },

  computed: {
    dynComponent: function dynComponent() {
      var content = document.getElementById('slideContent').innerHTML;
      var template = '<div class="slides">' + content + '</div>';
      return {
        template: template, mounted: function mounted() {
          Reveal.initialize({
            postMessageEvents: true,
            controls: true,
            progress: true,
            center: true,
            transition: 'slide',
            dependencies: [{ src: 'https://cdn.jsdelivr.net/npm/reveal.js@3.6.0/plugin/zoom-js/zoom.js', async: true }, { src: 'https://cdn.jsdelivr.net/npm/reveal.js@3.6.0/plugin/notes/notes.js', async: true }]
          });
        }
      };
    }
  }

};

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(77);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(564);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Dashboard = __webpack_require__(565);

var _Dashboard2 = _interopRequireDefault(_Dashboard);

var _TreeViewer = __webpack_require__(584);

var _TreeViewer2 = _interopRequireDefault(_TreeViewer);

var _D3Viewer = __webpack_require__(857);

var _D3Viewer2 = _interopRequireDefault(_D3Viewer);

var _Settings = __webpack_require__(1229);

var _Settings2 = _interopRequireDefault(_Settings);

var _AccordionViewer = __webpack_require__(1232);

var _AccordionViewer2 = _interopRequireDefault(_AccordionViewer);

var _NestedViewer = __webpack_require__(1235);

var _NestedViewer2 = _interopRequireDefault(_NestedViewer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var baseMode = window.lconfig.baseMode;
if (!baseMode) {
  baseMode = 't';
}

var startPage = '/1';
if (window.lconfig.coverPage) {
  startPage = '/2';
}

exports.default = new _vueRouter2.default({
  routes: [{
    path: '/t/:id',
    component: _Dashboard2.default,
    children: [{
      name: 'Node',
      path: '',
      component: _TreeViewer2.default
    }]
  }, {
    path: '/a/:id',
    component: _Dashboard2.default,
    children: [{
      name: 'ANode',
      path: '',
      component: _AccordionViewer2.default
    }]
  }, {
    path: '/n/:id',
    component: _Dashboard2.default,
    children: [{
      name: 'NNode',
      path: '',
      component: _NestedViewer2.default
    }]
  }, {
    path: '/d/:id',
    component: _Dashboard2.default,
    children: [{
      name: 'DNode',
      path: '',
      component: _D3Viewer2.default
    }]
  }, {
    path: '/z/:id',
    component: _Dashboard2.default,
    children: [{
      name: 'ZNode',
      path: '',
      component: _D3Viewer2.default
    }]
  }, {
    path: '/r/:id',
    component: _Dashboard2.default,
    children: [{
      name: 'RNode',
      path: '',
      component: _D3Viewer2.default
    }]
  }, {
    path: '/settings',
    component: _Settings2.default
  }, {
    path: '*',
    redirect: '/' + baseMode + startPage
  }]
});

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Header = __webpack_require__(567);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'dashboard',
  components: {
    appheader: _Header2.default
  },
  data: function data() {
    return {};
  },

  computed: {
    id: function id() {
      if (!this.$route.params.id) {
        return +1;
      } else {
        return this.$route.params.id;
      }
    },
    config: function config() {
      return window.lconfig;
    },
    dashboardStyle: function dashboardStyle() {
      var style = {};
      if (window.lconfig.coverPage) {
        style = { display: 'none' };
      }
      return style;
    }
  },
  watch: {
    '$route': function $route(to, from) {}
  }
};

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _SearchBar = __webpack_require__(570);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

var _leoFile = __webpack_require__(581);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatJSONData(data, textItems) {
  if (_lodash2.default.isArray(data)) {
    data.forEach(function (d) {
      return formatJSONData(d, textItems);
    });
  } else {
    data.text = textItems[data.t];
    data.children.forEach(function (child) {
      formatJSONData(child, textItems);
    });
  }
}

exports.default = {
  name: 'appheader',
  components: {
    searchbar: _SearchBar2.default
  },
  data: function data() {
    return {
      menu: false
    };
  },

  methods: {
    settings: function settings() {
      this.$router.replace({ path: '/settings' });
    },
    downloadJSON: function downloadJSON() {
      var data = this.$store.state.leodata;
      var item = JSON.search(data, '//*[id="' + this.$store.state.currentItem.id + '"]')[0];
      var textItems = this.$store.state.leotext;
      formatJSONData(item, textItems);
      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/json;charset=utf-8,' + encodeURI((0, _stringify2.default)(data));
      hiddenElement.target = '_blank';
      hiddenElement.download = 'leovue.json';
      hiddenElement.click();
    },
    downloadLeo: function downloadLeo() {
      var data = this.$store.state.leodata;
      var item = JSON.search(data, '//*[id="' + this.$store.state.currentItem.id + '"]')[0];
      data = (0, _leoFile.JSONtoLeo)(item, this.$store.state.leotext);
      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/xml;charset=utf-8,' + encodeURI(data);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'leovue.leo';
      hiddenElement.click();
    },
    setAccordion: function setAccordion() {
      this.$store.commit('TOGGLEACCORDION');
    },
    toggle: function toggle() {
      var menuEl = document.getElementById('menu');
      if (this.menu) {
        menuEl.style.width = 0;
        menuEl.style.borderLeft = 'none';
      } else {
        menuEl.style.width = '180px';
        menuEl.style.borderLeft = '1px solid #ccc';
      }
      this.menu = !this.menu;
    },
    setViewType: function setViewType(type) {
      this.$store.commit('VIEW_TYPE', { type: type });
      this.$store.commit('RESET');
      this.$router.replace({ path: '/' + type + '/' + this.$store.state.currentItem.id });

      setTimeout(this.toggle, 500);
    },
    goBack: function goBack() {
      if (this.noBack) {
        return;
      }
      var history = this.$store.state.history;
      var historyIndex = this.$store.state.historyIndex;
      if (historyIndex > 0) {
        historyIndex = historyIndex - 1;
      }
      var id = history[historyIndex];
      this.$store.dispatch('setCurrentItem', { id: id, historyIndex: historyIndex });
    },
    goForward: function goForward() {
      if (this.noForward) {
        return;
      }
      var history = this.$store.state.history;
      var historyIndex = this.$store.state.historyIndex;
      var id = history[historyIndex + 1];
      if (historyIndex < history.length - 1) {
        historyIndex = historyIndex + 1;
      }
      this.$store.dispatch('setCurrentItem', { id: id, historyIndex: historyIndex });
    }
  },
  computed: {
    viewType: function viewType() {
      return this.$store.state.viewType;
    },
    accordion: function accordion() {
      return this.$store.state.accordion;
    },
    viewTypes: function viewTypes() {
      var viewTypes = [{ name: 'Outline', type: 't' }, { name: 'Inline', type: 'a' }, { name: 'Graphic Tree', type: 'd' }, { name: 'Dendrogram', type: 'z' }, { name: 'Nested Menu', type: 'n' }, { name: 'Movable Panes', type: 'w' }];
      if (this.config.viewTypes) {
        return this.config.viewTypes;
      }
      return viewTypes;
    },
    noBack: function noBack() {
      return this.$store.state.historyIndex < 2;
    },
    noForward: function noForward() {
      return this.$store.state.historyIndex >= this.$store.state.history.length - 1;
    },
    config: function config() {
      return window.lconfig;
    }
  }
};

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(79);

var _keys2 = _interopRequireDefault(_keys);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

var _VueInstant = __webpack_require__(576);

var _VueInstant2 = _interopRequireDefault(_VueInstant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'searchbar',
  data: function data() {
    return {
      value: '',
      suggestionAttribute: 'title',
      suggestions: [],
      selectedEvent: ''
    };
  },

  methods: {
    clickInput: function clickInput() {
      this.selectedEvent = 'click input';
    },
    clickButton: function clickButton() {
      this.selectedEvent = 'click button';
    },
    selected: function selected() {
      this.selectedEvent = 'selection changed';
    },
    enter: function enter() {
      this.selectedEvent = 'enter';
    },
    keyUp: function keyUp() {
      this.selectedEvent = 'keyup pressed';
    },
    keyDown: function keyDown() {
      this.selectedEvent = 'keyDown pressed';
    },
    keyRight: function keyRight() {
      this.selectedEvent = 'keyRight pressed';
    },
    clear: function clear() {
      this.selectedEvent = 'clear input';
    },
    escape: function escape() {
      this.selectedEvent = 'escape';
    },
    changed: function changed() {
      this.suggestions = [];
      var that = this;
      if (this.value.length < 3) {
        return;
      }
      var state = this.$store.state;
      var terms = this.value.split(' ');
      var items = state.idx.search(this.value).filter(function (items) {
        return (0, _keys2.default)(items.matchData.metadata).length === terms.length;
      });
      items.forEach(function (item) {
        var doc = _lodash2.default.find(state.idxDocs, function (d) {
          return d.id === item.ref;
        });
        that.suggestions.push({
          title: doc.name,
          text: doc.text,
          id: doc.id
        });
      });
    }
  },
  components: {
    'vue-instant': _VueInstant2.default
  }
};

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueClickaway = __webpack_require__(578);

exports.default = {
  name: 'vueInstant',
  mixins: [_vueClickaway.mixin],
  props: {
    'value': {
      type: String,
      required: true
    },
    'suggestions': {
      type: Array,
      required: true
    },
    'suggestionAttribute': {
      type: String,
      required: true
    },
    'placeholder': {
      type: String,
      default: 'write something...'
    },
    'minMatch': {
      type: Number,
      default: 1
    },
    'name': {
      type: String,
      default: 'vueInstant'
    },
    'autofocus': {
      type: Boolean,
      default: true
    },
    'disabled': {
      type: Boolean
    },
    'type': {
      type: String,
      default: 'facebook'
    },
    'showAutocomplete': {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      selectedEvent: null,
      selectedSuggest: null,
      inputChanged: false,
      suggestionsIsVisible: true,
      highlightedIndex: 0,
      highlightedIndexMax: 7,
      similiarData: [],
      placeholderVal: this.placeholder,
      types: [{
        name: 'facebook',
        formClass: 'searchbox sbx-facebook',
        classWrapper: 'sbx-facebook__wrapper',
        classInput: 'sbx-facebook__input',
        classInputPlaceholder: 'sbx-facebook__input-placeholder',
        classSubmit: 'sbx-facebook__submit',
        svgSearch: '#sbx-icon-search-8',
        classReset: 'sbx-facebook__reset',
        svgClear: '#sbx-icon-clear-4',
        highlighClass: 'highlighted__facebook'
      }, {
        name: 'google',
        formClass: 'searchbox sbx-google',
        classWrapper: 'sbx-google__wrapper',
        classInput: 'sbx-google__input',
        classInputPlaceholder: 'sbx-google__input-placeholder',
        classSubmit: 'sbx-google__submit',
        svgSearch: '#sbx-icon-search-8',
        classReset: 'sbx-google__reset',
        svgClear: '#sbx-icon-clear-4',
        highlighClass: 'highlighted__google'
      }, {
        name: 'amazon',
        formClass: 'searchbox sbx-amazon',
        classWrapper: 'sbx-amazon__wrapper',
        classInput: 'sbx-amazon__input',
        classInputPlaceholder: 'sbx-amazon__input-placeholder',
        classSubmit: 'sbx-amazon__submit',
        svgSearch: '#sbx-icon-search-8',
        classReset: 'sbx-amazon__reset',
        svgClear: '#sbx-icon-clear-4',
        highlighClass: 'highlighted__amazon'
      }, {
        name: 'twitter',
        formClass: 'searchbox sbx-twitter',
        classWrapper: 'sbx-twitter__wrapper',
        classInput: 'sbx-twitter__input',
        classInputPlaceholder: 'sbx-twitter__input-placeholder',
        classSubmit: 'sbx-twitter__submit',
        svgSearch: '#sbx-icon-search-8',
        classReset: 'sbx-twitter__reset',
        svgClear: '#sbx-icon-clear-4',
        highlighClass: 'highlighted__twitter'
      }, {
        name: 'spotify',
        formClass: 'searchbox sbx-spotify',
        classWrapper: 'sbx-spotify__wrapper',
        classInput: 'sbx-spotify__input',
        classInputPlaceholder: 'sbx-spotify__input-placeholder',
        classSubmit: 'sbx-spotify__submit',
        svgSearch: '#sbx-icon-search-8',
        classReset: 'sbx-spotify__reset',
        svgClear: '#sbx-icon-clear-4',
        highlighClass: 'highlighted__spotify'
      }, {
        name: 'custom',
        formClass: 'searchbox sbx-custom',
        classWrapper: 'sbx-custom__wrapper',
        classInput: 'sbx-custom__input',
        classInputPlaceholder: 'sbx-custom__input-placeholder',
        classSubmit: 'sbx-custom__submit',
        svgSearch: '#sbx-icon-search-8',
        classReset: 'sbx-custom__reset',
        svgClear: '#sbx-icon-clear-4',
        highlighClass: 'highlighted__custom'
      }]
    };
  },

  watch: {
    placeholder: function placeholder(val) {
      if (this.textValIsEmpty()) {
        this.placeholderVal = val;
      }
    }
  },
  computed: {
    getPlaceholder: function getPlaceholder() {
      return '';
    },
    modeIsFull: function modeIsFull() {
      return this.showAutocomplete;
    },
    showSuggestions: function showSuggestions() {
      return this.similiarData.length >= this.minMatch;
    },
    getPropertiesClass: function getPropertiesClass() {
      var type = this.getType();
      return type.properties;
    },
    getFormClass: function getFormClass() {
      var type = this.getType();
      return type.formClass;
    },
    getClassWrapper: function getClassWrapper() {
      var type = this.getType();
      return type.classWrapper;
    },
    getClassInput: function getClassInput() {
      var type = this.getType();
      return type.classInput;
    },
    getClassInputPlaceholder: function getClassInputPlaceholder() {
      var type = this.getType();
      return type.classInputPlaceholder;
    },
    getClassSubmit: function getClassSubmit() {
      var type = this.getType();
      return type.classSubmit;
    },
    getSVGSearch: function getSVGSearch() {
      var type = this.getType();
      return type.svgSearch;
    },
    getClassReset: function getClassReset() {
      var type = this.getType();
      return type.classReset;
    },
    getSVGClear: function getSVGClear() {
      var type = this.getType();
      return type.svgClear;
    },


    textVal: {
      get: function get() {
        return this.value;
      },
      set: function set(v) {
        this.$emit('input', v);
      }
    }
  },
  methods: {
    decrementHighlightedIndex: function decrementHighlightedIndex() {
      this.highlightedIndex -= 1;
    },
    incrementHighlightedIndex: function incrementHighlightedIndex() {
      this.highlightedIndex += 1;
    },
    escapeAction: function escapeAction() {
      this.clearHighlightedIndex();
      this.clearSimilarData();
      this.clearSelected();
      this.setBlur();
      this.emitEscape();
    },
    arrowRightAction: function arrowRightAction() {
      this.setPlaceholderAndTextVal();
      this.emitKeyRight();
    },
    arrowDownAction: function arrowDownAction() {
      if (this.arrowDownValidation()) {
        this.incrementHighlightedIndex();

        this.emitKeyDown();
        var s = this.selectedSuggest;
        this.$store.dispatch('setCurrentItem', { id: s.id });
        this.$store.commit('SELECTINGON');
        this.$store.commit('SETSEARCHFLAG');
      } else {
        this.clearHighlightedIndex();
      }
    },
    arrowUpAction: function arrowUpAction() {
      if (this.highlightedIndex > 0) {
        this.decrementHighlightedIndex();

        this.emitKeyUp();
        var s = this.selectedSuggest;
        this.$store.dispatch('setCurrentItem', { id: s.id });
        this.$store.commit('SELECTINGON');
        this.$store.commit('SETSEARCHFLAG');
      } else {
        this.clearHighlightedIndex();
      }
    },
    enterAction: function enterAction() {
      this.setFinalTextValue();
      this.clearHighlightedIndex();
      this.clearSimilarData();
      this.emitEnter();
    },
    selectedAction: function selectedAction(index) {
      this.highlightedIndex = index;
      this.setFinalTextValue();
      this.clearPlaceholder();
      this.clearSimilarData();
      this.emitSelected();
      var s = this.selectedSuggest;
      this.$store.dispatch('setCurrentItem', { id: s.id });
      this.reset();
    },
    addRegister: function addRegister(o) {
      if (this.isSimilar(o) && this.textValIsNotEmpty()) {
        this.addSuggestion(o);
      }
    },
    addSuggestion: function addSuggestion(o) {
      if (!this.findSuggestionTextIsRepited(o)) {
        this.addToSimilarData(o);
      }
    },
    addToSimilarData: function addToSimilarData(o) {
      if (this.canAddToSimilarData()) {
        this.placeholderVal = this.letterProcess(o);
        this.selectedSuggest = o;
        this.emitSelected();
        this.similiarData.unshift(o);
      }
    },
    setTextValue: function setTextValue(e) {
      if (e.target.value.trim()) {
        this.textVal = e.target.value;
        this.emitChange();
      }
    },
    setSelectedAsTextValue: function setSelectedAsTextValue() {
      this.textVal = this.selected;
    },
    setInitialTextValue: function setInitialTextValue() {
      this.textVal = this.value;
    },
    setFinalTextValue: function setFinalTextValue() {
      if (this.finalTextValueValidation()) {
        this.setPlaceholderAndTextVal();
        this.emitChange();
      } else {
        this.clearAll();
      }
    },
    setPlaceholderAndTextVal: function setPlaceholderAndTextVal() {
      if (typeof this.similiarData[this.highlightedIndex] !== 'undefined') {
        var suggest = this.similiarData[this.highlightedIndex];
        this.placeholderVal = suggest[this.suggestionAttribute];
        this.textVal = suggest[this.suggestionAttribute];
        this.selectedSuggest = suggest;
        this.emitSelected();
      }
    },
    setInitialPlaceholder: function setInitialPlaceholder() {
      this.placeholderVal = this.placeholder;
    },
    setBlur: function setBlur() {
      this.$el.blur();
    },
    getType: function getType() {
      return this.types.find(this.isSameType);
    },
    getClassHighlighted: function getClassHighlighted(index) {
      if (this.highlightedIndex === index) {
        var type = this.getType();
        return type.highlighClass;
      }
    },
    letterProcess: function letterProcess(o) {
      var remoteText = o[this.suggestionAttribute].split('');
      var inputText = this.textVal.split('');
      inputText.forEach(function (letter, key) {
        if (letter !== remoteText[key]) {
          remoteText[key] = letter;
        }
      });
      return remoteText.join('');
    },
    findSuggests: function findSuggests() {
      if (this.suggestionsPropIsDefined()) {
        this.suggestions.forEach(this.addRegister);
      }
    },
    arrowDownValidation: function arrowDownValidation() {
      return this.highlightedIndex < this.highlightedIndexMax && this.highlightedIndex < this.similiarData.length - 1;
    },
    lowerFirst: function lowerFirst(string) {
      return string.charAt(0).toLowerCase() + string.slice(1);
    },
    controlEvents: function controlEvents() {
      var uncaptz = this.lowerFirst(this.selectedEvent + 'Action');
      var fnName = this[uncaptz];
      if (this.fnExists(fnName)) {
        fnName();
      }
    },
    findRepited: function findRepited(similarItem, o) {
      return similarItem[this.suggestionAttribute] === o[this.suggestionAttribute];
    },
    findSuggestionTextIsRepited: function findSuggestionTextIsRepited(o) {
      return this.similiarData.find(this.findRepited.bind(this, o));
    },
    finalTextValueValidation: function finalTextValueValidation() {
      return typeof this.similiarData[this.highlightedIndex] !== 'undefined' || this.placeholderVal === '' && this.highlightedIndex !== 0;
    },
    isSimilar: function isSimilar(o) {
      if (o) {
        return true;
      }
    },
    isSameType: function isSameType(o) {
      return o.name === this.type;
    },
    fnExists: function fnExists(fnName) {
      return typeof fnName === 'function';
    },
    canAddToSimilarData: function canAddToSimilarData() {
      return this.similiarData.length < this.highlightedIndexMax;
    },
    suggestionsPropIsDefined: function suggestionsPropIsDefined() {
      return typeof this.suggestions !== 'undefined';
    },
    notArrowKeysEvent: function notArrowKeysEvent() {
      return this.selectedEvent !== 'ArrowUp' && this.selectedEvent !== 'ArrowDown' && this.selectedEvent !== 'ArrowRight';
    },
    notEnterKeyEvent: function notEnterKeyEvent() {
      return this.selectedEvent !== 'Enter';
    },
    textValIsEmpty: function textValIsEmpty() {
      return this.textVal === '';
    },
    textValIsNotEmpty: function textValIsNotEmpty() {
      return this.textVal !== '';
    },
    reset: function reset() {
      this.clearValue();
      this.clearSelected();
      this.clearPlaceholder();
      this.clearSimilarData();
      this.clearSelectedSuggest();
      this.emitClear();
      this.emitSelected();
    },
    clearAll: function clearAll() {
      this.clearSelected();
      this.clearPlaceholder();
      this.clearSimilarData();
      this.clearSelectedSuggest();
    },
    clearValue: function clearValue() {
      this.textVal = '';
    },
    clearSelected: function clearSelected() {
      this.selected = null;
    },
    clearSelectedSuggest: function clearSelectedSuggest() {
      this.selectedSuggest = null;
    },
    clearSimilarData: function clearSimilarData() {
      this.similiarData = [];
    },
    clearPlaceholder: function clearPlaceholder() {
      if (this.textValIsEmpty()) {
        this.clearSimilarData();
        this.setInitialPlaceholder();
      } else {
        this.placeholderVal = '';
      }
    },
    clearHighlightedIndex: function clearHighlightedIndex() {
      this.highlightedIndex = 0;
    },
    changeText: function changeText(e) {
      this.selectedEvent = e.code;
      this.setTextValue(e);
      this.processChangeText();
      this.controlEvents(e);
    },
    processChangeText: function processChangeText(e) {
      if (this.notEnterKeyEvent()) {
        this.inputChanged = true;
        this.suggestionsIsVisible = true;
        this.clearAllAndFindSuggest();
      }
    },
    clearAllAndFindSuggest: function clearAllAndFindSuggest() {
      if (this.notArrowKeysEvent()) {
        this.clearAll();
        this.findSuggests();
      }
    },
    away: function away() {
      this.suggestionsIsVisible = false;
      this.emitSelected();
    },
    emitChange: function emitChange() {},
    emitClickInput: function emitClickInput(event) {
      this.$emit('click-input', event);
    },
    emitClickButton: function emitClickButton(event) {
      this.$emit('click-button', this.textVal);
    },
    emitEnter: function emitEnter() {
      var s = this.selectedSuggest;
      this.$store.dispatch('setCurrentItem', { id: s.id });
      this.$emit('enter');
      this.reset();
      this.setBlur();
      this.$store.commit('SELECTINGOFF');
    },
    emitKeyUp: function emitKeyUp() {
      this.$emit('key-up');
    },
    emitKeyDown: function emitKeyDown() {
      this.$emit('key-down', this.selectedSuggest);
    },
    emitKeyRight: function emitKeyRight() {
      this.$emit('key-right');
    },
    emitClear: function emitClear() {
      this.$emit('clear');
    },
    emitEscape: function emitEscape() {
      this.$emit('escape');
    },
    emitSelected: function emitSelected() {
      var s = this.selectedSuggest;
      if (!s) {
        return;
      }
      this.$emit('selected', s);
    }
  }
};

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Item = __webpack_require__(85);

var _Item2 = _interopRequireDefault(_Item);

var _ContentPane = __webpack_require__(150);

var _ContentPane2 = _interopRequireDefault(_ContentPane);

var _SplitPane = __webpack_require__(151);

var _SplitPane2 = _interopRequireDefault(_SplitPane);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var target = { el: true, v: null };
exports.default = {
  name: 'treeviewer',
  components: {
    item: _Item2.default,
    contentpane: _ContentPane2.default,
    splitpane: _SplitPane2.default
  },
  data: function data() {
    return {
      target: target
    };
  },
  methods: {
    getTop: function getTop(index) {
      if (!index) {
        return this.top;
      }
    }
  },
  computed: {
    ulStyle: function ulStyle() {
      var p = window.lconfig.leftPanePadding || '0';
      var c = window.lconfig.leftPaneBackground || '#fff';
      return 'padding-left:' + p + '; background-color:' + c;
    },
    leftPaneStyle: function leftPaneStyle() {
      var w = window.lconfig.leftPaneWidth || '420px';
      var c = window.lconfig.leftPaneBackground || '#fff';
      return 'width:' + w + ';background-color:' + c;
    },
    top: function top() {
      if (window.lconfig.firstNodeAsTitle === false) {
        return false;
      }
      return true;
    },
    data: function data() {
      return this.$store.state.leodata;
    },
    text: function text() {
      return this.$store.state.leotext;
    }
  }

};

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _velocityAnimate = __webpack_require__(228);

var _velocityAnimate2 = _interopRequireDefault(_velocityAnimate);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

var _util = __webpack_require__(31);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCloneMenu = function getCloneMenu(state, t, getNodePath) {
  var cloneList = state.parentTable[t] || [];
  var nodes = cloneList.map(function (id) {
    return JSON.search(state.leodata, '//*[id="' + id + '"]')[0];
  });
  var arr = [];
  nodes.forEach(function (node) {
    var nodePath = getNodePath(state.leodata, node, null);

    arr.push({ nodePath: nodePath, node: node });
  });
  var html = [];
  arr.forEach(function (chapter) {
    html.push('<div data-id="' + chapter.node.id + '" class="section-link"> ' + chapter.nodePath + ' </div>');
  });
  return html.join('');
};

exports.default = {
  name: 'item',
  props: {
    model: Object,
    targetEl: Boolean,
    textItems: Object,
    top: Boolean,
    accordion: Boolean,
    prefix: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      reset: true,
      openFlag: false,
      hasRibbon: true,
      inline: false,
      closearrow: false,
      myContent: '',
      show: false,
      cloneMenu: ''
    };
  },
  computed: {
    arrowIcon: function arrowIcon() {
      return window.lconfig.itemArrow || '▶';
    },
    isClone: function isClone() {
      return this.$store.state.parentTable[this.model.t].length > 1;
    },
    isFolder: function isFolder() {
      if (/\.leo\)$/.test(this.model.name)) {
        return true;
      }
      if (/^@outline/.test(this.model.name)) {
        return true;
      }
      return this.model.children && this.model.children.length;
    },
    isClosedSibling: function isClosedSibling() {
      if (this.isOpen) {
        return ' open';
      }
      var nextSiblings = JSON.search(this.$store.state.leodata, '//*[id="' + this.model.id + '"]/following-sibling::*');
      var prevSiblings = JSON.search(this.$store.state.leodata, '//*[id="' + this.model.id + '"]/preceding-sibling::children');
      var foo = nextSiblings.length + '_' + prevSiblings.length;
      return foo;
    },
    hasOpenSibling: function hasOpenSibling() {
      if (!this.accordion) {
        return false;
      }

      if (this.model.parent) {
        return false;
      }

      if (!this.isOpen) {
        return;
      }
      var nextSiblings = JSON.search(this.$store.state.leodata, '//*[id="' + this.model.id + '"]/following-sibling::*');
      var prevSiblings = JSON.search(this.$store.state.leodata, '//*[id="' + this.model.id + '"]/preceding-sibling::children');
      var siblings = nextSiblings.concat(prevSiblings);
      siblings = siblings.map(function (s) {
        return s.id;
      });
      var hasOpen = false;
      var ids = this.$store.state.openItemIds;
      siblings.forEach(function (sid) {
        if (ids.indexOf(sid + '') > -1) {
          hasOpen = true;
        }
      });
      hasOpen = false;

      if (this.model.parent) {
        var _siblings = this.model.parent.children;
        if (_siblings.length > 1) {
          hasOpen = true;
        }
      }
      return hasOpen;
    },

    nid: function nid() {
      return this.prefix + '_' + this.model.id;
    },
    isOpen: function isOpen() {
      var ids = this.$store.state.openItemIds;
      var open = true;
      if (ids.indexOf(this.model.id + '') === -1) {
        open = false;
      }
      return open;
    },
    isOpenInline: function isOpenInline() {
      return this.$route.name === 'ANode';
    },
    isOpenA: function isOpenA() {
      if (_lodash2.default.has(this.model, 'o')) {
        return this.closearrow;
      }
      return this.isOpen && !this.closearrow;
    },
    active: function active() {
      if (!this.model) {
        return;
      }
      if (this.$store.state.currentPage.id) {
        return this.$store.state.currentPage.id === this.model.id;
      }
      return this.$store.state.currentItem.id === this.model.id;
    },
    activeBackgroundColor: function activeBackgroundColor() {
      var bg = window.lconfig.activeBackgroundColor || '#01FF70';
      if (this.active) {
        return bg;
      }
      return '#ffffff';
    }
  },
  methods: {
    gotoClone: function gotoClone(event) {
      var id = event.target.dataset.id;
      this.hideCloneMenu();
      console.log('Going to node:', id);
      if (!id) {
        return;
      }

      this.$store.dispatch('setCurrentItem', { id: id });
    },
    hideCloneMenu: function hideCloneMenu() {
      this.$root.$emit('bv::hide::popover');
      this.show = false;
    },
    showCloneMenu: function showCloneMenu() {
      var _this = this;

      this.cloneMenu = getCloneMenu(this.$store.state, this.model.t, _util2.default.getNodePath);
      if (this.show) {
        return;
      }
      this.$root.$emit('bv::hide::popover');
      var fn = function fn() {
        _this.show = true;
      };
      setTimeout(fn, 100);
    },
    setCloneMenuActive: function setCloneMenuActive() {},
    toggle: function toggle() {
      var _this2 = this;

      if (window.lconfig.githubRibbon) {
        var ribbon = document.getElementsByClassName('github-ribbon');
        if (ribbon && ribbon[0]) {
          ribbon[0].style.display = 'none';
          window.lconfig.githubRibbon = false;
        }
      }
      var cover = document.getElementById('cover-page');
      if (cover) {
        cover.style.display = 'none';
      }

      if (this.model.vtitle) {
        this.vtitle = this.model.vtitle;
      }

      var duration = 300;
      var easing = 'linear';
      this.reset = false;

      if (this.model.parent) {
        return this.toggleN();
      }

      var openItemIds = this.$store.state.openItemIds.slice(0);
      if (!this.isOpen) {
        openItemIds.push(this.model.id);
      } else {
        openItemIds = openItemIds.filter(function (id) {
          return id !== _this2.model.id;
        });
        this.closearrow = true;
      }

      var ul = this.$el.getElementsByClassName('child-items')[0];
      if (!this.isOpen) {
        (0, _velocityAnimate2.default)(ul, 'slideDown', { duration: duration, easing: easing }).then(function (els) {
          _this2.$store.commit('OPEN_ITEMS', { openItemIds: openItemIds });
          if (_this2.accordion) {
            _this2.closeSiblings(easing, 'Up');
          }
        });
      } else {
        (0, _velocityAnimate2.default)(ul, 'slideUp', { duration: duration, easing: easing }).then(function (els) {
          _this2.$store.commit('OPEN_ITEMS', { openItemIds: openItemIds });
          _this2.closearrow = false;
          if (_this2.accordion) {
            _this2.closeSiblings(easing, 'Down');
          }
        });
      }
      var id = this.model.id;
      if (this.model.page) {
        var page = this.model.page;
        this.$store.dispatch('setCurrentItem', { id: page.pid });
        this.$store.dispatch('setCurrentPageSection', { id: page.id });
        var sectionId = 'x' + page.pid + '-' + page.id;
        var sectionEl = document.getElementById(sectionId);
        var container = document.getElementById('content-inner-containerb');
        (0, _velocityAnimate2.default)(sectionEl, 'scroll', { container: container });
        console.log('page', page);
        return;
      }
      if (this.model.presentation) {
        var presentation = this.model.presentation;
        var _id = this.model.presentation.pid;
        this.$store.dispatch('setCurrentItem', { id: _id });

        var _toPageF = function _toPageF() {
          var iframe = document.getElementsByTagName('iframe')[0];
          if (!presentation.hasOwnProperty('index')) {
            return;
          }
          if (!iframe.contentWindow) {
            console.log('NO IFRAME CONTENT WINDOW');
          }
          if (iframe.contentWindow.Reveal) {
            console.log('going to page:', presentation.index);
            iframe.contentWindow.Reveal.slide(presentation.index, 0);
          } else {
            console.log(iframe.contentWindow.document);
            console.log('no reveal');
          }
        };
        window.setTimeout(_toPageF, 1);
        return;
      }

      this.$store.dispatch('setCurrentItem', { id: id });
    },
    toggleN: function toggleN() {
      var _this3 = this;

      var duration = 300;
      var easing = 'linear';
      this.reset = false;
      var ul = this.$el.getElementsByClassName('child-items')[0];
      if (!this.model.o) {
        (0, _velocityAnimate2.default)(ul, 'slideDown', { duration: duration, easing: easing }).then(function (els) {
          _this3.model.o = !_this3.model.o;
          _this3.closearrow = _this3.model.o;
          if (_this3.accordion) {
            _this3.closeSiblingsN(easing, 'Up');
          }
        });
      } else {
        (0, _velocityAnimate2.default)(ul, 'slideUp', { duration: duration, easing: easing }).then(function (els) {
          console.log('slideup');
          _this3.model.o = !_this3.model.o;
          _this3.closearrow = _this3.model.o;
          if (_this3.accordion) {
            _this3.closeSiblingsN(easing, 'Down');
          }
        });
      }
    },

    closeSiblings: function closeSiblings(easing, direction) {
      var duration = 500;
      var nextSiblings = JSON.search(this.$store.state.leodata, '//*[id="' + this.model.id + '"]/following-sibling::*');
      var prevSiblings = JSON.search(this.$store.state.leodata, '//*[id="' + this.model.id + '"]/preceding-sibling::children');
      var siblings = nextSiblings.concat(prevSiblings);
      siblings = siblings.map(function (s) {
        return s.id;
      });

      siblings.forEach(function (sid) {
        var el = document.getElementById(sid);
        el.style.display = 'none';
        (0, _velocityAnimate2.default)(el, 'slide' + direction, { duration: duration, easing: easing }).then(function (els) {});
      });
    },
    closeSiblingsN: function closeSiblingsN(easing, direction) {
      var _this4 = this;

      var duration = 500;
      var siblings = _lodash2.default.clone(this.model.parent.children);
      siblings = siblings.map(function (s) {
        return s.id;
      });
      var id = this.model.id;
      siblings.forEach(function (sid) {
        if (sid === id) {
          return;
        }
        var nid = _this4.prefix + '' + sid;

        var el = document.getElementById(nid);
        (0, _velocityAnimate2.default)(el, 'slide' + direction, { duration: duration, easing: easing }).then(function (els) {}).catch(function (e) {
          return console.log(e);
        });
      });
    }
  },
  watch: {
    '$store.state.contentItemsUpdateCount': {
      handler: function handler(val, oldVal) {
        if (!this.isOpenInline) {
          return;
        }
        if (val > 0 && val !== oldVal) {
          var text = this.$store.state.contentItems[this.model.id];
          this.myContent = text;
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted: function mounted() {},
  updated: function updated() {}
};

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var none = '\n <div>NO TEMPLATE</div>\n';

var openbooks = '\n<% var book = data[Object.keys(data)[0]] %>\n<div class="book-listing">\n  <h2><%- book.title %></h2>\n  <h3><%- book.subtitle %></h3>\n  <div style="float:left;margin-right:6px;">\n    <% if (book.cover) { %>\n    <a target="_blank" href="<%= book.url %>"><img src="<%= book.cover.medium %>"/></a>\n    <% } %>\n  </div>\n  <div style="float:left">  \n    <table>\n      <tr>\n        <td class="col-label">Author<% if (book.authors.length > 1) { %>s<% } %>:</td>\n        <td style="width:300px">\n        <% for (var i = 0; i < book.authors.length; i++) { \n             var author = book.authors[i]\n        %>\n             <a target="_blank" href="<% author.url %>"><span style="white-space: nowrap"><%- author.name %><br></span></a>\n        <% } %>\n          </td>\n      </tr>\n      <tr><td class="col-label">Pages:</td><td><%= book.number_of_pages %></td></tr>\n      <tr><td class="col-label">Pub. Date:</td><td><%= book.publish_date %></td></tr>\n      <tr>\n        <td class="col-label">Publisher:</td>\n        <td style="width:300px">\n        <% for (var i = 0; i < book.publishers.length; i++) { \n             var publisher = book.publishers[i]\n        %>\n             <span style="white-space: nowrap"><%- publisher.name %><br></span>\n        <% } %>\n          </td>\n      </tr>    </table>\n  </div>\n  <% if (data.params.rating) { %>\n  <div style="clear:both; padding-top:10px;">\n    <star-rating :show-rating="false" :read-only="true" star-size="25" rating="<%= data.params.rating %>"></star-rating>\n  </div>\n  <% } %>\n  <div class="comments">\n  <%- data.params.comments %>\n  </div>   \n</div>\n';

var weather = '\n<h1>Weather for <%= data.params.location %></h1>\n<div>Data from <%= data.params.source %></div>\n<div class="weather-report">\n  <table>   \n    <tr><td class="col-label">Observation Time:</td><td><%= moment(data.dt * 1000).format(\'MMMM Do YYYY, h:mm a\') %></td></tr>      \n    <tr><td class="col-label">Weather:</td><td><%= data.weather[0].description %></td></tr>      \n    <tr><td class="col-label">Temperature:</td><td><%= data.main.temp %></td></tr>      \n    <tr><td class="col-label">Humidity:</td><td><%= data.main.humidity %></td></tr>      \n    <tr><td class="col-label">Wind:</td><td><%= data.wind.speed %></td></tr>\n  </table>\n</div>        \n';

var templates = { none: none, weather: weather, openbooks: openbooks };

function render(json, templateType) {
  if (!templateType) {
    templateType = 'none';
  }
  var templateString = null;

  var templateEl = document.getElementById(templateType);
  if (templateEl) {
    templateString = templateEl.innerText.replace(/{{/g, '<%').replace(/}}/g, '%>');
  }
  templateString = templateString || templates[templateType];
  if (!templateString) {
    return '<h2>No Matching Template</h2>';
  }
  var compiled = _lodash2.default.template(templateString);
  var html = '<h2 class="error-msg">Template Compilation Error</h2>';
  try {
    html = compiled({ data: json });
  } catch (e) {
    console.log('Template compilation error: ', templateType, e);
  }

  html = html.replace(/&amp;quot;/g, '&quot;');
  return html;
}

exports.default = { render: render };

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _presentation = __webpack_require__(852);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hljs = __webpack_require__(233);

var util = __webpack_require__(31);

window.getData = function (data) {
  if (data && data.query && data.query.results && data.query.results.resources && data.query.results.resources.content && data.query.results.resources.status == 200) {
    var html = data.query.results.resources.content;
    if (/https:/.test(window.url)) {
      html = html.replace(/src="http:/g, 'src="https:');
    }
    loadHTML(html);
  } else if (data && data.error && data.error.description) {
    loadHTML(data.error.description);
  } else {
    loadHTML('Error: Cannot load ' + window.url);
  }
};
window.loadHTML = function (html) {
  iframe.src = 'about:blank';
  iframe.contentWindow.document.open();

  iframe.contentWindow.document.write(html.replace(/<head>/i, '<head><base href="' + window.url + '"><scr' + 'ipt>document.addEventListener("click", function(e) { if(e.target && e.target.nodeName == "A") { e.preventDefault(); window.open(e.target.href); } });</scr' + 'ipt>'));
  iframe.contentWindow.document.close();
};
window.loadURL = function (src) {
  var url = src;
  var script = document.createElement('script');
  script.src = 'https://query.yahooapis.com/v1/public/yql?q=select%20*%20from%20data.headers%20where%20url%3D%22' + encodeURIComponent(url) + '%22&format=json&diagnostics=true&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys&callback=getData';
  document.body.appendChild(script);
};
function overrideXFrame(item, textItems) {
  var iframe = document.getElementsByTagName('iframe')[0];
  if (!iframe) {
    return;
  }
  window.iframe = iframe;
  var url = iframe.src;
  if (url === 'about:blank') {
    return loadPresentation(item, textItems, iframe);
  }
  console.log('URL', url);
  if (!/^\s?xttp/.test(url)) {
    return;
  }
  window.url = url.replace(/^s?xttp/, 'http');
  loadURL(window.url);
}


function loadPresentation(item, textItems, iframe) {
  console.log('loading presentation', item);

  var content = '';
  var re = /^@props (.*)/;
  if (!item.children.length) {
    console.log('pid', item.presentation.pid);
    return;
  }
  item.children.forEach(function (page, index) {
    var pageContent = textItems[page.t];
    var props = re.exec(pageContent);
    if (props) {
      props = props[1];
    } else {
      props = '';
    }
    content = content + '<section ' + props + '>' + util.formatText(pageContent, true) + '</section>';
  });
  var html = (0, _presentation.presentation)(item.name, content);
  iframe.contentWindow.document.open();
  iframe.contentWindow.document.write(html);
  iframe.contentWindow.document.close();
}

exports.default = {
  name: 'contentpane',
  components: {},
  data: function data() {
    return {
      xSections: [],
      handleScroll: null
    };
  },

  methods: {
    onScroll: function onScroll() {
      if (!this.xSections.length) {
        return;
      }
      this.handleScroll();
    },
    goNext: function goNext() {
      var next = this.$store.state.currentItem.next;
      this.resetCurrentItem(next);
    },
    goPrev: function goPrev() {
      var prev = this.$store.state.currentItem.prev;
      this.resetCurrentItem(prev);
    },
    resetCurrentItem: function resetCurrentItem(id) {
      this.$store.dispatch('setCurrentItem', { id: id });
    },
    dataTableClick: function dataTableClick(r) {
      debugger;
      var title = r.data.title.replace(/<[^>]*>/g, "");

      var item = JSON.search(this.$store.state.leodata, '//*[vtitle="' + title + '"]')[0];
      if (item) {
        var id = item.id;
        this.$store.dispatch('setCurrentItem', { id: id });
      }
      console.log('ROW CLICK', title, item);
    }
  },
  computed: {
    cpWidth: function cpWidth() {
      return window.lconfig.contentPaneWidth || '700px';
    },
    data: function data() {
      return this.$store.state.leodata;
    },
    text: function text() {
      return this.$store.state.leotext;
    },
    iframeContent: function iframeContent() {
      if (this.$store.state.contentPane === 'site') {
        return true;
      } else {
        return false;
      }
    },
    boardContent: function boardContent() {
      if (this.$store.state.contentPane === 'board') {
        return true;
      } else {
        return false;
      }
    },
    textContent: function textContent() {
      if (this.$store.state.contentPane === 'text') {
        return true;
      } else {
        return false;
      }
    },
    currentItemContent: function currentItemContent() {
      return this.$store.state.currentItemContent;
    },
    iframeHTML: function iframeHTML() {
      if (this.iframeContent) {
        return this.$store.state.iframeHTML;
      } else {
        return '';
      }
    },
    hasNext: function hasNext() {
      return this.$store.state.currentItem.next;
    },
    hasPrev: function hasPrev() {
      return this.$store.state.currentItem.prev;
    },
    dynComponent: function dynComponent() {
      var template = this.currentItemContent ? this.currentItemContent : '<div></div>';
      return {
        template: template,
        props: this.$options.props };
    }
  },
  beforeUpdate: function beforeUpdate() {},
  mounted: function mounted() {
    var xSections = document.getElementsByClassName('x-section');
    if (xSections) {
      this.xSections = xSections;
    }
    function handleScrollF() {
      var _this = this;

      var sections = Array.prototype.slice.call(this.xSections);
      sections.forEach(function (section) {
        var top = section.getBoundingClientRect().top;
        if (top < 100) {
          var re = /-(\d+)$/;
          var match = re.exec(section.id);
          var id = match[1];
          return _this.$store.dispatch('setCurrentPageSection', { id: id });
        }
      });
    }
    this.handleScroll = _lodash2.default.debounce(handleScrollF, 50);
  },
  updated: function updated() {
    var blocks = this.$el.querySelectorAll('code');

    blocks.forEach(function (block) {
      hljs.highlightBlock(block);
    });
    var id = this.$store.state.currentItem.id;
    var item = JSON.search(this.data, '//*[id="' + id + '"]')[0];
    overrideXFrame(item, this.$store.state.leotext);
    var clinks = document.getElementsByClassName('csection-link');
    var leodata = this.$store.state.leodata;
    var me = this;

    function gotoSectionFunc(leodata) {
      function func(e) {
        try {
          var _item = JSON.search(leodata, '//*[name="' + e.srcElement.innerHTML + '"]')[0];
          console.log('ITEM', _item);
          var _id = _item.id;
          me.$store.dispatch('setCurrentItem', { id: _id });
        } catch (e) {
          console.log('goto section error:', e);
        }
      }
      return func;
    }
    for (var i = 0; i < clinks.length; i++) {
      var clink = clinks[i];
      clink.onclick = gotoSectionFunc(leodata);
    }
  },

  watch: {}
};

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var leftPane = void 0;
var rightPane = void 0;
var paneSep = void 0;
exports.default = {
  name: 'splitpane',
  props: {
    leftPaneStyle: String
  },
  data: function data() {
    return {
      showRightButton: false,
      leftPaneWidth: 0
    };
  },
  methods: {
    slide: function slide(direction) {
      if (direction === 'left') {
        this.leftPaneWidth = leftPane.style.width;
        leftPane.style.width = 0;
        this.showRightButton = true;
      } else {
        leftPane.style.width = this.leftPaneWidth;
        this.showRightButton = false;
      }
    }
  },
  computed: {
    xshowRightButton: function xshowRightButton() {
      if (!leftPane) {
        return;
      }
      return !leftPane.style.width;
    },
    rightPaneStyle: function rightPaneStyle() {
      var width = window.lconfig.rightPaneWidth;
      width = width || '100%';
      return { width: width };
    }
  },
  mounted: function mounted() {
    leftPane = document.getElementById('left-pane');
    rightPane = document.getElementById('right-pane');
    paneSep = document.getElementById('panes-separator');

    var leftLimit = 0;
    var rightLimit = 90;

    paneSep.sdrag(function (el, pageX, startX, pageY, startY, fix) {
      fix.skipX = true;
      if (pageX < window.innerWidth * leftLimit / 100) {
        pageX = window.innerWidth * leftLimit / 100;
        fix.pageX = pageX;
      }
      if (pageX > window.innerWidth * rightLimit / 100) {
        pageX = window.innerWidth * rightLimit / 100;
        fix.pageX = pageX;
      }
      var cur = pageX / window.innerWidth * 100;
      if (cur < 0) {
        cur = 0;
      }
      if (cur > window.innerWidth) {
        cur = window.innerWidth;
      }
      var right = 100 - cur - 2;
      leftPane.style.width = cur + '%';
      rightPane.style.width = right + '%';
    }, null, 'horizontal');
  },
  updated: function updated() {}
};

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _D3tree = __webpack_require__(859);

var _D3tree2 = _interopRequireDefault(_D3tree);

var _SplitPane = __webpack_require__(151);

var _SplitPane2 = _interopRequireDefault(_SplitPane);

var _ContentPane = __webpack_require__(150);

var _ContentPane2 = _interopRequireDefault(_ContentPane);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var target = { el: null };
exports.default = {
  name: 'd3viewer',
  props: {},
  components: {
    D3tree: _D3tree2.default,
    splitpane: _SplitPane2.default,
    contentpane: _ContentPane2.default
  },
  data: function data() {
    return {
      target: target,
      open: false,
      active: false,
      lhandle: true,
      duration: 750,
      nodeText: 'name',
      currentNode: null,
      zoomable: true,
      isLoading: false,
      events: [],
      reset: 0
    };
  },
  methods: {
    onClick: function onClick(evt) {
      this.currentNode = evt.element;
      this.onEvent('onClick', evt);
    },
    onEvent: function onEvent(eventName, data) {
      this.events.push({ eventName: eventName, data: data.data });
      var id = data.data.id;
      this.$store.dispatch('setCurrentItem', { id: id });
    }
  },
  watch: {
    '$route': {
      handler: function handler(val, oldVal, changed) {},
      immediate: true
    }
  },
  computed: {
    data: function data() {
      var d = this.$store.state.leodata;
      if (d.length > 1) {
        var root = {
          name: 'test',
          id: 0,
          children: d
        };
        return root;
      } else {
        return d[0];
      }
    },
    text: function text() {
      return this.$store.state.leotext;
    },
    openDepth: function openDepth() {
      if (this.$store.state.viewType === 'd') {
        return 2;
      }
      return -1;
    },
    type: function type() {
      this.reset = this.reset + 1;
      if (this.$store.state.viewType === 'z') {
        return 'cluster';
      }
      return 'tree';
    },
    layoutType: function layoutType() {
      if (this.$store.state.viewType === 'r') {
        return 'circular';
      }
      return 'euclidean';
    },
    Marginx: function Marginx() {
      if (this.$store.state.viewType === 'r') {
        return -300;
      }
      return 80;
    },
    Marginy: function Marginy() {
      if (this.$store.state.viewType === 'r') {
        return -200;
      }
      return 30;
    }
  },
  mounted: function mounted() {},
  updated: function updated() {}
};

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(66);

var _promise2 = _interopRequireDefault(_promise);

var _toConsumableArray2 = __webpack_require__(155);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = __webpack_require__(26);

var _typeof3 = _interopRequireDefault(_typeof2);

var _vueResizeDirective = __webpack_require__(886);

var _vueResizeDirective2 = _interopRequireDefault(_vueResizeDirective);

var _euclideanLayout = __webpack_require__(889);

var _euclideanLayout2 = _interopRequireDefault(_euclideanLayout);

var _circularLayout = __webpack_require__(890);

var _circularLayout2 = _interopRequireDefault(_circularLayout);

var _d3Utils = __webpack_require__(891);

var _d = __webpack_require__(266);

var d3 = _interopRequireWildcard(_d);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapMany(arr, mapper) {
  return arr.reduce(function (prev, curr) {
    return prev.concat(mapper(curr));
  }, []);
}

var _layout = {
  euclidean: _euclideanLayout2.default,
  circular: _circularLayout2.default
};

var i = 0;
var currentSelected = null;
var types = ['tree', 'cluster'];
var layouts = ['circular', 'euclidean'];

var props = {
  data: Object,
  duration: {
    type: Number,
    default: 750
  },
  type: {
    type: String,
    default: 'tree',
    validator: function validator(value) {
      return types.indexOf(value) !== -1;
    }
  },
  layoutType: {
    type: String,
    default: 'euclidean',
    validator: function validator(value) {
      return layouts.indexOf(value) !== -1;
    }
  },
  marginX: {
    type: Number,
    default: 20
  },
  marginY: {
    type: Number,
    default: 20
  },
  nodeText: {
    type: String,
    required: true
  },
  zoomable: {
    type: Boolean,
    default: false
  },
  openDepth: {
    type: Number,
    default: -1
  },
  reset: {
    type: Number,
    default: 0
  }
};

var directives = {
  resize: _vueResizeDirective2.default
};

function drawLink(source, target, _ref) {
  var transformNode = _ref.transformNode;

  return 'M' + transformNode(source.x, source.y) + 'C' + transformNode(source.x, (source.y + target.y) / 2) + ' ' + transformNode(target.x, (source.y + target.y) / 2) + ' ' + transformNode(target.x, target.y);
}

function hasChildren(d) {
  return d.children || d._children;
}

function getChildren(d) {
  return d.children ? { children: d.children, visible: true } : d._children ? { children: d._children, visible: false } : null;
}

function onAllChilddren(d, callback) {
  var fatherVisible = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  if (callback(d, fatherVisible) === false) {
    return;
  }
  var directChildren = getChildren(d);
  directChildren && directChildren.children.forEach(function (child) {
    return onAllChilddren(child, callback, directChildren.visible);
  });
}

function removeTextAndGraph(selection) {
  ['circle', 'text'].forEach(function (select) {
    selection.selectAll(select).remove();
  });
}

function translate(vector, _ref2) {
  var transformNode = _ref2.transformNode;

  return 'translate(' + transformNode(vector.x, vector.y) + ')';
}

exports.default = {
  props: props,

  directives: directives,

  data: function data() {
    return {
      currentTransform: null,
      maxTextLenght: {
        first: 0,
        last: 0
      },
      initialize: false
    };
  },
  mounted: function mounted() {
    var size = this.getSize();
    var svg = d3.select(this.$el).append('svg').attr('width', size.width).attr('height', size.height);
    var g = null;
    var zoom = null;

    if (this.zoomable) {
      g = svg.append('g');
      zoom = d3.zoom().scaleExtent([0.9, 8]).on('zoom', this.zoomed(g));
      svg.call(zoom).on('wheel', function () {
        return d3.event.preventDefault();
      });
      svg.call(zoom.transform, d3.zoomIdentity);
    } else {
      g = this.transformSvg(svg.append('g'), size);
    }

    var tree = this.tree;
    this.internaldata = {
      svg: svg,
      g: g,
      tree: tree,
      zoom: zoom
    };

    this.data && this.onData(this.data);
  },


  methods: {
    getSize: function getSize() {
      var width = this.$el.clientWidth + 80;
      var height = this.$el.clientHeight;
      return { width: width, height: height };
    },
    resize: function resize() {
      var size = this.getSize();
      this.internaldata.svg.attr('width', size.width).attr('height', size.height);
      this.layout.size(this.internaldata.tree, size, this.margin, this.maxTextLenght);
      this.applyZoom(size);
      this.redraw();
    },
    completeRedraw: function completeRedraw(_ref3) {
      var _ref3$margin = _ref3.margin,
          margin = _ref3$margin === undefined ? null : _ref3$margin,
          _ref3$layout = _ref3.layout,
          layout = _ref3$layout === undefined ? null : _ref3$layout;

      var size = this.getSize();
      this.layout.size(this.internaldata.tree, size, this.margin, this.maxTextLenght);
      this.applyTransition(size, { margin: margin, layout: layout });
      this.redraw();
    },
    transformSvg: function transformSvg(g, size) {
      size = size || this.getSize();
      return this.layout.transformSvg(g, this.margin, size, this.maxTextLenght);
    },
    updateTransform: function updateTransform(g, size) {
      size = size || this.getSize();
      return this.layout.updateTransform(g, this.margin, size, this.maxTextLenght);
    },
    updateGraph: function updateGraph(source) {
      var _this = this;

      var originBuilder = source;
      var forExit = source;
      if ((typeof source === 'undefined' ? 'undefined' : (0, _typeof3.default)(source)) === 'object') {
        var origin = { x: source.x0, y: source.y0 };
        originBuilder = function originBuilder(d) {
          return origin;
        };
        forExit = function forExit(d) {
          return { x: source.x, y: source.y };
        };
      }
      var root = this.internaldata.root;
      var links = this.internaldata.g.selectAll('.linktree').data(this.internaldata.tree(root).descendants().slice(1), function (d) {
        return d.id;
      });

      var updateLinks = links.enter().append('path').attr('class', 'linktree');
      var node = this.internaldata.g.selectAll('.nodetree').data(root.descendants(), function (d) {
        return d.id;
      });
      var newNodes = node.enter().append('g').attr('class', 'nodetree');
      var allNodes = newNodes.merge(node);

      removeTextAndGraph(node);

      var text = allNodes.append('text').attr('dy', '.35em').text(function (d, i) {
        if (i === 0) {
          return '';
        }
        var t = d.data[_this.nodeText];

        var re = /^\[(.*?)\]\((.*?)\)$/;
        var match = re.exec(t);
        if (match) {
          t = match[1];
        }
        if (/^@clean/.test(t)) {
          t = t.substring(t.lastIndexOf('/') + 1);
        }
        return t;
      }).on('click', function (d) {
        currentSelected = currentSelected === d ? null : d;
        d3.event.stopPropagation();
        _this.redraw();
        _this.$emit('clicked', { element: d, data: d.data });
      });

      updateLinks.attr('d', function (d) {
        return drawLink(originBuilder(d), originBuilder(d), _this.layout);
      });

      var updateAndNewLinks = links.merge(updateLinks);
      var updateAndNewLinksPromise = (0, _d3Utils.toPromise)(updateAndNewLinks.transition().duration(this.duration).attr('d', function (d) {
        return drawLink(d, d.parent, _this.layout);
      }));

      var exitingLinksPromise = (0, _d3Utils.toPromise)(links.exit().transition().duration(this.duration).attr('d', function (d) {
        return drawLink(forExit(d), forExit(d), _this.layout);
      }).remove());

      newNodes.attr('transform', function (d) {
        return translate(originBuilder(d), _this.layout);
      });

      allNodes.classed('node--internal', function (d) {
        return hasChildren(d);
      }).classed('node--leaf', function (d) {
        return !hasChildren(d);
      }).classed('selected', function (d) {
        return d === currentSelected;
      }).on('click', this.onNodeClick);

      var allNodesPromise = (0, _d3Utils.toPromise)(allNodes.transition().duration(this.duration).attr('transform', function (d) {
        return translate(d, _this.layout);
      }).attr('opacity', 1));

      allNodes.append('circle');
      text.attr('x', function (d) {
        return d.textInfo ? d.textInfo.x : 0;
      }).attr('dx', function (d) {
        return d.textInfo ? (0, _d3Utils.anchorTodx)(d.textInfo.anchor, this) : 0;
      }).attr('transform', function (d) {
        return 'rotate(' + (d.textInfo ? d.textInfo.rotate : 0) + ')';
      });

      var transformer = this.layout.transformText;
      allNodes.each(function (d) {
        d.textInfo = transformer(d, hasChildren(d));
      });

      var textTransition = (0, _d3Utils.toPromise)(text.transition().duration(this.duration).attr('x', function (d) {
        return d.textInfo.x;
      }).attr('dx', function (d) {
        return (0, _d3Utils.anchorTodx)(d.textInfo.anchor, this);
      }).attr('transform', function (d) {
        return 'rotate(' + d.textInfo.rotate + ')';
      }));

      allNodes.each(function (d) {
        d.x0 = d.x;
        d.y0 = d.y;
      });

      var exitingNodes = node.exit();
      var exitingNodesPromise = (0, _d3Utils.toPromise)(exitingNodes.transition().duration(this.duration).attr('transform', function (d) {
        return translate(forExit(d), _this.layout);
      }).attr('opacity', 0).remove());
      exitingNodes.select('circle').attr('r', 1e-6);
      if (!this.initialized && this.layoutType === 'euclidean' && this.type === 'tree') {
        if (this.openDepth > 0) {
          allNodes.each(function (d) {
            var depth = d.ancestors().length;
            if (depth > _this.openDepth) {
              _this.collapse(d, false);
            }
          });
          if (this.layoutType === 'euclidean') {
            this.initialized = true;
          }
        } else {
          allNodes.each(function (d) {
            return _this.expand(d, false);
          });
        }
      }
      if (this.type !== 'tree') {
        allNodes.each(function (d) {
          return _this.expand(d, false);
        });
        this.initialized = false;
      }
      var leaves = root.leaves();
      var extremeNodes = text.filter(function (d) {
        return leaves.indexOf(d) !== -1;
      }).nodes();
      var last = Math.max.apply(Math, (0, _toConsumableArray3.default)(extremeNodes.map(function (node) {
        return node.getComputedTextLength();
      }))) + 6;
      var first = text.node().getComputedTextLength() + 6;
      if (last <= this.maxTextLenght.last && first <= this.maxTextLenght.first) {
        return _promise2.default.all([allNodesPromise, exitingNodesPromise, textTransition, updateAndNewLinksPromise, exitingLinksPromise]);
      }
      this.maxTextLenght = { first: first, last: last };
      this.internaldata.svg.call(this.internaldata.zoom.transform, this.currentTransform);
      this.layout.size(this.internaldata.tree, this.getSize(), this.margin, this.maxTextLenght);

      return this.updateGraph(source);
    },
    onNodeClick: function onNodeClick(d) {
      if (d.children) {
        this.collapse(d);
      } else {
        this.expand(d);
        var title = d.data.name;
        if (/^\[/.test(title)) {
          console.log('REDRAW');
          this.redraw();
        } else {
          console.log('RR', title);
        }
        this.redraw();
      }
    },
    onData: function onData(data) {
      if (!data) {
        this.internaldata.root = null;
        this.clean();
        return;
      }
      var root = d3.hierarchy(data).sort(function (a, b) {
        return (0, _d3Utils.compareString)(a.data.text, b.data.text);
      });
      this.internaldata.root = root;
      root.each(function (d) {
        d.id = i++;
      });
      var size = this.getSize();
      root.x = size.height / 2;
      root.y = 0;
      root.x0 = root.x;
      root.y0 = root.y;
      this.redraw();
    },
    clean: function clean() {
      var _this2 = this;

      ['.linktree', '.nodetree', 'text', 'circle'].forEach(function (selector) {
        _this2.internaldata.g.selectAll(selector).transition().duration(_this2.duration).attr('opacity', 0).remove();
      });
    },
    redraw: function redraw() {
      var root = this.internaldata.root;
      if (root) {
        return this.updateGraph(root);
      }
      return _promise2.default.resolve('no graph');
    },
    getNodeOriginComputer: function getNodeOriginComputer(originalVisibleNodes) {
      return function (node) {
        var parentVisible = (0, _d3Utils.findInParents)(node, originalVisibleNodes);
        return { x: parentVisible.x0, y: parentVisible.y0 };
      };
    },
    applyZoom: function applyZoom(size) {
      var _internaldata = this.internaldata,
          g = _internaldata.g,
          zoom = _internaldata.zoom;

      if (this.zoomable) {
        g.call(zoom.transform, this.currentTransform);
      } else {
        this.transformSvg(g, size);
      }
    },
    applyTransition: function applyTransition(size, _ref4) {
      var margin = _ref4.margin,
          layout = _ref4.layout;
      var _internaldata2 = this.internaldata,
          g = _internaldata2.g,
          svg = _internaldata2.svg,
          zoom = _internaldata2.zoom;

      if (this.zoomable) {
        var transform = this.currentTransform;
        var oldMargin = margin || this.margin;
        var oldLayout = layout || this.layout;

        var nowTransform = oldLayout.updateTransform(transform, oldMargin, size, this.maxTextLenght);
        var nextRealTransform = this.updateTransform(transform, size);
        var current = d3.zoomIdentity.translate(transform.x + nowTransform.x - nextRealTransform.x, transform.y + nowTransform.y - nextRealTransform.y).scale(transform.k);

        svg.call(zoom.transform, current).transition().duration(this.duration).call(zoom.transform, transform);
      } else {
        var transitiong = g.transition().duration(this.duration);
        this.transformSvg(transitiong, size);
      }
    },
    zoomed: function zoomed(g) {
      var _this3 = this;

      return function () {
        var transform = d3.event.transform;
        var size = _this3.getSize();
        var transformToApply = _this3.updateTransform(transform, size);
        _this3.currentTransform = transform;
        _this3.$emit('zoom', { transform: transform });
        g.attr('transform', transformToApply);
      };
    },
    updateIfNeeded: function updateIfNeeded(d, update) {
      return update ? this.updateGraph(d).then(function () {
        return true;
      }) : _promise2.default.resolve(true);
    },
    collapse: function collapse(d) {
      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!d.children) {
        return _promise2.default.resolve(false);
      }

      d._children = d.children;
      d.children = null;
      this.$emit('retract', { element: d, data: d.data });
      return this.updateIfNeeded(d, update);
    },
    expand: function expand(d) {
      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!d._children) {
        return _promise2.default.resolve(false);
      }

      d.children = d._children;
      d._children = null;
      this.$emit('expand', { element: d, data: d.data });
      return this.updateIfNeeded(d, update);
    },
    expandAll: function expandAll(d) {
      var _this4 = this;

      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var lastVisible = d.leaves();
      onAllChilddren(d, function (child) {
        _this4.expand(child, false);
      });
      return this.updateIfNeeded(this.getNodeOriginComputer(lastVisible), update);
    },
    collapseAll: function collapseAll(d) {
      var _this5 = this;

      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      onAllChilddren(d, function (child) {
        return _this5.collapse(child, false);
      });
      return this.updateIfNeeded(d, update);
    },
    show: function show(d) {
      var _this6 = this;

      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var path = d.ancestors().reverse();
      var root = path.find(function (node) {
        return node.children === null;
      }) || d;
      path.forEach(function (node) {
        return _this6.expand(node, false);
      });
      return this.updateIfNeeded(root, update);
    },
    showOnly: function showOnly(d) {
      var _this7 = this;

      var root = this.internaldata.root;
      var path = d.ancestors().reverse();
      var shouldBeRetracted = mapMany(path, function (p) {
        return p.children ? p.children : [];
      }).filter(function (node) {
        return node && path.indexOf(node) === -1;
      });
      var mapped = {};
      shouldBeRetracted.filter(function (node) {
        return node.children;
      }).forEach(function (rectractedNode) {
        return rectractedNode.each(function (c) {
          mapped[c.id] = rectractedNode;
        });
      });
      var origin = function origin(node) {
        var reference = mapped[node.id];
        return { x: reference.x, y: reference.y };
      };
      var updater = function updater(node) {
        if (shouldBeRetracted.indexOf(node) !== -1) {
          _this7.collapse(node, false);
          return false;
        }
        return node !== d;
      };
      onAllChilddren(root, updater);
      return this.updateGraph(origin).then(function () {
        return true;
      });
    },
    resetZoom: function resetZoom() {
      if (!this.zoomable) {
        return _promise2.default.resolve(false);
      }
      var _internaldata3 = this.internaldata,
          svg = _internaldata3.svg,
          zoom = _internaldata3.zoom;

      var transitionPromise = (0, _d3Utils.toPromise)(svg.transition().duration(this.duration).call(zoom.transform, function () {
        return d3.zoomIdentity;
      }));
      return transitionPromise.then(function () {
        return true;
      });
    }
  },

  computed: {
    tree: function tree() {
      var size = this.getSize();
      var tree = this.type === 'cluster' ? d3.cluster() : d3.tree();
      this.layout.size(tree, size, this.margin, this.maxTextLenght);
      return tree;
    },
    margin: function margin() {
      return { x: this.marginX, y: this.marginY };
    },
    layout: function layout() {
      return _layout[this.layoutType];
    }
  },

  watch: {
    data: function data(current, old) {
      this.onData(current);
    },
    type: function type() {
      if (!this.internaldata.tree) {
        return;
      }
      this.internaldata.tree = this.tree;
      this.redraw();
    },
    reset: function reset() {
      this.completeRedraw({ margin: { x: this.marginX, y: this.marginY } });
    },
    marginX: function marginX(newMarginX, oldMarginX) {
      this.completeRedraw({ margin: { x: newMarginX, y: this.marginY } });
    },
    marginY: function marginY(newMarginY, oldMarginY) {
      this.completeRedraw({ margin: { x: this.marginX, y: newMarginY } });
    },
    layout: function layout(newLayout, oldLayout) {
      this.completeRedraw({ layout: oldLayout });
    }
  }
};

/***/ }),

/***/ 2628:
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(2629);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(59)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../../../vue-style-loader/index.js!../../../../css-loader/index.js??ref--6-2!./alert.css", function() {
		var newContent = require("!!../../../../extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../../../vue-style-loader/index.js!../../../../css-loader/index.js??ref--6-2!./alert.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2629:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2688:
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(2689);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(59)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../../../vue-style-loader/index.js!../../../../css-loader/index.js??ref--6-2!./dropdown.css", function() {
		var newContent = require("!!../../../../extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../../../vue-style-loader/index.js!../../../../css-loader/index.js??ref--6-2!./dropdown.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2689:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2706:
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(2707);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(59)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../../../vue-style-loader/index.js!../../../../css-loader/index.js??ref--6-2!./form-input.css", function() {
		var newContent = require("!!../../../../extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../../../vue-style-loader/index.js!../../../../css-loader/index.js??ref--6-2!./form-input.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2707:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2756:
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(2757);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(59)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../../../vue-style-loader/index.js!../../../../css-loader/index.js??ref--6-2!./table.css", function() {
		var newContent = require("!!../../../../extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../../../vue-style-loader/index.js!../../../../css-loader/index.js??ref--6-2!./table.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2757:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2771:
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(2772);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(59)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../../vue-style-loader/index.js!../../../css-loader/index.js??ref--6-2!./bootstrap.css", function() {
		var newContent = require("!!../../../extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../../vue-style-loader/index.js!../../../css-loader/index.js??ref--6-2!./bootstrap.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2772:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2773:
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(2774);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(59)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../vue-style-loader/index.js!../../css-loader/index.js??ref--6-2!./bootstrap-vue.css", function() {
		var newContent = require("!!../../extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../vue-style-loader/index.js!../../css-loader/index.js??ref--6-2!./bootstrap-vue.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2774:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2775:
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(2776);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(59)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../vue-style-loader/index.js!../../css-loader/index.js??ref--6-2!./timeline-vuejs.css", function() {
		var newContent = require("!!../../extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../vue-style-loader/index.js!../../css-loader/index.js??ref--6-2!./timeline-vuejs.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2776:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2783:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f105438_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__(2785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(2784)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f105438"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f105438_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f105438_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2784:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2785:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{style:(_vm.style)},[_c('caption',[_vm._v(_vm._s(_vm.caption))]),_vm._v(" "),_c('thead',_vm._l((_vm.firstRow),function(cell,c){return (_vm.dataCol(c))?_c('th',[_vm._v(_vm._s(cell))]):_vm._e()})),_vm._v(" "),_c('tbody',_vm._l((_vm.table),function(row,r){return (r)?_c('tr',_vm._l((row),function(cell,c){return (_vm.dataCol(c))?_c('td',[_vm._v(_vm._s(cell))]):_vm._e()})):_vm._e()}))])])}
var staticRenderFns = []


/***/ }),

/***/ 2786:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VCTable_vue__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VCTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VCTable_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VCTable_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VCTable_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66d711b8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VCTable_vue__ = __webpack_require__(2789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(2787)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VCTable_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66d711b8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VCTable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66d711b8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VCTable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2787:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2789:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.currentTable,{tag:"component"})],1)}
var staticRenderFns = []


/***/ }),

/***/ 2790:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mermaid_vue__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mermaid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mermaid_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mermaid_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mermaid_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ada058c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mermaid_vue__ = __webpack_require__(2792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(2791)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ada058c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mermaid_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ada058c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mermaid_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ada058c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mermaid_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2791:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2792:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mermaid",attrs:{"name":_vm.name}},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),

/***/ 2793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MermaidP_vue__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MermaidP_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MermaidP_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MermaidP_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MermaidP_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1d5aa1c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MermaidP_vue__ = __webpack_require__(2795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(2794)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a1d5aa1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MermaidP_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1d5aa1c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MermaidP_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1d5aa1c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MermaidP_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2794:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2795:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xmermaid"},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),

/***/ 2796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VSVG_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VSVG_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VSVG_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VSVG_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VSVG_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ca214be_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VSVG_vue__ = __webpack_require__(2798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(2797)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VSVG_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ca214be_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VSVG_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ca214be_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VSVG_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2797:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2798:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.style)},[_c('svg',{staticStyle:{"height":"100%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":_vm.viewBox,"version":"1.1"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"white"}}),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []


/***/ }),

/***/ 2799:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionLink_vue__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionLink_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionLink_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionLink_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionLink_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16bdb7e6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionLink_vue__ = __webpack_require__(2801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(2800)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16bdb7e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionLink_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16bdb7e6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionLink_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16bdb7e6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionLink_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2800:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2801:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-link",on:{"click":_vm.gotoSection}},[_vm._v("« "+_vm._s(_vm.title)+" »")])}
var staticRenderFns = []


/***/ }),

/***/ 2802:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TOC_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TOC_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TOC_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TOC_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TOC_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7226846d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TOC_vue__ = __webpack_require__(2804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(2803)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7226846d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TOC_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7226846d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TOC_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7226846d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TOC_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2803:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2804:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toc"},_vm._l((_vm.chapters),function(chapter){return _c('div',{staticClass:"chapter"},[_c('div',{staticClass:"section-link",on:{"click":function($event){_vm.gotoSection(chapter.vtitle)}}},[_vm._v(_vm._s(chapter.vtitle))])])}))}
var staticRenderFns = []


/***/ }),

/***/ 2805:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NodeLink_vue__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NodeLink_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NodeLink_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NodeLink_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NodeLink_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d139bd3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NodeLink_vue__ = __webpack_require__(2807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(2806)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d139bd3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NodeLink_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d139bd3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NodeLink_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d139bd3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NodeLink_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2806:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2807:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"node-link",on:{"click":_vm.gotoSection}},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []


/***/ }),

/***/ 2808:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MathJax_vue__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MathJax_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MathJax_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MathJax_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MathJax_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8582320_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MathJax_vue__ = __webpack_require__(2810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(2809)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e8582320"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MathJax_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8582320_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MathJax_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8582320_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MathJax_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2809:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2810:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"}},[_vm._v("\n  $$"),_vm._t("default"),_vm._v("$$\n")],2)}
var staticRenderFns = []


/***/ }),

/***/ 2811:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageLeft_vue__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageLeft_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageLeft_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageLeft_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageLeft_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b6c0d6a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageLeft_vue__ = __webpack_require__(2813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(2812)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b6c0d6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageLeft_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b6c0d6a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageLeft_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b6c0d6a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageLeft_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2812:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2813:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"img",staticStyle:{"float":"left"}},[_c('img',{attrs:{"height":_vm.heightpx,"src":_vm.src}})]),_vm._v(" "),_c('div',{staticClass:"txt"},[_vm._t("txt")],2),_vm._v(" "),_c('div',{staticClass:"footer",staticStyle:{"clear":"both","text-align":"center","padding-top":"30px"}},[_vm._t("foot")],2)])}
var staticRenderFns = []


/***/ }),

/***/ 2814:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LVTimeline_vue__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LVTimeline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LVTimeline_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LVTimeline_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LVTimeline_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a7db710_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LVTimeline_vue__ = __webpack_require__(2817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(2815)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a7db710"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LVTimeline_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a7db710_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LVTimeline_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a7db710_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LVTimeline_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2815:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2817:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lv-timeline"},[_c('timeline',{attrs:{"timeline-items":_vm.chapters,"message-when-no-items":_vm.messageWhenNoItems,"unique-year":true,"order":"desc"}})],1)}
var staticRenderFns = []


/***/ }),

/***/ 2818:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WordCloud_vue__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WordCloud_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WordCloud_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WordCloud_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WordCloud_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4cd2288_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WordCloud_vue__ = __webpack_require__(2841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(2819)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a4cd2288"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WordCloud_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4cd2288_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WordCloud_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4cd2288_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WordCloud_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2819:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2841:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"word-cloud"},[_c('vue-word-cloud',{attrs:{"words":_vm.chapters,"color":function (ref) {
	var weight = ref[1];

	return weight > 50 ? 'DeepPink' : weight > 25 ? 'RoyalBlue' : 'Indigo';
},"font-family":"Roboto"}})],1)}
var staticRenderFns = []


/***/ }),

/***/ 2842:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kanban_vue__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kanban_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kanban_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kanban_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kanban_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34536ce0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kanban_vue__ = __webpack_require__(2845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(2843)
  __webpack_require__(2844)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34536ce0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kanban_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34536ce0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kanban_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34536ce0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kanban_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2843:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2844:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2845:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nestedviewer",staticStyle:{"color":"#fff"}},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"flex-grid"},_vm._l((_vm.itemSet.children),function(col,c){return _c('div',{staticClass:"col"},[_c('div',{staticClass:"col-title"},[_vm._v(_vm._s(col.name))]),_vm._v(" "),_c('ul',{attrs:{"slot":"left"},slot:"left"},_vm._l((col.children),function(itemdata){return _c('div',[_c('item',{staticClass:"item",attrs:{"prefix":'nid' + c,"model":itemdata,"top":false,"textItems":_vm.text,"accordion":true,"targetEl":null}})],1)}))])}))])}
var staticRenderFns = []


/***/ }),

/***/ 2846:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MermaidBoard_vue__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MermaidBoard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MermaidBoard_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MermaidBoard_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MermaidBoard_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73c0b51e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MermaidBoard_vue__ = __webpack_require__(2849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(2847)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73c0b51e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MermaidBoard_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73c0b51e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MermaidBoard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73c0b51e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MermaidBoard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2847:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2849:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mm-board"},[_c('div',{ref:"mbutton",staticClass:"mbutton",attrs:{"id":"mbutton"},on:{"click":_vm.clickb}},[(!_vm.viewSource)?_c('icon',{staticClass:"icon",attrs:{"name":"code"}}):_vm._e(),_vm._v(" "),(_vm.viewSource)?_c('icon',{staticClass:"icon",attrs:{"name":"picture-o"}}):_vm._e()],1),_vm._v(" "),(!_vm.viewSource)?_c('div',{staticStyle:{"text-align":"center"},on:{"click":_vm.click}},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('mermaid',{attrs:{"name":_vm.mmName,"mm":_vm.mm,"height":_vm.mprops.height + ''}},[_vm._v("\n      "+_vm._s(_vm.mm)+"\n    ")])],1):_vm._e(),_vm._v(" "),(_vm.viewSource)?_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.mmPretty)}}):_vm._e()])}
var staticRenderFns = []


/***/ }),

/***/ 2850:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3Board_vue__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3Board_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3Board_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3Board_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3Board_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a15266_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D3Board_vue__ = __webpack_require__(2852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(2851)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01a15266"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3Board_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a15266_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D3Board_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a15266_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D3Board_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2851:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2852:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{attrs:{"width":"800","height":"600","id":"d3board-svg"}})])}
var staticRenderFns = []


/***/ }),

/***/ 2854:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 420,
	"./af.js": 420,
	"./ar": 421,
	"./ar-dz": 422,
	"./ar-dz.js": 422,
	"./ar-kw": 423,
	"./ar-kw.js": 423,
	"./ar-ly": 424,
	"./ar-ly.js": 424,
	"./ar-ma": 425,
	"./ar-ma.js": 425,
	"./ar-sa": 426,
	"./ar-sa.js": 426,
	"./ar-tn": 427,
	"./ar-tn.js": 427,
	"./ar.js": 421,
	"./az": 428,
	"./az.js": 428,
	"./be": 429,
	"./be.js": 429,
	"./bg": 430,
	"./bg.js": 430,
	"./bm": 431,
	"./bm.js": 431,
	"./bn": 432,
	"./bn.js": 432,
	"./bo": 433,
	"./bo.js": 433,
	"./br": 434,
	"./br.js": 434,
	"./bs": 435,
	"./bs.js": 435,
	"./ca": 436,
	"./ca.js": 436,
	"./cs": 437,
	"./cs.js": 437,
	"./cv": 438,
	"./cv.js": 438,
	"./cy": 439,
	"./cy.js": 439,
	"./da": 440,
	"./da.js": 440,
	"./de": 441,
	"./de-at": 442,
	"./de-at.js": 442,
	"./de-ch": 443,
	"./de-ch.js": 443,
	"./de.js": 441,
	"./dv": 444,
	"./dv.js": 444,
	"./el": 445,
	"./el.js": 445,
	"./en-au": 446,
	"./en-au.js": 446,
	"./en-ca": 447,
	"./en-ca.js": 447,
	"./en-gb": 448,
	"./en-gb.js": 448,
	"./en-ie": 449,
	"./en-ie.js": 449,
	"./en-il": 450,
	"./en-il.js": 450,
	"./en-nz": 451,
	"./en-nz.js": 451,
	"./eo": 452,
	"./eo.js": 452,
	"./es": 453,
	"./es-do": 454,
	"./es-do.js": 454,
	"./es-us": 455,
	"./es-us.js": 455,
	"./es.js": 453,
	"./et": 456,
	"./et.js": 456,
	"./eu": 457,
	"./eu.js": 457,
	"./fa": 458,
	"./fa.js": 458,
	"./fi": 459,
	"./fi.js": 459,
	"./fo": 460,
	"./fo.js": 460,
	"./fr": 461,
	"./fr-ca": 462,
	"./fr-ca.js": 462,
	"./fr-ch": 463,
	"./fr-ch.js": 463,
	"./fr.js": 461,
	"./fy": 464,
	"./fy.js": 464,
	"./gd": 465,
	"./gd.js": 465,
	"./gl": 466,
	"./gl.js": 466,
	"./gom-latn": 467,
	"./gom-latn.js": 467,
	"./gu": 468,
	"./gu.js": 468,
	"./he": 469,
	"./he.js": 469,
	"./hi": 470,
	"./hi.js": 470,
	"./hr": 471,
	"./hr.js": 471,
	"./hu": 472,
	"./hu.js": 472,
	"./hy-am": 473,
	"./hy-am.js": 473,
	"./id": 474,
	"./id.js": 474,
	"./is": 475,
	"./is.js": 475,
	"./it": 476,
	"./it.js": 476,
	"./ja": 477,
	"./ja.js": 477,
	"./jv": 478,
	"./jv.js": 478,
	"./ka": 479,
	"./ka.js": 479,
	"./kk": 480,
	"./kk.js": 480,
	"./km": 481,
	"./km.js": 481,
	"./kn": 482,
	"./kn.js": 482,
	"./ko": 483,
	"./ko.js": 483,
	"./ky": 484,
	"./ky.js": 484,
	"./lb": 485,
	"./lb.js": 485,
	"./lo": 486,
	"./lo.js": 486,
	"./lt": 487,
	"./lt.js": 487,
	"./lv": 488,
	"./lv.js": 488,
	"./me": 489,
	"./me.js": 489,
	"./mi": 490,
	"./mi.js": 490,
	"./mk": 491,
	"./mk.js": 491,
	"./ml": 492,
	"./ml.js": 492,
	"./mn": 493,
	"./mn.js": 493,
	"./mr": 494,
	"./mr.js": 494,
	"./ms": 495,
	"./ms-my": 496,
	"./ms-my.js": 496,
	"./ms.js": 495,
	"./mt": 497,
	"./mt.js": 497,
	"./my": 498,
	"./my.js": 498,
	"./nb": 499,
	"./nb.js": 499,
	"./ne": 500,
	"./ne.js": 500,
	"./nl": 501,
	"./nl-be": 502,
	"./nl-be.js": 502,
	"./nl.js": 501,
	"./nn": 503,
	"./nn.js": 503,
	"./pa-in": 504,
	"./pa-in.js": 504,
	"./pl": 505,
	"./pl.js": 505,
	"./pt": 506,
	"./pt-br": 507,
	"./pt-br.js": 507,
	"./pt.js": 506,
	"./ro": 508,
	"./ro.js": 508,
	"./ru": 509,
	"./ru.js": 509,
	"./sd": 510,
	"./sd.js": 510,
	"./se": 511,
	"./se.js": 511,
	"./si": 512,
	"./si.js": 512,
	"./sk": 513,
	"./sk.js": 513,
	"./sl": 514,
	"./sl.js": 514,
	"./sq": 515,
	"./sq.js": 515,
	"./sr": 516,
	"./sr-cyrl": 517,
	"./sr-cyrl.js": 517,
	"./sr.js": 516,
	"./ss": 518,
	"./ss.js": 518,
	"./sv": 519,
	"./sv.js": 519,
	"./sw": 520,
	"./sw.js": 520,
	"./ta": 521,
	"./ta.js": 521,
	"./te": 522,
	"./te.js": 522,
	"./tet": 523,
	"./tet.js": 523,
	"./tg": 524,
	"./tg.js": 524,
	"./th": 525,
	"./th.js": 525,
	"./tl-ph": 526,
	"./tl-ph.js": 526,
	"./tlh": 527,
	"./tlh.js": 527,
	"./tr": 528,
	"./tr.js": 528,
	"./tzl": 529,
	"./tzl.js": 529,
	"./tzm": 530,
	"./tzm-latn": 531,
	"./tzm-latn.js": 531,
	"./tzm.js": 530,
	"./ug-cn": 532,
	"./ug-cn.js": 532,
	"./uk": 533,
	"./uk.js": 533,
	"./ur": 534,
	"./ur.js": 534,
	"./uz": 535,
	"./uz-latn": 536,
	"./uz-latn.js": 536,
	"./uz.js": 535,
	"./vi": 537,
	"./vi.js": 537,
	"./x-pseudo": 538,
	"./x-pseudo.js": 538,
	"./yo": 539,
	"./yo.js": 539,
	"./zh-cn": 540,
	"./zh-cn.js": 540,
	"./zh-hk": 541,
	"./zh-hk.js": 541,
	"./zh-tw": 542,
	"./zh-tw.js": 542
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2854;

/***/ }),

/***/ 2855:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SummaryTable_vue__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SummaryTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SummaryTable_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SummaryTable_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SummaryTable_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a13e6a4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SummaryTable_vue__ = __webpack_require__(2857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(2856)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a13e6a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SummaryTable_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a13e6a4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SummaryTable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a13e6a4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SummaryTable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2856:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2857:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-table"},[_c('table-component',{attrs:{"data":_vm.chapters,"sort-by":"pubdate","sort-order":"desc"},on:{"rowClick":_vm.dataTableClick}},_vm._l((_vm.colKeys),function(col){return _c('table-column',_vm._b({key:col.title},'table-column',col,false))}))],1)}
var staticRenderFns = []


/***/ }),

/***/ 2858:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagSearch_vue__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagSearch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagSearch_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagSearch_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagSearch_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f8b5e5a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagSearch_vue__ = __webpack_require__(2861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(2859)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f8b5e5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagSearch_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f8b5e5a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagSearch_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f8b5e5a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagSearch_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2859:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2861:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-tags-input',{attrs:{"tags":_vm.tags,"autocomplete-items":_vm.filteredItems},on:{"tags-changed":function (newTags) { return _vm.tags = newTags; }},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}}),_vm._v(" "),_c('div',{staticClass:"hit-list"},_vm._l((_vm.chapters),function(chapter){return _c('div',{staticClass:"chapter"},[_c('div',{staticClass:"section-link",on:{"click":function($event){_vm.gotoSection(chapter.node.id)}}},[_vm._v(_vm._s(chapter.nodePath)+" / "+_vm._s(chapter.node.vtitle))])])}))],1)}
var staticRenderFns = []


/***/ }),

/***/ 2863:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.charts = undefined;

var _from = __webpack_require__(110);

var _from2 = _interopRequireDefault(_from);

var _keys = __webpack_require__(79);

var _keys2 = _interopRequireDefault(_keys);

var _vueChartjs = __webpack_require__(2864);

var _vueChartjs2 = _interopRequireDefault(_vueChartjs);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _momentRange = __webpack_require__(2909);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var moment = (0, _momentRange.extendMoment)(_moment2.default);

var defaultColors = ['#8e5ea2', '#3cba9f', '#3e95cd', '#e8c3b9', '#c45850'];

function dataSetFromGroups(groups, data, textItems, props) {
  var datasets = [];
  var labels = [];
  groups.forEach(function (group) {
    var dataSet = dataSetFromGroup(group, data, textItems, props);
    labels.push(dataSet.labels);
    var d = dataSet.datasets[0];
    d.labels = dataSet.labels;
    d.label = dataSet.groupName;
    datasets.push(d);
  });

  labels = _lodash2.default.uniq(_lodash2.default.flatten(labels));
  datasets.forEach(function (dataSet, index) {
    var dataObj = {};

    for (var i = 0; i < dataSet.labels.length; i++) {
      var k = dataSet.labels[i];
      dataObj[k] = dataSet.data[i];
    }
    var points = [];
    dataSet.backgroundColor = defaultColors[index];
    dataSet.borderColor = defaultColors[index];

    labels.forEach(function (label) {
      points.push(dataObj[label] || 0);
    });
    dataSet.data = points;
  });
  return { labels: labels, datasets: datasets };
}

function dataSetFromGroup(group, data, textItems, props) {
  var dataKey = props.dataKey;
  var item = JSON.search(data, '//*[group="' + group + '"]')[0];
  var children = item.children;
  var items = [];
  children.forEach(function (child) {
    var t = textItems[child.t];
    var textData = {};
    try {
      textData = JSON.parse(t);
    } catch (e) {}
    items.push(textData);
  });
  var dataObject = {};

  if (props.dataKey.indexOf('.') > -1) {
    dataKey = props.dataKey.substring(0, props.dataKey.lastIndexOf('.'));
    dataKey = '//' + dataKey.replace(/\./, '/');
    items = JSON.search(items, dataKey);
    dataKey = props.dataKey.substring(props.dataKey.lastIndexOf('.') + 1);
  }
  console.log(items.length);

  if (props.filterKey) {
    _lodash2.default.remove(items, function (item) {
      return _lodash2.default.get(item, props.filterKey) === props.filterValue;
    });
  }

  items.forEach(function (item) {
    var key = props.dataKey || 'pubdate';
    if (props.period) {
      dataKey = 'period';
      item.period = moment(item[key])[props.period]();
    }
  });
  items.forEach(function (item) {
    var k = item[dataKey];
    if (!k) {
      k = 'N/A';
    }
    dataObject[k] = dataObject[k] || 0;
    dataObject[k] = dataObject[k] + 1;
  });
  var labels = (0, _keys2.default)(dataObject);
  if (props.sparse) {
    var sparseDataObject = {};
    var startDate = labels[0];
    var endDate = _lodash2.default.last(labels);
    var range = moment.range(startDate, endDate);
    var dates = (0, _from2.default)(range.by('year'));
    dates.shift();
    dates = dates.map(function (m) {
      return m.format('YYYY');
    });
    dates.forEach(function (date) {
      sparseDataObject[date] = dataObject[date] || 0;
    });
    dataObject = sparseDataObject;
    labels = (0, _keys2.default)(dataObject);
  }
  if (props.sort === 'key') {
    labels.sort();
  }
  if (props.sort === 'value') {
    labels.sort(function (a, b) {
      return dataObject[b] - dataObject[a];
    });
  }
  data = [];
  labels.forEach(function (label) {
    data.push(dataObject[label]);
  });

  var dataSet = {
    labels: labels,
    groupName: item.vtitle,
    datasets: [{
      label: props.legendLabel,
      borderColor: props.borderColor || props.backgroundColor,
      backgroundColor: props.backgroundColor,
      data: data
    }]
  };
  return dataSet;
}

function extractOptionColumns(table) {
  var options = {};
  var colNames = table[0].map(_lodash2.default.trim);
  colNames.forEach(function (colName, c) {
    if (colName.indexOf('$') === 0) {
      extractColumn(table, options, colName, c);
    }
  });
  return options;
}

function extractColumn(table, options, colName, c) {
  var column = [];
  var firstRow = table[0];
  if (_lodash2.default.isUndefined(colName)) {
    c = 0;
  }
  if (_lodash2.default.isUndefined(c)) {
    c = -1;
    for (var i = 0; i < firstRow.length; i++) {
      if (firstRow[i] === colName) {
        c = i;
      }
    }
    if (c === -1) {
      return {};
    }
  }
  firstRow.splice(c, 1);
  for (var r = 1; r < table.length; r++) {
    column.push(_lodash2.default.trim(table[r].splice(c, 1)));
  }
  options[colName] = column;
}

function dataTableToDataSet(dataTable) {
  var csvArray = _lodash2.default.cloneDeep(dataTable.arr);
  var title = dataTable.title;
  var options = extractOptionColumns(csvArray);
  var colors = options.$colors || defaultColors;
  var datasets = [];
  var labels = csvArray.splice(0, 1)[0];
  labels.splice(0, 1);
  labels = labels.map(_lodash2.default.trim);
  csvArray.forEach(function (d, i) {
    d = d.map(_lodash2.default.trim);
    var set = {};
    set.label = d.splice(0, 1)[0];
    set.borderColor = colors[i];
    set.backgroundColor = set.borderColor;
    set.pointBackgroundColor = set.borderColor;
    set.pointBorderColor = set.borderColor;
    set.data = d.map(function (item) {
      return +item;
    });
    set.fill = false;
    datasets.push(set);
  });
  return { datasets: datasets, labels: labels, title: title, colors: colors };
}

function charts(Vue) {
  function getChartOptions(type) {
    var chartOptions = {
      extends: _vueChartjs2.default[type],
      props: {
        dataSet: String,
        dataTable: String,
        group: String,
        groups: Array,
        title: String,
        col: String,
        gridLines: Boolean,
        board: Boolean,
        dataKey: String,
        sparse: Boolean,
        period: String,
        filterKey: String,
        filterValue: String,
        sort: String,
        h: Number,
        legendLabel: String,
        backgroundColor: String,
        borderColor: String,
        responsive: {
          type: Boolean,
          default: true
        }
      },
      computed: {
        height: function height() {
          if (!this.board) {
            return 400;
          }

          if (this.h) {
            return this.h;
          }
          var h = window.innerHeight;
          if (h) {
            h = h - 60;
          }
          return h || 400;
        },
        xdataSetFromGroup: function xdataSetFromGroup() {
          var _this = this;

          console.log(dataSetFromGroup);
          var group = this.group;
          var dataKey = this.dataKey;
          var data = this.$store.state.leodata;
          var textItems = this.$store.state.leotext;
          var item = JSON.search(data, '//*[group="' + group + '"]')[0];
          var children = item.children;
          var items = [];
          children.forEach(function (child) {
            var t = textItems[child.t];
            var textData = {};
            try {
              textData = JSON.parse(t);
            } catch (e) {}
            items.push(textData);
          });
          var dataObject = {};

          if (this.dataKey.indexOf('.') > -1) {
            dataKey = this.dataKey.substring(0, this.dataKey.lastIndexOf('.'));
            dataKey = '//' + dataKey.replace(/\./, '/');
            items = JSON.search(items, dataKey);
            dataKey = this.dataKey.substring(this.dataKey.lastIndexOf('.') + 1);
          }
          console.log(items.length);
          if (this.filterKey) {
            _lodash2.default.remove(items, function (item) {
              return _lodash2.default.get(item, _this.filterKey) === _this.filterValue;
            });
          }

          items.forEach(function (item) {
            var key = _this.dataKey || 'pubdate';
            if (_this.period) {
              dataKey = 'period';
              item.period = moment(item[key])[_this.period]();
            }
          });
          items.forEach(function (item) {
            var k = item[dataKey];
            if (!k) {
              k = 'N/A';
            }
            dataObject[k] = dataObject[k] || 0;
            dataObject[k] = dataObject[k] + 1;
          });
          var labels = (0, _keys2.default)(dataObject);
          if (this.sparse) {
            var sparseDataObject = {};
            var startDate = labels[0];
            var endDate = _lodash2.default.last(labels);
            var range = moment.range(startDate, endDate);
            var dates = (0, _from2.default)(range.by('year'));
            dates.shift();
            dates = dates.map(function (m) {
              return m.format('YYYY');
            });
            dates.forEach(function (date) {
              sparseDataObject[date] = dataObject[date] || 0;
            });
            dataObject = sparseDataObject;
            labels = (0, _keys2.default)(dataObject);
          }
          if (this.sort === 'key') {
            labels.sort();
          }
          if (this.sort === 'value') {
            labels.sort(function (a, b) {
              return dataObject[b] - dataObject[a];
            });
          }
          data = [];
          labels.forEach(function (label) {
            data.push(dataObject[label]);
          });

          var dataSet = {
            labels: labels,
            datasets: [{
              label: this.legendLabel,
              borderColor: this.borderColor || this.backgroundColor,
              backgroundColor: this.backgroundColor,
              data: data
            }]
          };
          return dataSet;
        }
      },
      mounted: function mounted() {
        var _this2 = this;

        var options = {
          responsive: this.responsive,
          maintainAspectRatio: false,
          layout: {
            padding: {
              left: 20,
              right: 20,
              top: 20,
              bottom: 20
            }
          },
          scales: {
            xAxes: [{
              gridLines: { display: this.gridLines },
              categoryPercentage: 0.9,
              barPercentage: 0.8,
              ticks: {
                beginAtZero: true,
                padding: 25
              }
            }],
            yAxes: [{
              gridLines: { display: this.gridLines },
              ticks: {
                beginAtZero: true,
                padding: 25
              }
            }]
          }
        };

        if (type === 'Pie') {
          delete options.scales;
        }
        if (type === 'Doughnut') {
          delete options.scales;
        }
        if (type === 'Polar') {
          delete options.scales;
        }
        var data = null;

        if (this.group) {
          data = dataSetFromGroup(this.group, this.$store.state.leodata, this.$store.state.leotext, this.$options.propsData);
        }
        if (this.groups) {
          data = dataSetFromGroups(this.groups, this.$store.state.leodata, this.$store.state.leotext, this.$options.propsData);
        }
        if (this.dataSet) {
          data = this.$store.state.dataSets[this.dataSet];
          if (!data) {
            data = window.parent.lconfig.dataSets[this.dataSet];
          }
        }
        if (this.dataTable) {
          var d = this.$store.state.dataTables[this.dataTable];
          if (!d) {
            d = window.parent.lconfig.dataTables[this.dataTable];
          }
          var dataArray = d.arr;
          if (this.col) {
            var colIndex = dataArray[0].findIndex(function (c) {
              return c === _this2.col;
            });
            var colData = dataArray.map(function (v) {
              return v[colIndex];
            });
            var colNames = dataArray.map(function (v) {
              return v[0];
            });
            colData.shift();
            colNames.shift();
            data = dataTableToDataSet(d);
            data.labels = colNames;
            data.datasets = [{
              data: colData,
              backgroundColor: data.colors,
              borderColor: data.colors
            }];

            if (type === 'Bar') {
              _lodash2.default.set(options, 'legend.display', false);
            }
          } else {
            data = dataTableToDataSet(d);
          }
        }
        options.title = {
          display: true,
          text: this.title || data.title || ''
        };
        this.renderChart(data, options);
      }
    };
    return chartOptions;
  }

  Vue.component('line-chart', getChartOptions('Line'));
  Vue.component('bar-chart', getChartOptions('Bar'));
  Vue.component('horizontalBar-chart', getChartOptions('HorizontalBar'));
  Vue.component('pie-chart', getChartOptions('Pie'));
  Vue.component('doughnut-chart', getChartOptions('Doughnut'));
  Vue.component('polar-chart', getChartOptions('PolarArea'));
}

exports.charts = charts;

/***/ }),

/***/ 2910:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {/*
 * defiant.js [v1.4.1]
 * http://www.defiantjs.com
 * Copyright (c) 2013-2017, Hakan Bilgin <hbi@longscript.com>
 * Licensed under the MIT License
 */
/*
 * x10.js v0.1.3
 * Web worker wrapper with simple interface
 *
 * Copyright (c) 2013-2015, Hakan Bilgin <hbi@longscript.com>
 * Licensed under the MIT License
 */

(function(window, undefined) {
  //'use strict';

  var x10 = {
    init: function() {
      return this;
    },
    work_handler: function(event) {
      var args = Array.prototype.slice.call(event.data, 1),
        func = event.data[0],
        ret  = tree[func].apply(tree, args);

      // return process finish
      postMessage([func, ret]);
    },
    setup: function(tree) {
      var url    = window.URL || window.webkitURL,
        script = 'var tree = {'+ this.parse(tree).join(',') +'};',
        blob   = new Blob([script + 'self.addEventListener("message", '+ this.work_handler.toString() +', false);'],
          {type: 'text/javascript'}),
        worker = new Worker(url.createObjectURL(blob));

      // thread pipe
      worker.onmessage = function(event) {
        var args = Array.prototype.slice.call(event.data, 1),
          func = event.data[0];
        x10.observer.emit('x10:'+ func, args);
      };

      return worker;
    },
    call_handler: function(func, worker) {
      return function() {
        var args = Array.prototype.slice.call(arguments, 0, -1),
          callback = arguments[arguments.length-1];

        // add method name
        args.unshift(func);

        // listen for 'done'
        x10.observer.on('x10:'+ func, function(event) {
          callback(event.detail[0]);
        });

        // start worker
        worker.postMessage(args);
      };
    },
    compile: function(hash) {
      var worker = this.setup(typeof(hash) === 'function' ? {func: hash} : hash),
        obj    = {},
        fn;
      // create return object
      if (typeof(hash) === 'function') {
        obj.func = this.call_handler('func', worker);
        return obj.func;
      } else {
        for (fn in hash) {
          obj[fn] = this.call_handler(fn, worker);
        }
        return obj;
      }
    },
    parse: function(tree, isArray) {
      var hash = [],
        key,
        val,
        v;

      for (key in tree) {
        v = tree[key];
        // handle null
        if (v === null) {
          hash.push(key +':null');
          continue;
        }
        // handle undefined
        if (v === undefined) {
          hash.push(key +':undefined');
          continue;
        }
        switch (v.constructor) {
          case Date:     val = 'new Date('+ v.valueOf() +')';           break;
          case Object:   val = '{'+ this.parse(v).join(',') +'}';       break;
          case Array:    val = '['+ this.parse(v, true).join(',') +']'; break;
          case String:   val = '"'+ v.replace(/"/g, '\\"') +'"';        break;
          case RegExp:
          case Function: val = v.toString();                            break;
          default:       val = v;
        }
        if (isArray) hash.push(val);
        else hash.push(key +':'+ val);
      }
      return hash;
    },
    // simple event emitter
    observer: (function() {
      var stack = {};

      return {
        on: function(type, fn) {
          if (!stack[type]) {
            stack[type] = [];
          }
          stack[type].unshift(fn);
        },
        off: function(type, fn) {
          if (!stack[type]) return;
          var i = stack[type].indexOf(fn);
          stack[type].splice(i,1);
        },
        emit: function(type, detail) {
          if (!stack[type]) return;
          var event = {
              type         : type,
              detail       : detail,
              isCanceled   : false,
              cancelBubble : function() {
                this.isCanceled = true;
              }
            },
            len = stack[type].length;
          while(len--) {
            if (event.isCanceled) return;
            stack[type][len](event);
          }
        }
      };
    })()
  };

  if (false) {
    // publish x10
    window.x10 = x10.init();
  } else {
    module.exports = x10.init();
  }

})(this);


(function(window, module, undefined) {
  'use strict';

  var Defiant = {
    is_ie     : /(msie|trident)/i.test(navigator.userAgent),
    is_safari : /safari/i.test(navigator.userAgent),
    env       : 'production',
    xml_decl  : '<?xml version="1.0" encoding="utf-8"?>',
    namespace : 'xmlns:d="defiant-namespace"',
    tabsize   : 4,
    render: function(template, data) {
      var processor = new XSLTProcessor(),
        span      = document.createElement('span'),
        opt       = {match: '/'},
        tmpltXpath,
        scripts,
        temp,
        sorter;
      // handle arguments
      switch (typeof(template)) {
        case 'object':
          this.extend(opt, template);
          if (!opt.data) opt.data = data;
          break;
        case 'string':
          opt.template = template;
          opt.data = data;
          break;
        default:
          throw 'error';
      }
      opt.data = JSON.toXML(opt.data);
      tmpltXpath = '//xsl:template[@name="'+ opt.template +'"]';

      if (!this.xsl_template) this.gatherTemplates();

      if (opt.sorter) {
        sorter = this.node.selectSingleNode(this.xsl_template, tmpltXpath +'//xsl:for-each//xsl:sort');
        if (sorter) {
          if (opt.sorter.order) sorter.setAttribute('order', opt.sorter.order);
          if (opt.sorter.select) sorter.setAttribute('select', opt.sorter.select);
          sorter.setAttribute('data-type', opt.sorter.type || 'text');
        }
      }

      temp = this.node.selectSingleNode(this.xsl_template, tmpltXpath);
      temp.setAttribute('match', opt.match);
      processor.importStylesheet(this.xsl_template);
      span.appendChild(processor.transformToFragment(opt.data, document));
      temp.removeAttribute('match');

      if (this.is_safari) {
        scripts = span.getElementsByTagName('script');
        for (var i=0, il=scripts.length; i<il; i++) scripts[i].defer = true;
      }
      return span.innerHTML;
    },
    gatherTemplates: function() {
      var scripts = document.getElementsByTagName('script'),
        str     = '',
        i       = 0,
        il      = scripts.length;
      for (; i<il; i++) {
        if (scripts[i].type === 'defiant/xsl-template') str += scripts[i].innerHTML;
      }
      this.xsl_template = this.xmlFromString('<xsl:stylesheet version="1.0" xmlns:xsl="http://www.w3.org/1999/XSL/Transform" '+ this.namespace +'>'+ str.replace(/defiant:(\w+)/g, '$1') +'</xsl:stylesheet>');
    },
    getSnapshot: function(data, callback) {
      return JSON.toXML(data, callback || true);
    },
    xmlFromString: function(str) {
      var parser,
        doc;
      str = str.replace(/>\s{1,}</g, '><');
      if (str.trim().match(/<\?xml/) === null) {
        str = this.xml_decl + str;
      }
      if (typeof(ActiveXObject) != 'undefined') {
        doc = new ActiveXObject('Msxml2.DOMDocument');
        doc.loadXML(str);
        if (str.indexOf('xsl:stylesheet') === -1) {
          doc.setProperty('SelectionLanguage', 'XPath');
        }
      } else {
        parser = new DOMParser();
        doc = parser.parseFromString(str, 'text/xml');
      }
      return doc;
    },
    extend: function(src, dest) {
      for (var content in dest) {
        if (!src[content] || typeof(dest[content]) !== 'object') {
          src[content] = dest[content];
        } else {
          this.extend(src[content], dest[content]);
        }
      }
      return src;
    },
    node: {}
  };

  // Export
  window.Defiant = module.exports = Defiant;

})(
  typeof window !== 'undefined' ? window : {},
   true ? module : {}
);


if (typeof(XSLTProcessor) === 'undefined') {

  // emulating XSLT Processor (enough to be used in defiant)
  var XSLTProcessor = function() {};
  XSLTProcessor.prototype = {
    importStylesheet: function(xsldoc) {
      this.xsldoc = xsldoc;
    },
    transformToFragment: function(data, doc) {
      var str = data.transformNode(this.xsldoc),
        span = document.createElement('span');
      span.innerHTML = str;
      return span;
    }
  };

} else if (typeof(XSLTProcessor) !== 'function' && !XSLTProcessor) {

  // throw error
  throw 'XSLTProcessor transformNode not implemented';

}


// extending STRING
if (!String.prototype.fill) {
  String.prototype.fill = function(i,c) {
    var str = this;
    c = c || ' ';
    for (; str.length<i; str+=c){}
    return str;
  };
}

if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/gm, '');
  };
}

if (!String.prototype.xTransform) {
  String.prototype.xTransform = function () {
    var str = this;
    if (this.indexOf('translate(') === -1) {
      str = this.replace(/contains\(([^,]+),([^\\)]+)\)/g, function(c,h,n) {
        var a = 'abcdefghijklmnopqrstuvwxyz';
        return "contains(translate("+ h +", \""+ a.toUpperCase() +"\", \""+ a +"\"),"+ n.toLowerCase() +")";
      });
    }
    return str.toString();
  };
}

/* jshint ignore:start */
if (typeof(JSON) === 'undefined') {
  window.JSON = {
    parse: function (sJSON) { return eval("(" + sJSON + ")"); },
    stringify: function (vContent) {
      if (vContent instanceof Object) {
        var sOutput = "";
        if (vContent.constructor === Array) {
          for (var nId = 0; nId < vContent.length; sOutput += this.stringify(vContent[nId]) + ",", nId++);
          return "[" + sOutput.substr(0, sOutput.length - 1) + "]";
        }
        if (vContent.toString !== Object.prototype.toString) {
          return "\"" + vContent.toString().replace(/"/g, "\\$&") + "\"";
        }
        for (var sProp in vContent) {
          sOutput += "\"" + sProp.replace(/"/g, "\\$&") + "\":" + this.stringify(vContent[sProp]) + ",";
        }
        return "{" + sOutput.substr(0, sOutput.length - 1) + "}";
      }
      return typeof vContent === "string" ? "\"" + vContent.replace(/"/g, "\\$&") + "\"" : String(vContent);
    }
  };
}
/* jshint ignore:end */

if (!JSON.toXML) {
  JSON.toXML = function(tree, callback) {
    'use strict';

    var interpreter = {
        map              : [],
        rx_validate_name : /^(?!xml)[a-z_][\w\d.:]*$/i,
        rx_node          : /<(.+?)( .*?)>/,
        rx_constructor   : /<(.+?)( d:contr=".*?")>/,
        rx_namespace     : / xmlns\:d="defiant\-namespace"/,
        rx_data          : /(<.+?>)(.*?)(<\/d:data>)/i,
        rx_function      : /function (\w+)/i,
        namespace        : 'xmlns:d="defiant-namespace"',
        to_xml_str: function(tree) {
          return {
            str: this.hash_to_xml(null, tree),
            map: this.map
          };
        },
        hash_to_xml: function(name, tree, array_child) {
          var is_array = tree.constructor === Array,
            self = this,
            elem = [],
            attr = [],
            key,
            val,
            val_is_array,
            type,
            is_attr,
            cname,
            constr,
            cnName,
            i,
            il,
            fn = function(key, tree) {
              val = tree[key];
              if (val === null || val === undefined || val.toString() === 'NaN') val = null;

              is_attr = key.slice(0,1) === '@';
              cname   = array_child ? name : key;
              if (cname == +cname && tree.constructor !== Object) cname = 'd:item';
              if (val === null) {
                constr = null;
                cnName = false;
              } else {
                constr = val.constructor;
                cnName = constr.toString().match(self.rx_function)[1];
              }

              if (is_attr) {
                attr.push( cname.slice(1) +'="'+ self.escape_xml(val) +'"' );
                if (cnName !== 'String') attr.push( 'd:'+ cname.slice(1) +'="'+ cnName +'"' );
              } else if (val === null) {
                elem.push( self.scalar_to_xml( cname, val ) );
              } else {
                switch (constr) {
                  case Function:
                    // if constructor is function, then it's not a JSON structure
                    throw 'JSON data should not contain functions. Please check your structure.';
                  /* falls through */
                  case Object:
                    elem.push( self.hash_to_xml( cname, val ) );
                    break;
                  case Array:
                    if (key === cname) {
                      val_is_array = val.constructor === Array;
                      if (val_is_array) {
                        i = val.length;
                        while (i--) {
                          if (val[i] === null || !val[i] || val[i].constructor === Array) val_is_array = true;
                          if (!val_is_array && val[i].constructor === Object) val_is_array = true;
                        }
                      }
                      elem.push( self.scalar_to_xml( cname, val, val_is_array ) );
                      break;
                    }
                  /* falls through */
                  case String:
                    if (typeof(val) === 'string') {
                      val = val.toString().replace(/\&/g, '&amp;')
                        .replace(/\r|\n/g, '&#13;');
                    }
                    if (cname === '#text') {
                      // prepare map
                      self.map.push(tree);
                      attr.push('d:mi="'+ self.map.length +'"');
                      attr.push('d:constr="'+ cnName +'"');
                      elem.push( self.escape_xml(val) );
                      break;
                    }
                  /* falls through */
                  case Number:
                  case Boolean:
                    if (cname === '#text' && cnName !== 'String') {
                      // prepare map
                      self.map.push(tree);
                      attr.push('d:mi="'+ self.map.length +'"');
                      attr.push('d:constr="'+ cnName +'"');
                      elem.push( self.escape_xml(val) );
                      break;
                    }
                    elem.push( self.scalar_to_xml( cname, val ) );
                    break;
                }
              }
            };
          if (tree.constructor === Array) {
            i = 0;
            il = tree.length;
            for (; i<il; i++) {
              fn(i.toString(), tree);
            }
          } else {
            for (key in tree) {
              fn(key, tree);
            }
          }
          if (!name) {
            name = 'd:data';
            attr.push(this.namespace);
            if (is_array) attr.push('d:constr="Array"');
          }
          if (name.match(this.rx_validate_name) === null) {
            attr.push( 'd:name="'+ name +'"' );
            name = 'd:name';
          }
          if (array_child) return elem.join('');
          // prepare map
          this.map.push(tree);
          attr.push('d:mi="'+ this.map.length +'"');

          return '<'+ name + (attr.length ? ' '+ attr.join(' ') : '') + (elem.length ? '>'+ elem.join('') +'</'+ name +'>' : '/>' );
        },
        scalar_to_xml: function(name, val, override) {
          var attr = '',
            text,
            constr,
            cnName;

          // check whether the nodename is valid
          if (name.match(this.rx_validate_name) === null) {
            attr += ' d:name="'+ name +'"';
            name = 'd:name';
            override = false;
          }
          if (val === null || val.toString() === 'NaN') val = null;
          if (val === null) return '<'+ name +' d:constr="null"/>';
          if (val.length === 1 && val.constructor === Array && !val[0]) {
            return '<'+ name +' d:constr="null" d:type="ArrayItem"/>';
          }
          if (val.length === 1 && val[0].constructor === Object) {

            text = this.hash_to_xml(false, val[0]);

            var a1 = text.match(this.rx_node),
              a2 = text.match(this.rx_constructor);
            a1 = (a1 !== null)? a1[2]
              .replace(this.rx_namespace, '')
              .replace(/>/, '')
              .replace(/"\/$/, '"') : '';
            a2 = (a2 !== null)? a2[2] : '';

            text = text.match(this.rx_data);
            text = (text !== null)? text[2] : '';

            return '<'+ name + a1 +' '+ a2 +' d:type="ArrayItem">'+ text +'</'+ name +'>';
          } else if (val.length === 0 && val.constructor === Array) {
            return '<'+ name +' d:constr="Array"/>';
          }
          // else
          if (override) {
            return this.hash_to_xml( name, val, true );
          }

          constr = val.constructor;
          cnName = constr.toString().match(this.rx_function)[1];
          text = (constr === Array)   ? this.hash_to_xml( 'd:item', val, true )
            : this.escape_xml(val);

          attr += ' d:constr="'+ cnName +'"';
          // prepare map
          this.map.push(val);
          attr += ' d:mi="'+ this.map.length +'"';

          return (name === '#text') ? this.escape_xml(val) : '<'+ name + attr +'>'+ text +'</'+ name +'>';
        },
        escape_xml: function(text) {
          return String(text) .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/&nbsp;/g, '&#160;');
        }
      },
      processed,
      doc,
      task;
    // depending on request
    switch (typeof callback) {
      case 'function':
        // compile interpreter with 'x10.js'
        task = x10.compile(interpreter);

        // parse in a dedicated thread
        task.to_xml_str(tree, function(processed) {
          // snapshot distinctly improves performance
          callback({
            doc: Defiant.xmlFromString(processed.str),
            src: tree,
            map: processed.map
          });
        });
        return;
      case 'boolean':
        processed = interpreter.to_xml_str.call(interpreter, tree);
        // return snapshot
        return {
          doc: Defiant.xmlFromString(processed.str),
          src: tree,
          map: processed.map
        };
      default:
        processed = interpreter.to_xml_str.call(interpreter, tree);
        doc = Defiant.xmlFromString(processed.str);

        this.search.map = processed.map;
        return doc;
    }
  };
}


if (!JSON.search) {
  JSON.search = function(tree, xpath, single) {
    'use strict';

    var isSnapshot = tree.doc && tree.doc.nodeType,
      doc        = isSnapshot ? tree.doc : JSON.toXML(tree),
      map        = isSnapshot ? tree.map : this.search.map,
      src        = isSnapshot ? tree.src : tree,
      xres       = Defiant.node[ single ? 'selectSingleNode' : 'selectNodes' ](doc, xpath.xTransform()),
      ret        = [],
      mapIndex,
      i;

    if (single) xres = [xres];
    i = xres.length;

    while (i--) {
      switch(xres[i].nodeType) {
        case 2:
        case 3:
          ret.unshift( xres[i].nodeValue );
          break;
        default:
          mapIndex = +xres[i].getAttribute('d:mi');
          //if (map[mapIndex-1] !== false) {
          ret.unshift( map[mapIndex-1] );
        //}
      }
    }

    // if environment = development, add search tracing
    if (Defiant.env === 'development') {
      this.trace = JSON.mtrace(src, ret, xres);
    }

    return ret;
  };
}

if (!JSON.mtrace) {
  JSON.mtrace = function(root, hits, xres) {
    'use strict';

    var win       = window,
      stringify = JSON.stringify,
      sroot     = stringify( root, null, '\t' ).replace(/\t/g, ''),
      trace     = [],
      i         = 0,
      il        = xres.length,
      od        = il ? xres[i].ownerDocument.documentElement : false,
      map       = this.search.map,
      hstr,
      cConstr,
      fIndex = 0,
      mIndex,
      lStart,
      lEnd;

    for (; i<il; i++) {
      switch (xres[i].nodeType) {
        case 2:
          cConstr = xres[i].ownerElement ? xres[i].ownerElement.getAttribute('d:'+ xres[i].nodeName) : 'String';
          hstr    = '"@'+ xres[i].nodeName +'": '+ win[ cConstr ]( hits[i] );
          mIndex  = sroot.indexOf(hstr);
          lEnd    = 0;
          break;
        case 3:
          cConstr = xres[i].parentNode.getAttribute('d:constr');
          hstr    = win[ cConstr ]( hits[i] );
          hstr    = '"'+ xres[i].parentNode.nodeName +'": '+ (hstr === 'Number' ? hstr : '"'+ hstr +'"');
          mIndex  = sroot.indexOf(hstr);
          lEnd    = 0;
          break;
        default:
          if (xres[i] === od) continue;
          if (xres[i].getAttribute('d:constr') === 'String' || xres[i].getAttribute('d:constr') === 'Number') {
            cConstr = xres[i].getAttribute('d:constr');
            hstr    = win[ cConstr ]( hits[i] );
            mIndex  = sroot.indexOf(hstr, fIndex);
            hstr    = '"'+ xres[i].nodeName +'": '+ (cConstr === 'Number' ? hstr : '"'+ hstr +'"');
            lEnd    = 0;
            fIndex  = mIndex + 1;
          } else {
            hstr   = stringify( hits[i], null, '\t' ).replace(/\t/g, '');
            mIndex = sroot.indexOf(hstr);
            lEnd   = hstr.match(/\n/g).length;
          }
      }
      lStart = sroot.substring(0,mIndex).match(/\n/g).length+1;
      trace.push([lStart, lEnd]);
    }

    return trace;
  };
}

Defiant.node.selectNodes = function(XNode, XPath) {
  if (XNode.evaluate) {
    var ns = XNode.createNSResolver(XNode.documentElement),
      qI = XNode.evaluate(XPath, XNode, ns, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null),
      res = [],
      i   = 0,
      il  = qI.snapshotLength;
    for (; i<il; i++) {
      res.push( qI.snapshotItem(i) );
    }
    return res;
  } else {
    return XNode.selectNodes(XPath);
  }
};
Defiant.node.selectSingleNode = function(XNode, XPath) {
  if (XNode.evaluate) {
    var xI = this.selectNodes(XNode, XPath);
    return (xI.length > 0)? xI[0] : null;
  } else {
    return XNode.selectSingleNode(XPath);
  }
};


Defiant.node.prettyPrint = function(node) {
  var root = Defiant,
    tabs = root.tabsize,
    decl = root.xml_decl.toLowerCase(),
    ser,
    xstr;
  if (root.is_ie) {
    xstr = node.xml;
  } else {
    ser  = new XMLSerializer();
    xstr = ser.serializeToString(node);
  }
  if (root.env !== 'development') {
    // if environment is not development, remove defiant related info
    xstr = xstr.replace(/ \w+\:d=".*?"| d\:\w+=".*?"/g, '');
  }
  var str    = xstr.trim().replace(/(>)\s*(<)(\/*)/g, '$1\n$2$3'),
    lines  = str.split('\n'),
    indent = -1,
    i      = 0,
    il     = lines.length,
    start,
    end;
  for (; i<il; i++) {
    if (i === 0 && lines[i].toLowerCase() === decl) continue;
    start = lines[i].match(/<[A-Za-z_\:]+.*?>/g) !== null;
    //start = lines[i].match(/<[^\/]+>/g) !== null;
    end   = lines[i].match(/<\/[\w\:]+>/g) !== null;
    if (lines[i].match(/<.*?\/>/g) !== null) start = end = true;
    if (start) indent++;
    lines[i] = String().fill(indent, '\t') + lines[i];
    if (start && end) indent--;
    if (!start && end) indent--;
  }
  return lines.join('\n').replace(/\t/g, String().fill(tabs, ' '));
};


Defiant.node.toJSON = function(xnode, stringify) {
  'use strict';

  var interpret = function(leaf) {
      var obj = {},
        win = window,
        attr,
        type,
        item,
        cname,
        cConstr,
        cval,
        text,
        i, il, a;

      switch (leaf.nodeType) {
        case 1:
          cConstr = leaf.getAttribute('d:constr');
          if (cConstr === 'Array') obj = [];
          else if (cConstr === 'String' && leaf.textContent === '') obj = '';

          attr = leaf.attributes;
          i = 0;
          il = attr.length;
          for (; i<il; i++) {
            a = attr.item(i);
            if (a.nodeName.match(/\:d|d\:/g) !== null) continue;

            cConstr = leaf.getAttribute('d:'+ a.nodeName);
            if (cConstr && cConstr !== 'undefined') {
              if (a.nodeValue === 'null') cval = null;
              else cval = win[ cConstr ]( (a.nodeValue === 'false') ? '' : a.nodeValue );
            } else {
              cval = a.nodeValue;
            }
            obj['@'+ a.nodeName] = cval;
          }
          break;
        case 3:
          type = leaf.parentNode.getAttribute('d:type');
          cval = (type) ? win[ type ]( leaf.nodeValue === 'false' ? '' : leaf.nodeValue ) : leaf.nodeValue;
          obj = cval;
          break;
      }
      if (leaf.hasChildNodes()) {
        i = 0;
        il = leaf.childNodes.length;
        for(; i<il; i++) {
          item  = leaf.childNodes.item(i);
          cname = item.nodeName;
          attr  = leaf.attributes;

          if (cname === 'd:name') {
            cname = item.getAttribute('d:name');
          }
          if (cname === '#text') {
            cConstr = leaf.getAttribute('d:constr');
            if (cConstr === 'undefined') cConstr = undefined;
            text = item.textContent || item.text;
            cval = cConstr === 'Boolean' && text === 'false' ? '' : text;

            if (!cConstr && !attr.length) obj = cval;
            else if (cConstr && il === 1) {
              obj = win[cConstr](cval);
            } else if (!leaf.hasChildNodes()) {
              obj[cname] = (cConstr)? win[cConstr](cval) : cval;
            } else {
              if (attr.length < 3) obj = (cConstr)? win[cConstr](cval) : cval;
              else obj[cname] = (cConstr)? win[cConstr](cval) : cval;
            }
          } else {
            if (item.getAttribute('d:constr') === 'null') {
              if (obj[cname] && obj[cname].push) obj[cname].push(null);
              else if (item.getAttribute('d:type') === 'ArrayItem') obj[cname] = [obj[cname]];
              else obj[cname] = null;
              continue;
            }
            if (obj[cname]) {
              if (obj[cname].push) obj[cname].push(interpret(item));
              else obj[cname] = [obj[cname], interpret(item)];
              continue;
            }
            cConstr = item.getAttribute('d:constr');
            switch (cConstr) {
              case 'null':
                if (obj.push) obj.push(null);
                else obj[cname] = null;
                break;
              case 'Array':
                //console.log( Defiant.node.prettyPrint(item) );
                if (item.parentNode.firstChild === item && cConstr === 'Array' && cname !== 'd:item') {
                  if (cname === 'd:item' || cConstr === 'Array') {
                    cval = interpret(item);
                    obj[cname] = cval.length ? [cval] : cval;
                  } else {
                    obj[cname] = interpret(item);
                  }
                }
                else if (obj.push) obj.push( interpret(item) );
                else obj[cname] = interpret(item);
                break;
              case 'String':
              case 'Number':
              case 'Boolean':
                text = item.textContent || item.text;
                cval = cConstr === 'Boolean' && text === 'false' ? '' : text;

                if (obj.push) obj.push( win[cConstr](cval) );
                else obj[cname] = interpret(item);
                break;
              default:
                if (obj.push) obj.push( interpret( item ) );
                else obj[cname] = interpret( item );
            }
          }
        }
      }
      if (leaf.nodeType === 1 && leaf.getAttribute('d:type') === 'ArrayItem') {
        obj = [obj];
      }
      return obj;
    },
    node = (xnode.nodeType === 9) ? xnode.documentElement : xnode,
    ret  = interpret(node),
    rn   = ret[node.nodeName];

  // exclude root, if "this" is root node
  if (node === node.ownerDocument.documentElement && rn && rn.constructor === Array) {
    ret = rn;
  }
  if (stringify && stringify.toString() === 'true') stringify = '\t';
  return stringify ? JSON.stringify(ret, null, stringify) : ret;
};


// check if jQuery is present
if (typeof(jQuery) !== 'undefined') {
  (function ( $ ) {
    'use strict';

    $.fn.defiant = function(template, xpath) {
      this.html( Defiant.render(template, xpath) );
      return this;
    };

  }(jQuery));
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(105)(module)))

/***/ }),

/***/ 2911:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  function sdrag(onDrag, onStop, direction) {
    var startX = 0;
    var startY = 0;
    var el = this;
    var dragging = false;

    function move(e) {
      var fix = {};
      onDrag && onDrag(el, e.pageX, startX, e.pageY, startY, fix);
      if ('vertical' !== direction) {
        var pageX = 'pageX' in fix ? fix.pageX : e.pageX;
        if ('startX' in fix) {
          startX = fix.startX;
        }
        if (false === 'skipX' in fix) {
          el.style.left = pageX - startX + 'px';
        }
      }
      if ('horizontal' !== direction) {
        var pageY = 'pageY' in fix ? fix.pageY : e.pageY;
        if ('startY' in fix) {
          startY = fix.startY;
        }
        if (false === 'skipY' in fix) {
          el.style.top = pageY - startY + 'px';
        }
      }
    }

    function startDragging(e) {
      if (e.currentTarget instanceof HTMLElement || e.currentTarget instanceof SVGElement) {
        dragging = true;
        var left = el.style.left ? parseInt(el.style.left) : 0;
        var top = el.style.top ? parseInt(el.style.top) : 0;
        startX = e.pageX - left;
        startY = e.pageY - top;
        window.addEventListener('mousemove', move);
      } else {
        throw new Error('Your target must be an html element');
      }
    }

    this.addEventListener('mousedown', startDragging);
    window.addEventListener('mouseup', function (e) {
      if (true === dragging) {
        dragging = false;
        window.removeEventListener('mousemove', move);
        onStop && onStop(el, e.pageX, startX, e.pageY, startY);
      }
    });
  }

  Element.prototype.sdrag = sdrag;
})();

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

var _jsYaml = __webpack_require__(143);

var _jsYaml2 = _interopRequireDefault(_jsYaml);

var _lodashTemplate = __webpack_require__(232);

var _lodashTemplate2 = _interopRequireDefault(_lodashTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hljs = __webpack_require__(233);

var md = __webpack_require__(146)({
  html: true,
  linkify: true,
  typographer: true
});

function replaceRelUrls(html, base) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(html, 'text/html');
  var images = doc.images;
  for (var i = 0; i < images.length; i++) {
    var image = images[i];
    var src = image.getAttribute('src');
    if (/http:/.test(src)) {
      return html;
    }
    if (/https:/.test(src)) {
      return html;
    }
    if (/^\//.test(src)) {
      src = base + src;
    } else {
      src = base + '/' + src;
    }
    image.setAttribute('src', src);
  }
  return doc.body.innerHTML;
}

function getFileExtension(filename) {
  var re = /(?:\.([^.]+))?$/;
  var ext = re.exec(filename)[1];
  return ext;
}

function getLanguage(text) {
  var language = '';
  var re = /^@language (\w+)/;
  var languageTokens = re.exec(text);
  if (languageTokens) {
    language = languageTokens[1];
  }
  return language;
}

function removeFirstLine(text) {
  return text.split(/[\n]/).splice(1).join('\n');
}

function parseQueryString(config, url) {
  var urlParams = {};
  url.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function ($0, $1, $2, $3) {
    urlParams[$1] = $3;
  });
  for (var k in urlParams) {
    var v = urlParams[k];
    if (/#/.test(v)) {
      v = v.substring(0, v.indexOf('#'));
    }
    if (typeof v !== 'undefined') {
      config[k] = v.replace(/%2F/g, '/').replace(/%27/g, "'");
    }
  }
  var hash = window.location.hash;
  var baseMode = 't';
  if (window.lconfig.baseMode) {
    baseMode = window.lconfig.baseMode;
  }
  if (!hash || hash.length < 3) {}
  return urlParams;
}

function formatText(text, noWrapper, title) {
  if (!text) {
    return '';
  }
  var language = getLanguage(text);

  text = text.replace(/<<(.*?)>>/g, '<sectionlink :title="\'$1\'"/>');

  text = text.replace(/\[\[(.*?)\]\]/g, '<nodelink :title="\'$1\'"/>');

  if (!language) {
    language = 'plaintext';
  }

  if (/^\s*?@/.test(text)) {
    text = removeFirstLine(text);
  }
  if (title) {
    text = title + text;
  }
  var mu = '';
  var muv = null;
  switch (language) {
    case 'yaml':
      var data = _jsYaml2.default.load(text.replace('@language yaml', ''));
      console.log('YAML DATA..........', data);
      var template = _lodash2.default.get(data, 'params.template', '');
      text = _lodashTemplate2.default.render(data, template);
      break;
    case 'text':
      text = '<div class="text">' + text + '</div>';
      break;
    case 'plaintext':
      text = '<div class="text">' + text + '</div>';
      break;
    case 'md':
      text = md.render(text);
      text = text.replace(/src="https:.*?https:/g, 'src="https:');
      break;
    case 'pug':
      text = window.pug.render(text);
    case 'python':
      text = processPython(text);
      break;
    case 'html':
      text = text.replace(/(@docs|others)/g, '<span class="directive" title="Leo Directive - does not appear in source file.">$1</span>');
      break;
    case 'htmlsource':
      muv = hljs.highlight('html', text);
      text = muv.value;
      text = text.replace(/(@\w+)/, '<span class="directive" title="Leo Directive - does not appear in source file.">$1</span>');
      text = text.replace(/@others/g, '<span class="directive" title="Leo Directive: rest of tree goes here.">@others</span>');
      text = '<pre>' + text + '</pre>';

      var re = /<span class="hljs-tag">&lt;<span class="hljs-name">sectionlink<\/span> <span class="hljs-attr">:title<\/span>=<span class="hljs-string">"' (.*?) '"<\/span>\/&gt;<\/span>/g;
      var sl = '<sectionlink :title="\' $1 \'"/>';
      text = text.replace(re, sl);
      break;
    case 'VueComponent':
      muv = hljs.highlight('javascript', text);
      text = muv.value;
      text = '<pre>' + text + '</pre>';
      break;
    default:
      text = hiliteCode(text, language);
      text = '<div class="hcode">' + text + '</div>';
  }
  if (noWrapper) {
    return text;
  }
  text = '<div class=\'content\'>' + text + '</div>';
  return text;
}
function toTitleCase(str) {
  return str.replace(/\w*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function sendGTag(item) {
  if (typeof gtag === 'undefined') {
    return;
  }
  if (!item) {
    console.log('No item in GTAG');
    return;
  }
  gtag('config', 'UA-118289537-1', {
    'page_title': item.name,
    'page_path': '#/t/' + item.id,
    't': item.t
  });
}

function chop(s, c) {
  if (s.indexOf(c) < 0) {
    return s;
  }
  return s.substring(0, s.lastIndexOf(c));
}

function hiliteCode(text, language) {
  text = text.replace(/<sectionlink :title="'(.*?)'"\/>/g, '«$1»');
  text = text.replace(/<sectionlink title="(.*?)"\/>/g, '«$1»');
  var mu = hljs.highlight(language, text);
  text = mu.value;
  text = '<pre v-pre>' + text + '</pre>';
  text = text.replace(/«(.*?)»/g, '<span class="csection-link">«$1»</span>');
  return text;
}

function processPython(t) {
  var a = t.split(/\n/);
  var b = [];
  var c = [];
  var buffer = '';
  var inDocString = false;
  a.forEach(function (line) {
    if (/'''/.test(line)) {
      inDocString = !inDocString;
      if (!inDocString) {
        c = c.map(function (line) {
          return line.replace(/^\s*?\|/g, '').replace(/</g, '&lt;').replace(/>/, '&gt;').replace(/^\s*?#/, '');
        });
        var docString = c.join('\n');
        docString = md.render(docString);
        b.push(docString);
        c = [];
      } else {
        buffer = hiliteCode(buffer, 'python');
        b.push(buffer);
        buffer = '';
      }
      return;
    }
    if (inDocString) {
      return c.push(line);
    }

    buffer = buffer + '\n' + line;
  });
  t = b.join('') + hiliteCode(buffer, 'python');
  return t;
}

function processSingleDocstring(t) {
  if (/"""/.test(t)) {}
  return t;
}

function processDocstring(t) {
  if (/'''/.test(t)) {
    t = t.replace(/'''/, '</pre>');
    t = t.replace(/'''/, '<pre>');
    t = t.replace(/\|/g, '');
    t = md.render(t);
  }
  return t;
}

function getObjectByKeyFromTree(d, k, v) {
  k = k + '';
  if (d[k].indexOf(v) > -1) {
    return d;
  }
  if (!d.children) {
    return '';
  }
  for (var i = 0; i < d.children.length; i++) {
    var o = getObjectByKeyFromTree(d.children[i], k, v);
    if (o) {
      return o;
    }
  }
}

function getNodePath(leodata, node, p) {
  p = p ? ' / ' + p : '';
  if (!node.parentId) {
    return p;
  }
  var parentNode = JSON.search(leodata, '//*[id="' + node.parentId + '"]')[0];
  var parentId = parentNode && parentNode.parentId || null;
  p = parentNode.vtitle + p;
  return parentId ? getNodePath(leodata, parentNode, p) : p;
}

module.exports = {
  replaceRelUrls: replaceRelUrls,
  getFileExtension: getFileExtension,
  getLanguage: getLanguage,
  removeFirstLine: removeFirstLine,
  parseQueryString: parseQueryString,
  formatText: formatText,
  getObjectByKeyFromTree: getObjectByKeyFromTree,
  sendGTag: sendGTag,
  chop: chop,
  toTitleCase: toTitleCase,
  getNodePath: getNodePath
};

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'settings',
  components: {},
  methods: {
    main: function main() {
      this.$router.replace({ path: '/' });
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    id: function id() {
      if (!this.$route.params.id) {
        return +1;
      } else {
        return this.$route.params.id;
      }
    },
    staticSite: function staticSite() {
      if (window.lconfig.staticSite) {
        return true;
      }
      return false;
    }
  },
  watch: {
    '$route': function $route(to, from) {}
  }
};

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Item = __webpack_require__(85);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var target = { el: null };
exports.default = {
  name: 'accordionviewer',
  props: {},
  components: {
    item: _Item2.default
  },
  data: function data() {
    return {
      target: target,
      open: false,
      active: false,
      lhandle: true
    };
  },
  methods: {
    getTop: function getTop(index) {
      if (!index) {
        return this.top;
      }
    }
  },
  watch: {
    '$route': {
      handler: function handler(val, oldVal, changed) {},
      immediate: true
    }
  },
  computed: {
    data: function data() {
      return this.$store.state.leodata;
    },
    text: function text() {
      return this.$store.state.leotext;
    },
    ulStyle: function ulStyle() {
      var p = window.lconfig.leftPanePadding || '0';
      return 'padding-left:' + p;
    },
    top: function top() {
      if (window.lconfig.firstNodeAsTitle === false) {
        return false;
      }
      return true;
    }
  },
  mounted: function mounted() {}
};

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Item = __webpack_require__(85);

var _Item2 = _interopRequireDefault(_Item);

var _ContentPane = __webpack_require__(150);

var _ContentPane2 = _interopRequireDefault(_ContentPane);

var _SplitPane = __webpack_require__(151);

var _SplitPane2 = _interopRequireDefault(_SplitPane);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var target = { el: true, v: null };
exports.default = {
  name: 'nestedviewer',
  components: {
    item: _Item2.default,
    contentpane: _ContentPane2.default,
    splitpane: _SplitPane2.default
  },
  data: function data() {
    return {
      target: target
    };
  },
  computed: {
    data: function data() {
      return this.$store.state.leodata;
    },
    text: function text() {
      return this.$store.state.leotext;
    },
    ulStyle: function ulStyle() {
      var p = window.lconfig.leftPanePadding || '0';
      return 'padding-left:' + p;
    },
    leftPaneStyle: function leftPaneStyle() {
      var w = window.lconfig.leftPaneWidth || '420px';
      return 'width:' + w;
    }
  }

};

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(1283);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(155);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function assign(obj) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  sources.forEach(function (source) {
    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        obj[key] = source[key];
      }
    }
  });

  return obj;
}

var icons = {};

exports.default = {
  name: 'fa-icon',
  render: function render(h) {
    if (this.name === null) {
      return h();
    }

    var options = {
      class: this.klass,
      style: this.style,
      attrs: {
        role: this.label ? 'img' : 'presentation',
        'aria-label': this.label || null,
        x: this.x,
        y: this.y,
        width: this.width,
        height: this.height,
        viewBox: this.box
      }
    };

    if (this.raw) {
      options.domProps = {
        innerHTML: this.raw
      };
    }

    return h('svg', options, this.raw && this.icon ? null : this.$slots.default || [].concat((0, _toConsumableArray3.default)(this.icon.paths.map(function (path, i) {
      return h('path', {
        attrs: path,
        key: 'path-' + i
      });
    })), (0, _toConsumableArray3.default)(this.icon.polygons.map(function (polygon, i) {
      return h('polygon', {
        attrs: polygon,
        key: 'polygon-' + i
      });
    }))));
  },

  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return (0, _defineProperty3.default)({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.name !== null && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];
      var _icon$paths = icon.paths,
          paths = _icon$paths === undefined ? [] : _icon$paths,
          d = icon.d,
          _icon$polygons = icon.polygons,
          polygons = _icon$polygons === undefined ? [] : _icon$polygons,
          points = icon.points;


      if (d) {
        paths.push({ d: d });
      }

      if (points) {
        polygons.push({ points: points });
      }

      icons[name] = assign({}, icon, {
        paths: paths,
        polygons: polygons
      });
    }
  },

  icons: icons
};


var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'vtable',
  props: {
    dataTable: String,
    hideTitle: Boolean,
    shadow: {
      type: Boolean,
      default: true
    },
    fontSize: {
      type: String,
      default: '14'
    }
  },
  components: {},
  methods: {
    main: function main() {
      this.$router.replace({ path: '/' });
    },
    dataCol: function dataCol(index) {
      if (this.firstRow[index].indexOf('$') > -1) {
        return false;
      }
      return true;
    }
  },
  data: function data() {
    return {
      table: Object,
      caption: String
    };
  },

  computed: {
    id: function id() {},
    firstRow: function firstRow() {
      return this.table[0];
    },
    style: function style() {
      var shadowStyle = 'box-shadow: 1px 1px 7px #ccc';
      if (!this.shadowStyle) {
        shadowStyle = '';
      }
      return shadowStyle + '; font-size:' + this.fontSize + 'px;';
    }
  },
  mounted: function mounted() {
    var tableObj = this.$store.state.dataTables[this.dataTable];
    if (!tableObj) {
      tableObj = window.parent.lconfig.dataTables[this.dataTable];
    }
    if (tableObj) {
      this.table = tableObj.arr;
      if (!this.hideTitle) {
        this.caption = tableObj.title;
      }
    } else {
      this.table = [[]];
    }
  },

  watch: {
    '$route': function $route(to, from) {}
  }
};

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _numeral = __webpack_require__(2788);

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'vc-table',
  components: {},
  props: {
    dataTable: String
  },
  data: function data() {
    return {
      data: [],
      cols: [],
      currentTable: null
    };
  },
  beforeCreate: function beforeCreate() {},
  mounted: function mounted() {
    var tableObj = this.$store.state.dataTables[this.dataTable];
    if (tableObj) {
      this.data = tableObj.objArr;
      this.cols = tableObj.arr[0];
    } else {}

    this.currentTable = this.dynComponent;
  },

  computed: {
    id: function id() {},
    dynComponent: function dynComponent() {
      var d = this.data;
      var cols = '';
      this.cols.forEach(function (c) {
        if (c.indexOf('$') === -1) {
          var cellClass = '';
          if (c.match(/^\d+$/)) {
            cellClass = 'cell-class="number" :formatter="formatNumber"';
          } else {
            console.log('X', c);
          }
          cols = cols + ('<table-column ' + cellClass + ' show="' + c + '" label="' + c + '"></table-column>');
        }
      });
      var template = '\n          <table-component\n            :data="data"\n            sort-by="songs"\n            sort-order="asc">\n            ' + cols + '\n          </table-component>\n      ';
      return {
        template: template,
        methods: {
          formatNumber: function formatNumber(n) {
            return (0, _numeral2.default)(n).format('0,0');
          }
        },
        data: function data() {
          return {
            data: d
          };
        }
      };
    }
  }
};

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'mermaid',
  components: {},
  props: {
    name: {
      type: String,
      default: 'mm'
    },
    height: {
      type: String,
      default: '100%'
    },
    width: {
      type: String,
      default: ''
    },
    mm: {
      type: String,
      default: ''
    }
  },
  methods: {},
  data: function data() {
    return {};
  },
  beforeCreate: function beforeCreate() {},
  updated: function updated() {
    var mermaidEl = this.$el;
    mermaidEl.style.height = this.height + 'px';
    mermaidEl.style.width = this.width + 'px';
    mermaidEl.name = this.name;
    if (this.mm) {
      mermaidEl.innerHTML = this.mm;
    }
    mermaidEl.removeAttribute('data-processed');
    mermaid.init(undefined, mermaidEl);
  },
  mounted: function mounted() {
    var mermaidEl = this.$el;

    mermaidEl.style.height = this.height + 'px';
    mermaidEl.style.width = this.width + 'px';
    mermaidEl.name = this.name;
    var config = {
      startOnLoad: true,
      flowchart: {
        useMaxWidth: true,
        htmlLabels: true
      },
      theme: 'forest'
    };
    mermaid.initialize(config);
    mermaidEl.removeAttribute('data-processed');
    mermaid.init(undefined, mermaidEl);
  },

  computed: {
    id: function id() {}
  }
};

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'mermaidp',
  components: {},
  props: {
    height: {
      type: String,
      default: '300'
    },
    width: {
      type: String
    }
  },
  methods: {},
  data: function data() {
    return {};
  },
  beforeCreate: function beforeCreate() {},
  mounted: function mounted() {
    var config = {
      startOnLoad: true,
      flowchart: {
        useMaxWidth: true,
        htmlLabels: true
      },
      theme: 'forest'
    };
    mermaid.initialize(config);
    var mermaidEl = this.$el;
    if (this.width) {
      mermaidEl.style.width = this.width + 'px';
    }
    mermaidEl.style.height = this.height + 'px';
    var mermaidGraphDefinition = mermaidEl.innerHTML.replace(/&gt;/g, '>');
    function draw() {
      var cb = function cb(svgGraph) {
        svgGraph = svgGraph.replace(/svg {/, 'avg');
        mermaidEl.innerHTML = svgGraph;
        var svgEl = mermaidEl.firstElementChild;
        d3.select(svgEl).insert('rect', ':first-child').attr('width', '100%').attr('height', '100%').attr('fill', 'white');
        d3.select(svgEl).style('max-width', null).style('font-size', '14px').style('color', '#000').attr('height', this.height + 'px');
      };
      mermaid.render('mm1', mermaidGraphDefinition, cb);
    }
    draw();
  },

  computed: {
    id: function id() {}
  }
};

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'v-svg',
  components: {},
  props: {
    viewBox: {
      type: String,
      default: '0, 0, 900, 900'
    },
    height: {
      type: String,
      default: '400'
    },
    width: {
      type: String,
      default: '800'
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  computed: {
    id: function id() {},
    style: function style() {
      var height = this.height;
      var width = this.width;
      return 'height:' + height + 'px; max-width:' + width + 'px; background: #fff; margin-left:auto; margin-right: auto;';
    }
  }
};

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

var _util = __webpack_require__(31);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'sectionlink',
  props: {
    title: String
  },
  data: function data() {
    return {};
  },

  methods: {
    gotoSection: function gotoSection() {
      var plainTitle = _lodash2.default.trim(this.title);
      var searchTitle = '« ' + plainTitle + ' »';
      var leodata = this.$store.state.leodata;
      if (window.parent !== window.self) {
        leodata = window.parent.lconfig.leodata;
      }
      var titleObj = JSON.search(leodata, '//*[name="' + searchTitle + '"]')[0];
      if (!titleObj) {
        var i = 0;
        while (!titleObj && i < leodata.length) {
          titleObj = _util2.default.getObjectByKeyFromTree(leodata[i], 'name', plainTitle);
          i = i + 1;
        }
      }
      var id = null;
      var index = null;
      if (titleObj) {
        id = titleObj.id;
        if (titleObj.index) {
          index = titleObj.index;
        }
        this.$store.dispatch('setCurrentItem', { id: id });
        if (window.parent !== window.self) {
          console.log('posting message');
          window.parent.postMessage((0, _stringify2.default)({
            namespace: 'leovue',
            eventName: 'setcurrentitem',
            state: { id: id, index: index }
          }), '*');
        }
      }
    }
  },
  components: {}
};

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

var _util = __webpack_require__(31);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'toc',
  props: {},
  data: function data() {
    return {};
  },

  computed: {
    chapters: function chapters() {
      var data = this.$store.state.leodata;
      var item = JSON.search(data, '//*[id="' + this.$store.state.currentItem.id + '"]')[0];
      return item.children;
    }
  },
  methods: {
    gotoSection: function gotoSection(title) {
      var plainTitle = _lodash2.default.trim(title);
      var searchTitle = '« ' + plainTitle + ' »';
      var leodata = this.$store.state.leodata;
      if (window.parent !== window.self) {
        leodata = window.parent.lconfig.leodata;
      }
      var titleObj = JSON.search(leodata, '//*[vtitle="' + searchTitle + '"]')[0];
      if (!titleObj) {
        var i = 0;
        while (!titleObj && i < leodata.length) {
          titleObj = _util2.default.getObjectByKeyFromTree(leodata[i], 'vtitle', plainTitle);
          i = i + 1;
        }
      }
      var id = null;
      var index = null;
      if (titleObj) {
        id = titleObj.id;
        if (titleObj.index) {
          index = titleObj.index;
        }
        this.$store.dispatch('setCurrentItem', { id: id });
        if (window.parent !== window.self) {
          console.log('posting message');
          window.parent.postMessage((0, _stringify2.default)({
            namespace: 'leovue',
            eventName: 'setcurrentitem',
            state: { id: id, index: index }
          }), '*');
        }
      }
    }
  },
  components: {}
};

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'nodelink',
  props: {
    title: String
  },
  data: function data() {
    return {};
  },

  methods: {
    gotoSection: function gotoSection() {
      var title = _lodash2.default.trim(this.title);
      var leodata = this.$store.state.leodata;
      if (window.parent !== window.self) {
        leodata = window.parent.lconfig.leodata;
      }
      var titleObj = JSON.search(leodata, '//*[name="' + title + '"]')[0];
      if (!titleObj) {
        titleObj = JSON.search(leodata, '//*[contains(name, "' + title + '")]')[0];
      }
      if (!titleObj) {
        return;
      }
      var id = null;
      var index = null;
      if (titleObj) {
        id = titleObj.id;
        if (titleObj.index) {
          index = titleObj.index;
        }
        this.$store.dispatch('setCurrentItem', { id: id });
        if (window.parent !== window.self) {
          console.log('posting message');
          window.parent.postMessage((0, _stringify2.default)({
            namespace: 'leovue',
            eventName: 'setcurrentitem',
            state: { id: id, index: index }
          }), '*');
        }
      }
    }
  },
  components: {}
};

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'mathjax',
  data: function data() {
    return {};
  },

  methods: {},
  components: {},
  mounted: function mounted() {
    var _this = this;

    if (MathJax) {
      MathJax.Hub.Queue(['Typeset', MathJax.Hub, this.$el]);
      MathJax.Hub.Queue(function () {
        return _this.$el.style.display = 'block';
      });
    }
  },
  updated: function updated() {}
};

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'imgLeft',
  props: {
    src: String,
    height: String
  },
  computed: {
    heightpx: function heightpx() {
      if (!this.height) {
        this.height = '300';
      }
      return this.height + 'px';
    }
  }
};

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

var _util = __webpack_require__(31);

var _util2 = _interopRequireDefault(_util);

var _timelineVuejs = __webpack_require__(2816);

var _timelineVuejs2 = _interopRequireDefault(_timelineVuejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'lv-timeline',
  components: {
    timeline: _timelineVuejs2.default
  },
  props: {
    group: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    from: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      messageWhenNoItems: 'There are no items.'
    };
  },
  computed: {
    chapters: function chapters() {
      var _this = this;

      var data = this.$store.state.leodata;
      var item = JSON.search(data, '//*[group="' + this.group + '"]')[0];
      var children = item.children;
      var items = [];
      var textItems = this.$store.state.leotext;
      children.forEach(function (child) {
        var t = textItems[child.t];
        var textData = {};
        try {
          textData = JSON.parse(t);
        } catch (e) {
          console.log(e, child.id);
        }
        var o = {};
        var key = _this.from || 'blank';
        o.from = new Date(_lodash2.default.get(textData, key, ''));
        key = _this.title || 'blank';
        o.title = _lodash2.default.get(textData, key, '');
        key = _this.description || 'blank';
        o.description = _lodash2.default.get(textData, key, '');
        items.push(o);
      });
      return items;
    }
  },
  methods: {
    dataTableClick: function dataTableClick(r) {
      this.$parent.$parent.dataTableClick(r);
    },
    gotoSection: function gotoSection(title) {
      var plainTitle = _lodash2.default.trim(title);
      var searchTitle = '« ' + plainTitle + ' »';
      var leodata = this.$store.state.leodata;
      if (window.parent !== window.self) {
        leodata = window.parent.lconfig.leodata;
      }
      var titleObj = JSON.search(leodata, '//*[vtitle="' + searchTitle + '"]')[0];
      if (!titleObj) {
        var i = 0;
        while (!titleObj && i < leodata.length) {
          titleObj = _util2.default.getObjectByKeyFromTree(leodata[i], 'vtitle', plainTitle);
          i = i + 1;
        }
      }
      var id = null;
      var index = null;
      if (titleObj) {
        id = titleObj.id;
        if (titleObj.index) {
          index = titleObj.index;
        }
        this.$store.dispatch('setCurrentItem', { id: id });
        if (window.parent !== window.self) {
          console.log('posting message');
          window.parent.postMessage((0, _stringify2.default)({
            namespace: 'leovue',
            eventName: 'setcurrentitem',
            state: { id: id, index: index }
          }), '*');
        }
      }
    }
  }
};

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(79);

var _keys2 = _interopRequireDefault(_keys);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

var _util = __webpack_require__(31);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sw = __webpack_require__(2820);
var split = __webpack_require__(2840);
exports.default = {
  name: 'word-cloud',
  components: {},
  props: {
    group: {
      type: String,
      default: ''
    },
    from: {
      type: String,
      default: ''
    },
    threshold: {
      type: Number,
      default: 11
    }
  },
  data: function data() {
    return {
      messageWhenNoItems: 'There are no items.'
    };
  },
  computed: {
    chapters: function chapters() {
      var _this = this;

      var data = this.$store.state.leodata;
      var item = JSON.search(data, '//*[group="' + this.group + '"]')[0];
      var children = item.children;
      var items = [];
      var textItems = this.$store.state.leotext;
      children.forEach(function (child) {
        var t = textItems[child.t];
        var textData = {};
        try {
          textData = JSON.parse(t);
        } catch (e) {
          console.log(e, child.id);
        }
        items.push(_lodash2.default.get(textData, _this.from, ''));
      });
      var text = items.join();

      text = text.replace(/[[\]&,;'"”’().*?]/g, ' ');
      var words = split(text);
      words = sw.removeStopwords(words);
      var wf = {};
      _lodash2.default.remove(words, function (word) {
        return (/\d/.test(word)
        );
      });
      words.forEach(function (word) {
        if (word.length < 4) {
          return;
        }
        word = word.toLowerCase();
        wf[word] = wf[word] ? wf[word] + 1 : 1;
      });

      var wordFreq = {};
      (0, _keys2.default)(wf).forEach(function (k) {
        var v = wf[k];
        if (v > _this.threshold) wordFreq[k] = v;
      });
      var keys = (0, _keys2.default)(wordFreq);
      keys.forEach(function (k) {
        if (wordFreq[k + 's']) {
          wordFreq[k] = wordFreq[k] + wordFreq[k + 's'];
          delete wordFreq[k + 's'];
        }
        if (wordFreq[k + 'd']) {
          wordFreq[k] = wordFreq[k] + wordFreq[k + 'd'];
          delete wordFreq[k + 'd'];
        }
        if (wordFreq[k + 'ly']) {
          wordFreq[k] = wordFreq[k] + wordFreq[k + 'ly'];
          delete wordFreq[k + 'ly'];
        }
      });
      var c = [];
      (0, _keys2.default)(wordFreq).forEach(function (key) {
        var a = [];
        a.push(key);
        a.push(wordFreq[key]);
        c.push(a);
      });
      return c;
    }
  },
  methods: {
    dataTableClick: function dataTableClick(r) {
      this.$parent.$parent.dataTableClick(r);
    },
    gotoSection: function gotoSection(title) {
      var plainTitle = _lodash2.default.trim(title);
      var searchTitle = '« ' + plainTitle + ' »';
      var leodata = this.$store.state.leodata;
      if (window.parent !== window.self) {
        leodata = window.parent.lconfig.leodata;
      }
      var titleObj = JSON.search(leodata, '//*[vtitle="' + searchTitle + '"]')[0];
      if (!titleObj) {
        var i = 0;
        while (!titleObj && i < leodata.length) {
          titleObj = _util2.default.getObjectByKeyFromTree(leodata[i], 'vtitle', plainTitle);
          i = i + 1;
        }
      }
      var id = null;
      var index = null;
      if (titleObj) {
        id = titleObj.id;
        if (titleObj.index) {
          index = titleObj.index;
        }
        this.$store.dispatch('setCurrentItem', { id: id });
        if (window.parent !== window.self) {
          console.log('posting message');
          window.parent.postMessage((0, _stringify2.default)({
            namespace: 'leovue',
            eventName: 'setcurrentitem',
            state: { id: id, index: index }
          }), '*');
        }
      }
    }
  }
};

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Item = __webpack_require__(85);

var _Item2 = _interopRequireDefault(_Item);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _itemSet = null;
function addParentPointers(item) {
  item.children.forEach(function (c) {
    c.parent = item;
    c.o = false;
    addParentPointers(c);
  });
}
exports.default = {
  name: 'kanban',
  components: {
    item: _Item2.default
  },
  methods: {
    main: function main() {}
  },
  data: function data() {
    return {};
  },

  computed: {
    id: function id() {
      if (!this.$route.params.id) {
        return +1;
      } else {
        return this.$route.params.id;
      }
    },
    data: function data() {
      return this.$store.state.leodata;
    },
    item: function item() {
      var id = this.$store.state.currentItem.id;
      return JSON.search(this.data, '//*[id="' + id + '"]')[0];
    },
    title: function title() {
      return this.item.name.replace(/@kanban /, '');
    },
    text: function text() {
      return this.$store.state.leotext;
    },
    itemSet: function itemSet() {
      if (!_itemSet) {
        _itemSet = _lodash2.default.cloneDeep(this.item);
        addParentPointers(_itemSet);
      }
      return _itemSet;
    }
  },
  mounted: function mounted() {},

  watch: {
    '$route': function $route(to, from) {}
  }
};

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Item = __webpack_require__(85);

var _Item2 = _interopRequireDefault(_Item);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

var _jsYaml = __webpack_require__(143);

var _jsYaml2 = _interopRequireDefault(_jsYaml);

var _tooltip = __webpack_require__(2848);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var md = __webpack_require__(146)({
  html: true,
  linkify: true,
  typographer: true
});

function removeDirective(text) {
  text = text.replace(/^@.*?\n/, '');
  return text;
}
function addParentPointers(item) {
  item.name = item.name.replace(/@mermaid\w\w /, '');
  item.children.forEach(function (c) {
    c.parent = item;
    c.o = false;
    addParentPointers(c);
  });
}
function getParentG(n) {
  if (!n) {
    return n;
  }
  if (n.tagName === 'g' && n.id) {
    return n;
  } else {
    return getParentG(n.parentElement);
  }
}

function cleanTitle(title, props) {
  var label = '';
  var m = title.match(/^(\|\w+?\|)/);
  if (m && m[1]) {
    label = m[1];
    title = title.replace(label, '');
  } else {}
  if (!/[\[{(]/.test(title)) {
    title = '["' + title + '"]';
  }
  var firstChar = title[0];
  switch (firstChar) {
    case '[':
      title = setFa(title, 'square', 1);
      break;
    case '(':
      if (title.slice(0, 2) === '((') {
        title = setFa(title, 'circle', 2);
      } else {
        title = setFa(title, 'rounded', 1);
      }
      break;
    case '<':
      title = setFa(title, 'rhombus', 1);
      break;
    default:
  }
  return { title: title, label: label };
  function setFa(title, shape, count) {
    if (!props[shape].fa) {
      return title;
    }
    title = title.slice(0, count) + 'fa:fa-' + props[shape].fa + ' ' + title.slice(count);
    return title;
  }
}
function getMm(item, links, type, props) {
  var arrow = '-->';
  if (type === 'RL') {
    arrow = '---';
  }
  item.children.forEach(function (i) {
    var pname = cleanTitle(item.name, props);
    var cname = cleanTitle(i.name, props);
    links.push('mm' + item.t + pname.title + ' ' + arrow + ' ' + cname.label + ' mm' + i.t + cname.title + ';');
    getMm(i, links, type, props);
  });
}
function getStyles(items, links, type, props) {
  getStyle(items.name, links, type, props, items.t);
  items.children.forEach(function (i) {
    getStyles(i, links, type, props);
  });
}
function getStyle(title, links, type, props, id) {
  if (!/[\[{(]/.test(title)) {
    title = '[' + title + ']';
  }
  var firstChar = title[0];
  var fill = '';
  switch (firstChar) {
    case '[':
      fill = props.square.fill;
      break;
    case '(':
      if (title.slice(0, 2) === '((') {
        fill = props.circle.fill;
      } else {
        fill = props.rounded.fill;
      }
      break;
    case '{':
      fill = props.rhombus.fill;
      break;
    default:
  }
  if (fill) {
    links.push('style mm' + id + ' fill:' + fill);
  }
}
exports.default = {
  name: 'mermaid-board',
  components: {
    item: _Item2.default
  },
  methods: {
    main: function main() {},
    clickb: function clickb() {
      this.viewSource = !this.viewSource;
    },
    click: function click(e) {
      var _this = this;

      if (!e) {
        return null;
      }
      if (e.target.id === 'mbutton') {
        return;
      }
      var g = getParentG(e.target);
      if (!g) {
        return;
      }
      var action = _lodash2.default.get(this.mprops, 'click', '');
      if (action === 'goto') {
        var id = JSON.search(this.$store.state.leodata, '//children[t="' + g.id.replace(/mm/, '') + '"]')[0].id;
        return this.$store.dispatch('setCurrentItem', { id: id });
      }
      var text = this.$store.state.leotext[g.id.replace(/mm/, '')];
      text = removeDirective(text);
      text = md.render(text);
      if (!text) {
        text = '<div class="pop-small-text">No description for this node.</div>';
      }
      text = '<div class="pop-content">' + text + '</div>';

      var ref = document.getElementById(g.id);

      var pop = new _tooltip2.default(ref, {
        placement: 'top',
        title: 'bar',
        content: 'foo'
      });
      pop.show();
      document.getElementById('popover.content.html').innerHTML = text;
      console.log('POP', document.getElementById('popover.content.html').innerHTML);
      setTimeout(function () {
        return _this.popover.show('#' + g.id);
      }, 10);
      console.log('REFS', this.$refs.mbutton);
    }
  },
  data: function data() {
    return {
      viewSource: false,
      mmPretty: ''
    };
  },

  computed: {
    id: function id() {
      if (!this.$route.params.id) {
        return +1;
      } else {
        return this.$route.params.id;
      }
    },
    mPretty: function mPretty() {
      return Math.random();
    },
    mprops: function mprops() {
      var props = {
        height: 600,
        circle: {
          fill: '',
          fa: ''
        },
        square: {
          fill: '',
          fa: ''
        },
        rounded: {
          fill: '',
          fa: ''
        },
        rhombus: {
          fill: '',
          fa: ''
        }
      };
      try {
        var tprops = _jsYaml2.default.safeLoad(removeDirective(this.text));
        _lodash2.default.merge(props, tprops);
      } catch (e) {
        console.log('YAML parse');
      }
      return props;
    },
    data: function data() {
      return this.$store.state.leodata;
    },
    item: function item() {
      var id = this.$store.state.currentItem.id;
      return JSON.search(this.data, '//*[id="' + id + '"]')[0];
    },
    title: function title() {
      return this.item.name.replace(/@mermaid\w\w /, '').replace(/^\(/, '').replace(/\)$/, '');
    },
    mmName: function mmName() {
      return this.item.name;
    },
    text: function text() {
      return this.$store.state.leotext[this.item.t];
    },
    itemSet: function itemSet() {
      var itemSet = _lodash2.default.cloneDeep(this.item);
      addParentPointers(itemSet);

      return itemSet;
    },
    mm: function mm() {
      var graphType = 'LR';
      var m = this.item.name.match(/@mermaid([a-z][a-z])/);
      if (m) {
        graphType = m[1].toUpperCase();
      }
      var links = [];
      getMm(this.itemSet, links, graphType, this.mprops);
      var styles = [];
      getStyles(this.itemSet, styles, graphType, this.mprops);
      links = links.concat(styles);
      links = _lodash2.default.uniq(links);
      links[0] = links[0].replace(/@mermaid\w? /, '');
      links = links.reverse();
      links.unshift('graph ' + graphType + ';');
      this.mmPretty = links.join('<br>');
      return links.join('\n');
    }
  },
  updated: function updated() {
    var foo = this.mm;
  },
  mounted: function mounted() {
    var me = this;
    ons.createPopover('popover.html').then(function (element) {
      me.popover = element;
    });
  },

  watch: {
    '$route': function $route(to, from) {}
  }
};

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _d = __webpack_require__(266);

var d3 = _interopRequireWildcard(_d);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var graph = {
  'nodes': [{ 'x': 208.992345, 'y': 273.053211 }, { 'x': 595.98896, 'y': 56.377057 }, { 'x': 319.568434, 'y': 278.523637 }, { 'x': 214.494264, 'y': 214.893585 }, { 'x': 482.664139, 'y': 340.386773 }, { 'x': 84.078465, 'y': 192.021902 }, { 'x': 196.952261, 'y': 370.798667 }, { 'x': 107.358165, 'y': 435.15643 }, { 'x': 401.168523, 'y': 443.407779 }, { 'x': 508.368779, 'y': 386.665811 }, { 'x': 355.93773, 'y': 460.158711 }, { 'x': 283.630624, 'y': 87.898162 }, { 'x': 194.771218, 'y': 436.366028 }, { 'x': 477.520013, 'y': 337.547331 }, { 'x': 572.98129, 'y': 453.668459 }, { 'x': 106.717817, 'y': 235.990363 }, { 'x': 265.064649, 'y': 396.904945 }, { 'x': 452.719997, 'y': 137.886092 }],
  'links': [{ 'target': 11, 'source': 0 }, { 'target': 3, 'source': 0 }, { 'target': 10, 'source': 0 }, { 'target': 16, 'source': 0 }, { 'target': 1, 'source': 0 }, { 'target': 3, 'source': 0 }, { 'target': 9, 'source': 0 }, { 'target': 5, 'source': 0 }, { 'target': 11, 'source': 0 }, { 'target': 13, 'source': 0 }, { 'target': 16, 'source': 0 }, { 'target': 3, 'source': 1 }, { 'target': 9, 'source': 1 }, { 'target': 12, 'source': 1 }, { 'target': 4, 'source': 2 }, { 'target': 6, 'source': 2 }, { 'target': 8, 'source': 2 }, { 'target': 13, 'source': 2 }, { 'target': 10, 'source': 3 }, { 'target': 16, 'source': 3 }, { 'target': 9, 'source': 3 }, { 'target': 7, 'source': 3 }, { 'target': 11, 'source': 5 }, { 'target': 13, 'source': 5 }, { 'target': 12, 'source': 5 }, { 'target': 8, 'source': 6 }, { 'target': 13, 'source': 6 }, { 'target': 10, 'source': 7 }, { 'target': 11, 'source': 7 }, { 'target': 17, 'source': 8 }, { 'target': 13, 'source': 8 }, { 'target': 11, 'source': 10 }, { 'target': 16, 'source': 10 }, { 'target': 13, 'source': 11 }, { 'target': 14, 'source': 12 }, { 'target': 14, 'source': 12 }, { 'target': 14, 'source': 12 }, { 'target': 15, 'source': 12 }, { 'target': 16, 'source': 12 }, { 'target': 15, 'source': 14 }, { 'target': 16, 'source': 14 }, { 'target': 15, 'source': 14 }, { 'target': 16, 'source': 15 }, { 'target': 16, 'source': 15 }, { 'target': 17, 'source': 16 }]
};

exports.default = {
  name: 'd3-board',
  components: {},
  methods: {
    main: function main() {}
  },
  data: function data() {
    return {};
  },

  computed: {},
  mounted: function mounted() {
    var svg = document.getElementById('d3board-svg');
    var width = 600;
    var height = 400;
    var nodes = graph.nodes;
    var links = graph.links;
    var force = d3.forceSimulation().size([width, height]).nodes(nodes).links(links);
    force.linkDistance(width / 3.05);
    var link = svg.selectAll('.link').data(links).enter().append('line').attr('class', 'link');
    var node = svg.selectAll('.node').data(nodes).enter().append('circle').attr('class', 'node');
    force.on('end', function () {
      node.attr('r', width / 100).attr('cx', function (d) {
        return d.x;
      }).attr('cy', function (d) {
        return d.y;
      });
      link.attr('x1', function (d) {
        return d.source.x;
      }).attr('y1', function (d) {
        return d.source.y;
      }).attr('x2', function (d) {
        return d.target.x;
      }).attr('y2', function (d) {
        return d.target.y;
      });
    });
    force.start();
  },

  watch: {
    '$route': function $route(to, from) {}
  }
};

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(40);

var _stringify2 = _interopRequireDefault(_stringify);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

var _util = __webpack_require__(31);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDataArray(data, type, id) {
  var item = JSON.search(data, '//*[' + type + '="' + id + '"]')[0];
  return item ? item.children : [];
}
exports.default = {
  name: 'summary-table',
  props: {
    group: {
      type: Number,
      default: null
    },
    mgroup: {
      type: Number,
      default: null
    },
    cols: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    colKeys: function colKeys() {
      var cKeys = [];
      this.cols.forEach(function (col) {
        var newCol = {};
        newCol.show = col.show.replace(/\./g, '~');
        newCol.label = col.label;
        newCol['data-type'] = col.dataType;
        newCol['cell-class'] = col.cellClass;
        cKeys.push(newCol);
      });
      return cKeys;
    },
    chapters: function chapters() {
      var _this = this;

      function getColumnData(cols, d) {
        var o = {};
        _lodash2.default.forEach(cols, function (col) {
          o[col.show.replace(/\./g, '~')] = _lodash2.default.get(d, col.show, '');
        });
        return o;
      }
      var data = this.$store.state.leodata;
      var id = this.group || this.mgroup || this.$store.state.currentItem.id;
      var key = this.group ? 'group' : this.mgroup ? 'mgroup' : 'id';
      var d = getDataArray(data, key, id);
      var items = [];
      var textItems = this.$store.state.leotext;
      d.forEach(function (child) {
        var t = textItems[child.t];
        var textData = {};
        try {
          _this.mgroup ? textData = child.metadata : textData = JSON.parse(t);
        } catch (e) {
          console.log(e, child.id);
        }
        textData.rtitle = child.name;
        textData.vtitle = child.vtitle;
        items.push(getColumnData(_this.cols, textData));
      });
      return items;
    }
  },
  methods: {
    dataTableClick: function dataTableClick(r) {
      this.$parent.$parent.dataTableClick(r);
    },
    gotoSection: function gotoSection(title) {
      var plainTitle = _lodash2.default.trim(title);
      var searchTitle = '« ' + plainTitle + ' »';
      var leodata = this.$store.state.leodata;
      if (window.parent !== window.self) {
        leodata = window.parent.lconfig.leodata;
      }
      var titleObj = JSON.search(leodata, '//*[vtitle="' + searchTitle + '"]')[0];
      if (!titleObj) {
        var i = 0;
        while (!titleObj && i < leodata.length) {
          titleObj = _util2.default.getObjectByKeyFromTree(leodata[i], 'vtitle', plainTitle);
          i = i + 1;
        }
      }
      var id = null;
      var index = null;
      if (titleObj) {
        id = titleObj.id;
        if (titleObj.index) {
          index = titleObj.index;
        }
        this.$store.dispatch('setCurrentItem', { id: id });
        if (window.parent !== window.self) {
          console.log('posting message');
          window.parent.postMessage((0, _stringify2.default)({
            namespace: 'leovue',
            eventName: 'setcurrentitem',
            state: { id: id, index: index }
          }), '*');
        }
      }
    }
  },
  components: {}
};

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueTagsInput = __webpack_require__(2860);

var _vueTagsInput2 = _interopRequireDefault(_vueTagsInput);

var _util = __webpack_require__(31);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'tagsearch',
  components: {
    VueTagsInput: _vueTagsInput2.default
  },
  data: function data() {
    return {
      tag: '',
      tags: []
    };
  },

  computed: {
    chapters: function chapters() {
      var leodata = this.$store.state.leodata;
      if (!this.tags.length) {
        return;
      }
      var conditions = this.tags.map(function (tag) {
        return '[tags/text="' + tag.text + '"]';
      }).join('');
      var arr = [];
      var nodes = JSON.search(leodata, '//*' + conditions);
      nodes.forEach(function (node) {
        var nodePath = _util2.default.getNodePath(leodata, node);
        arr.push({ nodePath: nodePath, node: node });
      });
      return arr;
    },
    filteredItems: function filteredItems() {
      var tags = this.$store.state.tags;
      var tagList = tags.reduce(function (acc, curr) {
        acc.push({ text: curr });
        return acc;
      }, []);
      var tag = this.tag.toLowerCase();
      console.log(this.tags);
      return tagList.filter(function (i) {
        return i.text.toLowerCase().indexOf(tag) !== -1;
      });
    }
  },
  methods: {
    gotoSection: function gotoSection(id) {
      this.$store.dispatch('setCurrentItem', { id: id });
    }
  }
};

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(77);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(554);

var _App2 = _interopRequireDefault(_App);

var _AppBase = __webpack_require__(561);

var _AppBase2 = _interopRequireDefault(_AppBase);

var _router = __webpack_require__(218);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(1238);

var _store2 = _interopRequireDefault(_store);

var _vuexRouterSync = __webpack_require__(1280);

var _vueStarRating = __webpack_require__(1281);

var _vueStarRating2 = _interopRequireDefault(_vueStarRating);

var _Icon = __webpack_require__(0);

var _Icon2 = _interopRequireDefault(_Icon);

__webpack_require__(367);

__webpack_require__(368);

__webpack_require__(369);

__webpack_require__(370);

__webpack_require__(371);

__webpack_require__(1286);

var _forkMeOnGithubVue = __webpack_require__(2623);

var _forkMeOnGithubVue2 = _interopRequireDefault(_forkMeOnGithubVue);

var _bootstrapVue = __webpack_require__(2624);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

__webpack_require__(2771);

__webpack_require__(2773);

__webpack_require__(2775);

var _vue2Leaflet = __webpack_require__(2777);

var _vue2Leaflet2 = _interopRequireDefault(_vue2Leaflet);

var _vueInfoCard = __webpack_require__(2779);

var _vueInfoCard2 = _interopRequireDefault(_vueInfoCard);

var _vTooltip = __webpack_require__(2781);

var _vTooltip2 = _interopRequireDefault(_vTooltip);

var _vueYoutubeEmbed = __webpack_require__(2782);

var _vueYoutubeEmbed2 = _interopRequireDefault(_vueYoutubeEmbed);

var _Table = __webpack_require__(2783);

var _Table2 = _interopRequireDefault(_Table);

var _VCTable = __webpack_require__(2786);

var _VCTable2 = _interopRequireDefault(_VCTable);

var _Mermaid = __webpack_require__(2790);

var _Mermaid2 = _interopRequireDefault(_Mermaid);

var _MermaidP = __webpack_require__(2793);

var _MermaidP2 = _interopRequireDefault(_MermaidP);

var _VSVG = __webpack_require__(2796);

var _VSVG2 = _interopRequireDefault(_VSVG);

var _SectionLink = __webpack_require__(2799);

var _SectionLink2 = _interopRequireDefault(_SectionLink);

var _TOC = __webpack_require__(2802);

var _TOC2 = _interopRequireDefault(_TOC);

var _NodeLink = __webpack_require__(2805);

var _NodeLink2 = _interopRequireDefault(_NodeLink);

var _MathJax = __webpack_require__(2808);

var _MathJax2 = _interopRequireDefault(_MathJax);

var _ImageLeft = __webpack_require__(2811);

var _ImageLeft2 = _interopRequireDefault(_ImageLeft);

var _LVTimeline = __webpack_require__(2814);

var _LVTimeline2 = _interopRequireDefault(_LVTimeline);

var _WordCloud = __webpack_require__(2818);

var _WordCloud2 = _interopRequireDefault(_WordCloud);

var _Kanban = __webpack_require__(2842);

var _Kanban2 = _interopRequireDefault(_Kanban);

var _MermaidBoard = __webpack_require__(2846);

var _MermaidBoard2 = _interopRequireDefault(_MermaidBoard);

var _D3Board = __webpack_require__(2850);

var _D3Board2 = _interopRequireDefault(_D3Board);

var _vueTableComponent = __webpack_require__(2853);

var _SummaryTable = __webpack_require__(2855);

var _SummaryTable2 = _interopRequireDefault(_SummaryTable);

var _TagSearch = __webpack_require__(2858);

var _TagSearch2 = _interopRequireDefault(_TagSearch);

var _vuewordcloud = __webpack_require__(2862);

var _vuewordcloud2 = _interopRequireDefault(_vuewordcloud);

var _Charts = __webpack_require__(2863);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _Charts.charts)(_vue2.default);

var Defiant = __webpack_require__(2910);

_vue2.default.use(_vTooltip2.default);
_vue2.default.use(_vueYoutubeEmbed2.default);
_vue2.default.use(_forkMeOnGithubVue2.default);
_vue2.default.use(_bootstrapVue2.default);
_vue2.default.component('star-rating', _vueStarRating2.default);
_vue2.default.component('lv-timeline', _LVTimeline2.default);
_vue2.default.component('word-cloud', _WordCloud2.default);
_vue2.default.component('img-left', _ImageLeft2.default);
_vue2.default.component('sectionlink', _SectionLink2.default);
_vue2.default.component('toc', _TOC2.default);
_vue2.default.component('Nodelink', _NodeLink2.default);
_vue2.default.component('v-table', _Table2.default);
_vue2.default.component('v-svg', _VSVG2.default);
_vue2.default.component('vc-table', _VCTable2.default);
_vue2.default.component('mermaid', _Mermaid2.default);
_vue2.default.component('mermaidp', _MermaidP2.default);
_vue2.default.component('mj', _MathJax2.default);
_vue2.default.component('info-card', _vueInfoCard2.default);
_vue2.default.component('l-map', _vue2Leaflet2.default.LMap);
_vue2.default.component('l-tilelayer', _vue2Leaflet2.default.LTileLayer);
_vue2.default.component('l-marker', _vue2Leaflet2.default.LMarker);
_vue2.default.component('summary-table', _SummaryTable2.default);
_vue2.default.component('table-component', _vueTableComponent.TableComponent);
_vue2.default.component('table-column', _vueTableComponent.TableColumn);
_vue2.default.component('kanban', _Kanban2.default);
_vue2.default.component('mermaid-board', _MermaidBoard2.default);
_vue2.default.component('d3-board', _D3Board2.default);
_vue2.default.component('tagsearch', _TagSearch2.default);
_vue2.default.component(_vuewordcloud2.default.name, _vuewordcloud2.default);

(0, _vuexRouterSync.sync)(_store2.default, _router2.default);

var util = __webpack_require__(31);
util.parseQueryString(window.lconfig, window.location.href);

_vue2.default.component('icon', _Icon2.default);

_vue2.default.config.productionTip = false;

var template = '<App/>';
var el = '#app';
if (window.lconfig.appBase) {
  template = '<AppBase />';
  el = '#app-base';
}

__webpack_require__(2911);
new _vue2.default({
  el: el,
  store: _store2.default,
  router: _router2.default,
  template: template,
  components: { App: _App2.default, AppBase: _AppBase2.default },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('keyup', function (e) {
      var direction = '';
      e.preventDefault();
      switch (e.keyCode) {
        case 40:
          direction = 'down';
          break;
        case 38:
          direction = 'up';
          break;
        case 13:
          direction = 'in';
          break;
        default:
      }
      if (direction) {
        _this.$store.dispatch('changeCurrentItem', { direction: direction });
      }
    });
  }
});
_vue2.default.config.errorHandler = function (err, vm, info) {
  console.log('Error: ', err, vm.name, info);
};
_vue2.default.config.warnHandler = function (err) {
  console.log('Warning: ', err);
};

window.noop = function () {};

/***/ }),

/***/ 554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dfb77b0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(555)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dfb77b0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dfb77b0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 555:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cover_vue__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cover_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cover_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cover_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_407a252b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cover_vue__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(558)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cover_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_407a252b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cover_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_407a252b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cover_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 558:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.setup}},[(_vm.coverContent)?_c('section',{staticClass:"cover show",attrs:{"id":"cover-page"}},[_c(_vm.dynComponent,{tag:"component"})],1):_vm._e()])}
var staticRenderFns = []


/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"scroll-behavior":"smooth"},attrs:{"id":"app"},on:{"drop":function($event){_vm.drop_handler($event);},"dragover":function($event){_vm.dragover_handler($event);},"dragend":function($event){_vm.dragend_handler($event);}}},[_c('cover'),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.hasGithubRibbon)?_c('Ribbon',_vm._b({},'Ribbon',_vm.ribbonOptions,false)):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppBase_vue__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppBase_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppBase_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppBase_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppBase_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4259818_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppBase_vue__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(562)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppBase_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4259818_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppBase_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4259818_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppBase_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 562:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reveal"},[_c(_vm.currentContent,{tag:"component"})],1)}
var staticRenderFns = []


/***/ }),

/***/ 565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289af36a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(566)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-289af36a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289af36a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289af36a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 566:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 567:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26f5ee4c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(568)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26f5ee4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26f5ee4c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26f5ee4c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 568:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 570:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBar_vue__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83b29500_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchBar_vue__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(571)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83b29500_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchBar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83b29500_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchBar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 571:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueInstant_vue__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueInstant_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueInstant_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueInstant_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueInstant_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5ddba8e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueInstant_vue__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(577)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueInstant_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5ddba8e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueInstant_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5ddba8e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueInstant_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 577:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main"},[_c('form',{class:_vm.getFormClass,attrs:{"novalidate":"novalidate","onsubmit":"return false;"}},[_c('div',{class:_vm.getClassWrapper,attrs:{"role":"search"}},[_c('input',{class:_vm.getClassInputPlaceholder,attrs:{"type":"search","name":"search","placeholder":_vm.getPlaceholder,"autocomplete":"off","required":"required","tabindex":"-1"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.textVal),expression:"textVal"}],class:_vm.getClassInput,attrs:{"disabled":_vm.disabled,"type":"search","name":_vm.name,"placeholder":"","autocomplete":"off","required":"required","autofocus":_vm.autofocus},domProps:{"value":(_vm.textVal)},on:{"click":_vm.emitClickInput,"keyup":_vm.changeText,"input":function($event){if($event.target.composing){ return; }_vm.textVal=$event.target.value}}}),_vm._v(" "),_c('button',{class:_vm.getClassSubmit,attrs:{"type":"submit","tabindex":"-1"},on:{"click":_vm.emitClickButton}},[_c('svg',{attrs:{"role":"img","aria-label":"Search"}},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":_vm.getSVGSearch}})])]),_vm._v(" "),_c('button',{class:_vm.getClassReset,attrs:{"type":"reset","tabindex":"-1"},on:{"click":_vm.reset}},[_c('svg',{attrs:{"role":"img","aria-label":"Reset"}},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":_vm.getSVGClear}})])]),_vm._v(" "),(_vm.modeIsFull)?_c('div',{staticClass:"el-input-group__append"},[(_vm.suggestionsIsVisible && _vm.showSuggestions)?_c('ul',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.away),expression:"away"}],staticClass:"vue-instant__suggestions"},_vm._l((_vm.similiarData),function(item,index){return _c('li',{class:_vm.getClassHighlighted(index),on:{"click":function($event){_vm.selectedAction(index)}}},[_c('div',[_vm._v("\n                   "+_vm._s(item[_vm.suggestionAttribute])+"\n                   ")])])})):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('svg',{staticStyle:{"display":"none"},attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('symbol',{attrs:{"xmlns":"http://www.w3.org/2000/svg","id":"sbx-icon-search-8","viewBox":"0 0 40 40"}},[_c('path',{attrs:{"d":"M16 32c8.835 0 16-7.165 16-16 0-8.837-7.165-16-16-16C7.162 0 0 7.163 0 16c0 8.835 7.163 16 16 16zm0-5.76c5.654 0 10.24-4.586 10.24-10.24 0-5.656-4.586-10.24-10.24-10.24-5.656 0-10.24 4.584-10.24 10.24 0 5.654 4.584 10.24 10.24 10.24zM28.156 32.8c-1.282-1.282-1.278-3.363.002-4.643 1.282-1.284 3.365-1.28 4.642-.003l6.238 6.238c1.282 1.282 1.278 3.363-.002 4.643-1.283 1.283-3.366 1.28-4.643.002l-6.238-6.238z","fill-rule":"evenodd"}})]),_vm._v(" "),_c('symbol',{attrs:{"xmlns":"http://www.w3.org/2000/svg","id":"sbx-icon-clear-4","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M11.664 9.877l4.485 4.485-1.542 1.54-4.485-4.485-4.485 4.485-1.54-1.54 4.485-4.485-4.485-4.485 1.54-1.54 4.485 4.484 4.485-4.485 1.54 1.542-4.484 4.485zM10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z","fill-rule":"evenodd"}})])])])}
var staticRenderFns = []


/***/ }),

/***/ 580:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchbar"},[_c('div',{attrs:{"id":"searchbar"}},[_c('vue-instant',{attrs:{"suggestion-attribute":_vm.suggestionAttribute,"disabled":false,"show-autocomplete":true,"autofocus":false,"suggestions":_vm.suggestions,"name":"customName","placeholder":"","type":"twitter"},on:{"input":_vm.changed,"click-input":_vm.clickInput,"click-button":_vm.clickButton,"selected":_vm.selected,"enter":_vm.enter,"key-up":_vm.keyUp,"key-down":_vm.keyDown,"key-right":_vm.keyRight,"clear":_vm.clear,"escape":_vm.escape},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)])}
var staticRenderFns = []


/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JSONtoLeo = undefined;

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseString = '\n<leo_file xmlns:leo="http://leoeditor.com/namespaces/leo-python-editor/1.1" >\n  <leo_header file_format="2" tnodes="0" max_tnode_index="0" clone_windows="0"/>\n  <globals body_outline_ratio="0.5" body_secondary_ratio="0.5">\n    <global_window_position top="50" left="50" height="500" width="700"/>\n    <global_log_window_position top="0" left="0" height="0" width="0"/>\n  </globals>\n  <preferences/>\n  <find_panel_settings/>\n  <vnodes>\n    %%vnodes%%\n  </vnodes>\n  <tnodes>\n    %%tnodes%%\n  </tnodes>\n</leo_file>\n';

function dataToItems(d, items, t, tItems) {
  items.push('<v t="leovue.' + d.t + '"><vh>' + d.name + '</vh>');
  var text = t[d.t];
  text = text.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&\s/g, '&amp;');
  tItems.push('<t tx="leovue.' + d.t + '">' + text + '</t>');
  if (_lodash2.default.isArray(d)) {
    return d.forEach(function (i) {
      return dataToItems(i, items, t, tItems);
    });
  }
  if (d.children) {
    d.children.forEach(function (i) {
      dataToItems(i, items, t, tItems);
    });
  }
  items.push('</v>');
}
function JSONtoLeo(data, textData) {
  var items = [];
  var textItems = [];
  dataToItems(data, items, textData, textItems);

  var vnodes = items.join('');
  var tnodes = textItems.join('');
  var leo = baseString.replace(/%%vnodes%%/, vnodes);
  leo = leo.replace(/%%tnodes%%/, tnodes);
  return leo;
}

exports.JSONtoLeo = JSONtoLeo;

/***/ }),

/***/ 582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"33px"}},[_c('div',{staticClass:"holder"},[(_vm.config.showHeader)?_c('div',{staticClass:"header"},[(_vm.config.showAppTitle)?_c('span',{staticClass:"app-title"},[_vm._v("LeoVue")]):_vm._e(),_vm._v(" "),(_vm.config.showAppTitle && _vm.config.docTitle)?_c('span',[_vm._v(": ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"doc-title"},[_vm._v(_vm._s(_vm.config.docTitle))]),_vm._v(" "),_c('div',{staticClass:"icon icon-button",on:{"click":_vm.toggle}},[_c('icon',{staticClass:"icon",attrs:{"name":"bars"}})],1),_vm._v(" "),_c('div',{staticClass:"button-shim"}),_vm._v(" "),_c('div',{staticClass:"icon icon-button",on:{"click":_vm.goForward}},[_c('icon',{staticClass:"icon",class:{disabled: _vm.noForward},attrs:{"name":"arrow-right"}})],1),_vm._v(" "),_c('div',{staticClass:"icon icon-button disabled",on:{"click":_vm.goBack}},[_c('icon',{staticClass:"icon",class:{disabled: _vm.noBack},attrs:{"name":"arrow-left"}})],1),_vm._v(" "),_c('searchbar',{staticClass:"searchbar"}),_vm._v(" "),_c('div',{staticClass:"vshim"})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"menu",attrs:{"id":"menu"}},[_c('div',{staticClass:"menu-header"},[_vm._v("View Type")]),_vm._v(" "),_vm._l((_vm.viewTypes),function(v){return _c('div',{staticClass:"menu-item",on:{"click":function($event){_vm.setViewType(v.type)}}},[_c('div',{staticClass:"icon-box"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.viewType === v.type),expression:"viewType === v.type"}],staticClass:"check",attrs:{"name":"check"}})],1),_vm._v(" "),_c('div',{staticClass:"menu-label"},[_vm._v(_vm._s(v.name))])])}),_vm._v(" "),_c('div',{staticClass:"menu-separator"}),_vm._v(" "),_c('div',{staticClass:"hshim"}),_vm._v(" "),_c('div',{staticClass:"menu-item",attrs:{"title":"Accordion mode: close siblings when opening node."},on:{"click":function($event){_vm.setAccordion()}}},[_c('div',{staticClass:"icon-box"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.accordion),expression:"accordion"}],staticClass:"check",attrs:{"name":"check"}})],1),_vm._v(" "),_c('div',{staticClass:"menu-label"},[_vm._v("Accordion")])]),_vm._v(" "),_c('div',{staticClass:"menu-separator"}),_vm._v(" "),_c('div',{staticClass:"hshim"}),_vm._v(" "),_c('div',{staticClass:"hshim"}),_vm._v(" "),_c('div',{staticClass:"hshim"}),_vm._v(" "),_c('div',{staticClass:"menu-item",staticStyle:{"text-align":"center"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"menu-item",on:{"click":function($event){_vm.downloadJSON()}}},[_c('div',{staticClass:"menu-label",staticStyle:{"text-decoration":"underline","color":"blue"}},[_vm._v("JSON")])]),_vm._v(" "),_c('div',{staticClass:"menu-item",on:{"click":function($event){_vm.downloadLeo()}}},[_c('div',{staticClass:"menu-label",staticStyle:{"text-decoration":"underline","color":"blue"}},[_vm._v("Leo")])])]),_vm._v(" "),_c('div',{staticClass:"menu-footer",on:{"click":_vm.settings}},[_vm._v("LeoVue")])],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-label"},[_vm._v("Download"),_c('br'),_vm._v(" Node Data")])}]


/***/ }),

/***/ 583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard",style:(_vm.dashboardStyle),attrs:{"id":"dashboard"}},[_c('appheader'),_vm._v(" "),_c('div',{class:{'header-space': _vm.config.showHeader},attrs:{"id":"main"}},[_c('router-view',{attrs:{"id":_vm.id}})],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TreeViewer_vue__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TreeViewer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TreeViewer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TreeViewer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TreeViewer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6edffa8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TreeViewer_vue__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(585)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TreeViewer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6edffa8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TreeViewer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6edffa8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TreeViewer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 585:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 797:
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Item_vue__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Item_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Item_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Item_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5955c114_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Item_vue__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(586)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Item_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5955c114_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Item_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5955c114_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Item_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 850:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{'unselected-sibling': _vm.hasOpenSibling},attrs:{"id":_vm.prefix + _vm.model.id,"nid":_vm.nid}},[_c('div',{staticClass:"item-box",class:{bold: _vm.isFolder, iactive: _vm.active, topItem: _vm.top}},[_c('div',[_c('span',{on:{"mouseover":_vm.hideCloneMenu,"click":_vm.toggle}},[(_vm.isFolder)?_c('div',{staticClass:"icon-b",class:{'icon-bracket': _vm.top}},[_c('div',{staticClass:"arrow",class:{arrowdown: _vm.isOpenA}},[_vm._v(_vm._s(_vm.arrowIcon))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"leo-box"}),_vm._v(" "),(!_vm.isFolder)?_c('div',{staticClass:"leaf-button"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"otitle"},[_vm._v(_vm._s(_vm.model.vtitle))])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isClone),expression:"isClone"}],attrs:{"id":'popoverButton-sync-' + _vm.model.id},on:{"mouseover":_vm.showCloneMenu}},[_c('icon',{staticClass:"clone-button",attrs:{"name":"regular/clone","scale":.5}}),_vm._v(" "),_c('b-popover',{attrs:{"show":_vm.show,"target":'popoverButton-sync-' + _vm.model.id},on:{"update:show":function($event){_vm.show=$event},"shown":_vm.setCloneMenuActive}},[_c('span',{staticStyle:{"cursor":"hand"},domProps:{"innerHTML":_vm._s(_vm.cloneMenu)},on:{"click":_vm.gotoClone}})])],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"child-items"},[_c('div',{staticClass:"inline",domProps:{"innerHTML":_vm._s(_vm.myContent)}}),_vm._v(" "),(_vm.isFolder)?_c('ul',_vm._l((_vm.model.children),function(model){return _c('item',{key:model.id,staticClass:"item",attrs:{"model":model,"prefix":_vm.prefix,"textItems":_vm.textItems,"accordion":_vm.accordion,"targetEl":_vm.targetEl}})})):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpenInline),expression:"isOpenInline"}],staticClass:"hshim"})])])}
var staticRenderFns = []


/***/ }),

/***/ 851:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function presentation(name, content, index, theme, codeTheme) {

  if (!name) {
    name = 'default';
  }
  if (!index) {
    index = 0;
  }
  if (!codeTheme) {
    codeTheme = 'zenburn';
  }
  if (!theme) {
    theme = 'black';
  }

  var html = '\n<!doctype html>\n<html>\n\t<head>\n\t\t<meta charset="utf-8">\n\t\t<!--<base href="static/reveal/"-->\n\t\t<base href="https://cdn.jsdelivr.net/npm/reveal.js@3.6.0/">\n\t\t\n\t\t<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">\n\t\t<title>' + name + '</title>\n\t\t<!--\n\t\t<link rel="stylesheet" href="css/reveal.css">\n\t\t<link id="theme" rel="stylesheet" href="css/theme/' + theme + '.css">\n    -->\n    \n<!--\n\t\t<link rel="stylesheet" href="css/reveal.css">\n-->\n    <style type="text/css">\n    /*!\n     * reveal.js\n     * http://revealjs.com\n     * MIT licensed\n     *\n     * Copyright (C) 2017 Hakim El Hattab, http://hakim.se\n     */\n    /*********************************************\n     * RESET STYLES\n     *********************************************/\n    html, body, .reveal div, .reveal span, .reveal applet, .reveal object, .reveal iframe,\n    .reveal h1, .reveal h2, .reveal h3, .reveal h4, .reveal h5, .reveal h6, .reveal p, .reveal blockquote, .reveal pre,\n    .reveal a, .reveal abbr, .reveal acronym, .reveal address, .reveal big, .reveal cite, .reveal code,\n    .reveal del, .reveal dfn, .reveal em, .reveal img, .reveal ins, .reveal kbd, .reveal q, .reveal s, .reveal samp,\n    .reveal small, .reveal strike, .reveal strong, .reveal sub, .reveal sup, .reveal tt, .reveal var,\n    .reveal b, .reveal u, .reveal center,\n    .reveal dl, .reveal dt, .reveal dd, .reveal ol, .reveal ul, .reveal li,\n    .reveal fieldset, .reveal form, .reveal label, .reveal legend,\n    .reveal table, .reveal caption, .reveal tbody, .reveal tfoot, .reveal thead, .reveal tr, .reveal th, .reveal td,\n    .reveal article, .reveal aside, .reveal canvas, .reveal details, .reveal embed,\n    .reveal figure, .reveal figcaption, .reveal footer, .reveal header, .reveal hgroup,\n    .reveal menu, .reveal nav, .reveal output, .reveal ruby, .reveal section, .reveal summary,\n    .reveal time, .reveal mark, .reveal audio, .reveal video {\n      margin: 0;\n      padding: 0;\n      border: 0;\n      font-size: 100%;\n      /* font: inherit; */\n      vertical-align: baseline; }\n    \n    .reveal article, .reveal aside, .reveal details, .reveal figcaption, .reveal figure,\n    .reveal footer, .reveal header, .reveal hgroup, .reveal menu, .reveal nav, .reveal section {\n      display: block; }\n    \n    /*********************************************\n     * GLOBAL STYLES\n     *********************************************/\n    html,\n    body {\n      width: 100%;\n      height: 100%;\n      overflow: hidden; }\n    \n    body {\n      position: relative;\n      line-height: 1;\n      background-color: #fff;\n      color: #000; }\n    \n    /*********************************************\n     * VIEW FRAGMENTS\n     *********************************************/\n    .reveal .slides section .fragment {\n      opacity: 0;\n      visibility: hidden;\n      transition: all .2s ease; }\n    .reveal .slides section .fragment.visible {\n      opacity: 1;\n      visibility: inherit; }\n    \n    .reveal .slides section .fragment.grow {\n      opacity: 1;\n      visibility: inherit; }\n    .reveal .slides section .fragment.grow.visible {\n      -webkit-transform: scale(1.3);\n      transform: scale(1.3); }\n    \n    .reveal .slides section .fragment.shrink {\n      opacity: 1;\n      visibility: inherit; }\n    .reveal .slides section .fragment.shrink.visible {\n      -webkit-transform: scale(0.7);\n      transform: scale(0.7); }\n    \n    .reveal .slides section .fragment.zoom-in {\n      -webkit-transform: scale(0.1);\n      transform: scale(0.1); }\n    .reveal .slides section .fragment.zoom-in.visible {\n      -webkit-transform: none;\n      transform: none; }\n    \n    .reveal .slides section .fragment.fade-out {\n      opacity: 1;\n      visibility: inherit; }\n    .reveal .slides section .fragment.fade-out.visible {\n      opacity: 0;\n      visibility: hidden; }\n    \n    .reveal .slides section .fragment.semi-fade-out {\n      opacity: 1;\n      visibility: inherit; }\n    .reveal .slides section .fragment.semi-fade-out.visible {\n      opacity: 0.5;\n      visibility: inherit; }\n    \n    .reveal .slides section .fragment.strike {\n      opacity: 1;\n      visibility: inherit; }\n    .reveal .slides section .fragment.strike.visible {\n      text-decoration: line-through; }\n    \n    .reveal .slides section .fragment.fade-up {\n      -webkit-transform: translate(0, 20%);\n      transform: translate(0, 20%); }\n    .reveal .slides section .fragment.fade-up.visible {\n      -webkit-transform: translate(0, 0);\n      transform: translate(0, 0); }\n    \n    .reveal .slides section .fragment.fade-down {\n      -webkit-transform: translate(0, -20%);\n      transform: translate(0, -20%); }\n    .reveal .slides section .fragment.fade-down.visible {\n      -webkit-transform: translate(0, 0);\n      transform: translate(0, 0); }\n    \n    .reveal .slides section .fragment.fade-right {\n      -webkit-transform: translate(-20%, 0);\n      transform: translate(-20%, 0); }\n    .reveal .slides section .fragment.fade-right.visible {\n      -webkit-transform: translate(0, 0);\n      transform: translate(0, 0); }\n    \n    .reveal .slides section .fragment.fade-left {\n      -webkit-transform: translate(20%, 0);\n      transform: translate(20%, 0); }\n    .reveal .slides section .fragment.fade-left.visible {\n      -webkit-transform: translate(0, 0);\n      transform: translate(0, 0); }\n    \n    .reveal .slides section .fragment.current-visible {\n      opacity: 0;\n      visibility: hidden; }\n    .reveal .slides section .fragment.current-visible.current-fragment {\n      opacity: 1;\n      visibility: inherit; }\n    \n    .reveal .slides section .fragment.highlight-red,\n    .reveal .slides section .fragment.highlight-current-red,\n    .reveal .slides section .fragment.highlight-green,\n    .reveal .slides section .fragment.highlight-current-green,\n    .reveal .slides section .fragment.highlight-blue,\n    .reveal .slides section .fragment.highlight-current-blue {\n      opacity: 1;\n      visibility: inherit; }\n    \n    .reveal .slides section .fragment.highlight-red.visible {\n      color: #ff2c2d; }\n    \n    .reveal .slides section .fragment.highlight-green.visible {\n      color: #17ff2e; }\n    \n    .reveal .slides section .fragment.highlight-blue.visible {\n      color: #1b91ff; }\n    \n    .reveal .slides section .fragment.highlight-current-red.current-fragment {\n      color: #ff2c2d; }\n    \n    .reveal .slides section .fragment.highlight-current-green.current-fragment {\n      color: #17ff2e; }\n    \n    .reveal .slides section .fragment.highlight-current-blue.current-fragment {\n      color: #1b91ff; }\n    \n    /*********************************************\n     * DEFAULT ELEMENT STYLES\n     *********************************************/\n    /* Fixes issue in Chrome where italic fonts did not appear when printing to PDF */\n    .reveal:after {\n      content: \'\';\n      font-style: italic; }\n    \n    .reveal iframe {\n      z-index: 1; }\n    \n    /** Prevents layering issues in certain browser/transition combinations */\n    .reveal a {\n      position: relative; }\n    \n    .reveal .stretch {\n      max-width: none;\n      max-height: none; }\n    \n    .reveal pre.stretch code {\n      height: 100%;\n      max-height: 100%;\n      box-sizing: border-box; }\n    \n    /*********************************************\n     * CONTROLS\n     *********************************************/\n    @-webkit-keyframes bounce-right {\n      0%, 10%, 25%, 40%, 50% {\n        -webkit-transform: translateX(0);\n        transform: translateX(0); }\n      20% {\n        -webkit-transform: translateX(10px);\n        transform: translateX(10px); }\n      30% {\n        -webkit-transform: translateX(-5px);\n        transform: translateX(-5px); } }\n    @keyframes bounce-right {\n      0%, 10%, 25%, 40%, 50% {\n        -webkit-transform: translateX(0);\n        transform: translateX(0); }\n      20% {\n        -webkit-transform: translateX(10px);\n        transform: translateX(10px); }\n      30% {\n        -webkit-transform: translateX(-5px);\n        transform: translateX(-5px); } }\n    \n    @-webkit-keyframes bounce-down {\n      0%, 10%, 25%, 40%, 50% {\n        -webkit-transform: translateY(0);\n        transform: translateY(0); }\n      20% {\n        -webkit-transform: translateY(10px);\n        transform: translateY(10px); }\n      30% {\n        -webkit-transform: translateY(-5px);\n        transform: translateY(-5px); } }\n    \n    @keyframes bounce-down {\n      0%, 10%, 25%, 40%, 50% {\n        -webkit-transform: translateY(0);\n        transform: translateY(0); }\n      20% {\n        -webkit-transform: translateY(10px);\n        transform: translateY(10px); }\n      30% {\n        -webkit-transform: translateY(-5px);\n        transform: translateY(-5px); } }\n    \n    .reveal .controls {\n      display: none;\n      position: absolute;\n      top: auto;\n      bottom: 12px;\n      right: 12px;\n      left: auto;\n      z-index: 1;\n      color: #000;\n      pointer-events: none;\n      font-size: 10px; }\n    .reveal .controls button {\n      position: absolute;\n      padding: 0;\n      background-color: transparent;\n      border: 0;\n      outline: 0;\n      cursor: pointer;\n      color: currentColor;\n      -webkit-transform: scale(0.9999);\n      transform: scale(0.9999);\n      transition: color 0.2s ease, opacity 0.2s ease, -webkit-transform 0.2s ease;\n      transition: color 0.2s ease, opacity 0.2s ease, transform 0.2s ease;\n      z-index: 2;\n      pointer-events: auto;\n      font-size: inherit;\n      visibility: hidden;\n      opacity: 0;\n      -webkit-appearance: none;\n      -webkit-tap-highlight-color: transparent; }\n    .reveal .controls .controls-arrow:before,\n    .reveal .controls .controls-arrow:after {\n      content: \'\';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 2.6em;\n      height: 0.5em;\n      border-radius: 0.25em;\n      background-color: currentColor;\n      transition: all 0.15s ease, background-color 0.8s ease;\n      -webkit-transform-origin: 0.2em 50%;\n      transform-origin: 0.2em 50%;\n      will-change: transform; }\n    .reveal .controls .controls-arrow {\n      position: relative;\n      width: 3.6em;\n      height: 3.6em; }\n    .reveal .controls .controls-arrow:before {\n      -webkit-transform: translateX(0.5em) translateY(1.55em) rotate(45deg);\n      transform: translateX(0.5em) translateY(1.55em) rotate(45deg); }\n    .reveal .controls .controls-arrow:after {\n      -webkit-transform: translateX(0.5em) translateY(1.55em) rotate(-45deg);\n      transform: translateX(0.5em) translateY(1.55em) rotate(-45deg); }\n    .reveal .controls .controls-arrow:hover:before {\n      -webkit-transform: translateX(0.5em) translateY(1.55em) rotate(40deg);\n      transform: translateX(0.5em) translateY(1.55em) rotate(40deg); }\n    .reveal .controls .controls-arrow:hover:after {\n      -webkit-transform: translateX(0.5em) translateY(1.55em) rotate(-40deg);\n      transform: translateX(0.5em) translateY(1.55em) rotate(-40deg); }\n    .reveal .controls .controls-arrow:active:before {\n      -webkit-transform: translateX(0.5em) translateY(1.55em) rotate(36deg);\n      transform: translateX(0.5em) translateY(1.55em) rotate(36deg); }\n    .reveal .controls .controls-arrow:active:after {\n      -webkit-transform: translateX(0.5em) translateY(1.55em) rotate(-36deg);\n      transform: translateX(0.5em) translateY(1.55em) rotate(-36deg); }\n    .reveal .controls .navigate-left {\n      right: 6.4em;\n      bottom: 3.2em;\n      -webkit-transform: translateX(-10px);\n      transform: translateX(-10px); }\n    .reveal .controls .navigate-right {\n      right: 0;\n      bottom: 3.2em;\n      -webkit-transform: translateX(10px);\n      transform: translateX(10px); }\n    .reveal .controls .navigate-right .controls-arrow {\n      -webkit-transform: rotate(180deg);\n      transform: rotate(180deg); }\n    .reveal .controls .navigate-right.highlight {\n      -webkit-animation: bounce-right 2s 50 both ease-out;\n      animation: bounce-right 2s 50 both ease-out; }\n    .reveal .controls .navigate-up {\n      right: 3.2em;\n      bottom: 6.4em;\n      -webkit-transform: translateY(-10px);\n      transform: translateY(-10px); }\n    .reveal .controls .navigate-up .controls-arrow {\n      -webkit-transform: rotate(90deg);\n      transform: rotate(90deg); }\n    .reveal .controls .navigate-down {\n      right: 3.2em;\n      bottom: 0;\n      -webkit-transform: translateY(10px);\n      transform: translateY(10px); }\n    .reveal .controls .navigate-down .controls-arrow {\n      -webkit-transform: rotate(-90deg);\n      transform: rotate(-90deg); }\n    .reveal .controls .navigate-down.highlight {\n      -webkit-animation: bounce-down 2s 50 both ease-out;\n      animation: bounce-down 2s 50 both ease-out; }\n    .reveal .controls[data-controls-back-arrows="faded"] .navigate-left.enabled,\n    .reveal .controls[data-controls-back-arrows="faded"] .navigate-up.enabled {\n      opacity: 0.3; }\n    .reveal .controls[data-controls-back-arrows="faded"] .navigate-left.enabled:hover,\n    .reveal .controls[data-controls-back-arrows="faded"] .navigate-up.enabled:hover {\n      opacity: 1; }\n    .reveal .controls[data-controls-back-arrows="hidden"] .navigate-left.enabled,\n    .reveal .controls[data-controls-back-arrows="hidden"] .navigate-up.enabled {\n      opacity: 0;\n      visibility: hidden; }\n    .reveal .controls .enabled {\n      visibility: visible;\n      opacity: 0.9;\n      cursor: pointer;\n      -webkit-transform: none;\n      transform: none; }\n    .reveal .controls .enabled.fragmented {\n      opacity: 0.5; }\n    .reveal .controls .enabled:hover,\n    .reveal .controls .enabled.fragmented:hover {\n      opacity: 1; }\n    \n    .reveal:not(.has-vertical-slides) .controls .navigate-left {\n      bottom: 1.4em;\n      right: 5.5em; }\n    \n    .reveal:not(.has-vertical-slides) .controls .navigate-right {\n      bottom: 1.4em;\n      right: 0.5em; }\n    \n    .reveal:not(.has-horizontal-slides) .controls .navigate-up {\n      right: 1.4em;\n      bottom: 5em; }\n    \n    .reveal:not(.has-horizontal-slides) .controls .navigate-down {\n      right: 1.4em;\n      bottom: 0.5em; }\n    \n    .reveal.has-dark-background .controls {\n      color: #fff; }\n    \n    .reveal.has-light-background .controls {\n      color: #000; }\n    \n    .reveal.no-hover .controls .controls-arrow:hover:before,\n    .reveal.no-hover .controls .controls-arrow:active:before {\n      -webkit-transform: translateX(0.5em) translateY(1.55em) rotate(45deg);\n      transform: translateX(0.5em) translateY(1.55em) rotate(45deg); }\n    \n    .reveal.no-hover .controls .controls-arrow:hover:after,\n    .reveal.no-hover .controls .controls-arrow:active:after {\n      -webkit-transform: translateX(0.5em) translateY(1.55em) rotate(-45deg);\n      transform: translateX(0.5em) translateY(1.55em) rotate(-45deg); }\n    \n    @media screen and (min-width: 500px) {\n      .reveal .controls[data-controls-layout="edges"] {\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0; }\n      .reveal .controls[data-controls-layout="edges"] .navigate-left,\n      .reveal .controls[data-controls-layout="edges"] .navigate-right,\n      .reveal .controls[data-controls-layout="edges"] .navigate-up,\n      .reveal .controls[data-controls-layout="edges"] .navigate-down {\n        bottom: auto;\n        right: auto; }\n      .reveal .controls[data-controls-layout="edges"] .navigate-left {\n        top: 50%;\n        left: 8px;\n        margin-top: -1.8em; }\n      .reveal .controls[data-controls-layout="edges"] .navigate-right {\n        top: 50%;\n        right: 8px;\n        margin-top: -1.8em; }\n      .reveal .controls[data-controls-layout="edges"] .navigate-up {\n        top: 8px;\n        left: 50%;\n        margin-left: -1.8em; }\n      .reveal .controls[data-controls-layout="edges"] .navigate-down {\n        bottom: 8px;\n        left: 50%;\n        margin-left: -1.8em; } }\n    \n    /*********************************************\n     * PROGRESS BAR\n     *********************************************/\n    .reveal .progress {\n      position: absolute;\n      display: none;\n      height: 3px;\n      width: 100%;\n      bottom: 0;\n      left: 0;\n      z-index: 10;\n      background-color: rgba(0, 0, 0, 0.2);\n      color: #fff; }\n    \n    .reveal .progress:after {\n      content: \'\';\n      display: block;\n      position: absolute;\n      height: 10px;\n      width: 100%;\n      top: -10px; }\n    \n    .reveal .progress span {\n      display: block;\n      height: 100%;\n      width: 0px;\n      background-color: currentColor;\n      transition: width 800ms cubic-bezier(0.26, 0.86, 0.44, 0.985); }\n    \n    /*********************************************\n     * SLIDE NUMBER\n     *********************************************/\n    .reveal .slide-number {\n      position: fixed;\n      display: block;\n      right: 8px;\n      bottom: 8px;\n      z-index: 31;\n      font-family: Helvetica, sans-serif;\n      font-size: 12px;\n      line-height: 1;\n      color: #fff;\n      background-color: rgba(0, 0, 0, 0.4);\n      padding: 5px; }\n    \n    .reveal .slide-number-delimiter {\n      margin: 0 3px; }\n    \n    /*********************************************\n     * SLIDES\n     *********************************************/\n    .reveal {\n      position: relative;\n      width: 100%;\n      height: 100%;\n      overflow: hidden;\n      -ms-touch-action: none;\n      touch-action: none; }\n    \n    @media only screen and (orientation: landscape) {\n      .reveal.ua-iphone {\n        position: fixed; } }\n    \n    .reveal .slides {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      margin: auto;\n      pointer-events: none;\n      overflow: visible;\n      z-index: 1;\n      text-align: center;\n      -webkit-perspective: 600px;\n      perspective: 600px;\n      -webkit-perspective-origin: 50% 40%;\n      perspective-origin: 50% 40%; }\n    \n    .reveal .slides > section {\n      -ms-perspective: 600px; }\n    \n    .reveal .slides > section,\n    .reveal .slides > section > section {\n      display: none;\n      position: absolute;\n      width: 100%;\n      padding: 20px 0px;\n      pointer-events: auto;\n      z-index: 10;\n      -webkit-transform-style: flat;\n      transform-style: flat;\n      transition: -webkit-transform-origin 800ms cubic-bezier(0.26, 0.86, 0.44, 0.985), -webkit-transform 800ms cubic-bezier(0.26, 0.86, 0.44, 0.985), visibility 800ms cubic-bezier(0.26, 0.86, 0.44, 0.985), opacity 800ms cubic-bezier(0.26, 0.86, 0.44, 0.985);\n      transition: transform-origin 800ms cubic-bezier(0.26, 0.86, 0.44, 0.985), transform 800ms cubic-bezier(0.26, 0.86, 0.44, 0.985), visibility 800ms cubic-bezier(0.26, 0.86, 0.44, 0.985), opacity 800ms cubic-bezier(0.26, 0.86, 0.44, 0.985); }\n    \n    /* Global transition speed settings */\n    .reveal[data-transition-speed="fast"] .slides section {\n      transition-duration: 400ms; }\n    \n    .reveal[data-transition-speed="slow"] .slides section {\n      transition-duration: 1200ms; }\n    \n    /* Slide-specific transition speed overrides */\n    .reveal .slides section[data-transition-speed="fast"] {\n      transition-duration: 400ms; }\n    \n    .reveal .slides section[data-transition-speed="slow"] {\n      transition-duration: 1200ms; }\n    \n    .reveal .slides > section.stack {\n      padding-top: 0;\n      padding-bottom: 0; }\n    \n    .reveal .slides > section.present,\n    .reveal .slides > section > section.present {\n      display: block;\n      z-index: 11;\n      opacity: 1; }\n    \n    .reveal .slides > section:empty,\n    .reveal .slides > section > section:empty,\n    .reveal .slides > section[data-background-interactive],\n    .reveal .slides > section > section[data-background-interactive] {\n      pointer-events: none; }\n    \n    .reveal.center,\n    .reveal.center .slides,\n    .reveal.center .slides section {\n      min-height: 0 !important; }\n    \n    /* Don\'t allow interaction with invisible slides */\n    .reveal .slides > section.future,\n    .reveal .slides > section > section.future,\n    .reveal .slides > section.past,\n    .reveal .slides > section > section.past {\n      pointer-events: none; }\n    \n    .reveal.overview .slides > section,\n    .reveal.overview .slides > section > section {\n      pointer-events: auto; }\n    \n    .reveal .slides > section.past,\n    .reveal .slides > section.future,\n    .reveal .slides > section > section.past,\n    .reveal .slides > section > section.future {\n      opacity: 0; }\n    \n    /*********************************************\n     * Mixins for readability of transitions\n     *********************************************/\n    /*********************************************\n     * SLIDE TRANSITION\n     * Aliased \'linear\' for backwards compatibility\n     *********************************************/\n    .reveal.slide section {\n      -webkit-backface-visibility: hidden;\n      backface-visibility: hidden; }\n    \n    .reveal .slides > section[data-transition=slide].past,\n    .reveal .slides > section[data-transition~=slide-out].past,\n    .reveal.slide .slides > section:not([data-transition]).past {\n      -webkit-transform: translate(-150%, 0);\n      transform: translate(-150%, 0); }\n    \n    .reveal .slides > section[data-transition=slide].future,\n    .reveal .slides > section[data-transition~=slide-in].future,\n    .reveal.slide .slides > section:not([data-transition]).future {\n      -webkit-transform: translate(150%, 0);\n      transform: translate(150%, 0); }\n    \n    .reveal .slides > section > section[data-transition=slide].past,\n    .reveal .slides > section > section[data-transition~=slide-out].past,\n    .reveal.slide .slides > section > section:not([data-transition]).past {\n      -webkit-transform: translate(0, -150%);\n      transform: translate(0, -150%); }\n    \n    .reveal .slides > section > section[data-transition=slide].future,\n    .reveal .slides > section > section[data-transition~=slide-in].future,\n    .reveal.slide .slides > section > section:not([data-transition]).future {\n      -webkit-transform: translate(0, 150%);\n      transform: translate(0, 150%); }\n    \n    .reveal.linear section {\n      -webkit-backface-visibility: hidden;\n      backface-visibility: hidden; }\n    \n    .reveal .slides > section[data-transition=linear].past,\n    .reveal .slides > section[data-transition~=linear-out].past,\n    .reveal.linear .slides > section:not([data-transition]).past {\n      -webkit-transform: translate(-150%, 0);\n      transform: translate(-150%, 0); }\n    \n    .reveal .slides > section[data-transition=linear].future,\n    .reveal .slides > section[data-transition~=linear-in].future,\n    .reveal.linear .slides > section:not([data-transition]).future {\n      -webkit-transform: translate(150%, 0);\n      transform: translate(150%, 0); }\n    \n    .reveal .slides > section > section[data-transition=linear].past,\n    .reveal .slides > section > section[data-transition~=linear-out].past,\n    .reveal.linear .slides > section > section:not([data-transition]).past {\n      -webkit-transform: translate(0, -150%);\n      transform: translate(0, -150%); }\n    \n    .reveal .slides > section > section[data-transition=linear].future,\n    .reveal .slides > section > section[data-transition~=linear-in].future,\n    .reveal.linear .slides > section > section:not([data-transition]).future {\n      -webkit-transform: translate(0, 150%);\n      transform: translate(0, 150%); }\n    \n    /*********************************************\n     * CONVEX TRANSITION\n     * Aliased \'default\' for backwards compatibility\n     *********************************************/\n    .reveal .slides section[data-transition=default].stack,\n    .reveal.default .slides section.stack {\n      -webkit-transform-style: preserve-3d;\n      transform-style: preserve-3d; }\n    \n    .reveal .slides > section[data-transition=default].past,\n    .reveal .slides > section[data-transition~=default-out].past,\n    .reveal.default .slides > section:not([data-transition]).past {\n      -webkit-transform: translate3d(-100%, 0, 0) rotateY(-90deg) translate3d(-100%, 0, 0);\n      transform: translate3d(-100%, 0, 0) rotateY(-90deg) translate3d(-100%, 0, 0); }\n    \n    .reveal .slides > section[data-transition=default].future,\n    .reveal .slides > section[data-transition~=default-in].future,\n    .reveal.default .slides > section:not([data-transition]).future {\n      -webkit-transform: translate3d(100%, 0, 0) rotateY(90deg) translate3d(100%, 0, 0);\n      transform: translate3d(100%, 0, 0) rotateY(90deg) translate3d(100%, 0, 0); }\n    \n    .reveal .slides > section > section[data-transition=default].past,\n    .reveal .slides > section > section[data-transition~=default-out].past,\n    .reveal.default .slides > section > section:not([data-transition]).past {\n      -webkit-transform: translate3d(0, -300px, 0) rotateX(70deg) translate3d(0, -300px, 0);\n      transform: translate3d(0, -300px, 0) rotateX(70deg) translate3d(0, -300px, 0); }\n    \n    .reveal .slides > section > section[data-transition=default].future,\n    .reveal .slides > section > section[data-transition~=default-in].future,\n    .reveal.default .slides > section > section:not([data-transition]).future {\n      -webkit-transform: translate3d(0, 300px, 0) rotateX(-70deg) translate3d(0, 300px, 0);\n      transform: translate3d(0, 300px, 0) rotateX(-70deg) translate3d(0, 300px, 0); }\n    \n    .reveal .slides section[data-transition=convex].stack,\n    .reveal.convex .slides section.stack {\n      -webkit-transform-style: preserve-3d;\n      transform-style: preserve-3d; }\n    \n    .reveal .slides > section[data-transition=convex].past,\n    .reveal .slides > section[data-transition~=convex-out].past,\n    .reveal.convex .slides > section:not([data-transition]).past {\n      -webkit-transform: translate3d(-100%, 0, 0) rotateY(-90deg) translate3d(-100%, 0, 0);\n      transform: translate3d(-100%, 0, 0) rotateY(-90deg) translate3d(-100%, 0, 0); }\n    \n    .reveal .slides > section[data-transition=convex].future,\n    .reveal .slides > section[data-transition~=convex-in].future,\n    .reveal.convex .slides > section:not([data-transition]).future {\n      -webkit-transform: translate3d(100%, 0, 0) rotateY(90deg) translate3d(100%, 0, 0);\n      transform: translate3d(100%, 0, 0) rotateY(90deg) translate3d(100%, 0, 0); }\n    \n    .reveal .slides > section > section[data-transition=convex].past,\n    .reveal .slides > section > section[data-transition~=convex-out].past,\n    .reveal.convex .slides > section > section:not([data-transition]).past {\n      -webkit-transform: translate3d(0, -300px, 0) rotateX(70deg) translate3d(0, -300px, 0);\n      transform: translate3d(0, -300px, 0) rotateX(70deg) translate3d(0, -300px, 0); }\n    \n    .reveal .slides > section > section[data-transition=convex].future,\n    .reveal .slides > section > section[data-transition~=convex-in].future,\n    .reveal.convex .slides > section > section:not([data-transition]).future {\n      -webkit-transform: translate3d(0, 300px, 0) rotateX(-70deg) translate3d(0, 300px, 0);\n      transform: translate3d(0, 300px, 0) rotateX(-70deg) translate3d(0, 300px, 0); }\n    \n    /*********************************************\n     * CONCAVE TRANSITION\n     *********************************************/\n    .reveal .slides section[data-transition=concave].stack,\n    .reveal.concave .slides section.stack {\n      -webkit-transform-style: preserve-3d;\n      transform-style: preserve-3d; }\n    \n    .reveal .slides > section[data-transition=concave].past,\n    .reveal .slides > section[data-transition~=concave-out].past,\n    .reveal.concave .slides > section:not([data-transition]).past {\n      -webkit-transform: translate3d(-100%, 0, 0) rotateY(90deg) translate3d(-100%, 0, 0);\n      transform: translate3d(-100%, 0, 0) rotateY(90deg) translate3d(-100%, 0, 0); }\n    \n    .reveal .slides > section[data-transition=concave].future,\n    .reveal .slides > section[data-transition~=concave-in].future,\n    .reveal.concave .slides > section:not([data-transition]).future {\n      -webkit-transform: translate3d(100%, 0, 0) rotateY(-90deg) translate3d(100%, 0, 0);\n      transform: translate3d(100%, 0, 0) rotateY(-90deg) translate3d(100%, 0, 0); }\n    \n    .reveal .slides > section > section[data-transition=concave].past,\n    .reveal .slides > section > section[data-transition~=concave-out].past,\n    .reveal.concave .slides > section > section:not([data-transition]).past {\n      -webkit-transform: translate3d(0, -80%, 0) rotateX(-70deg) translate3d(0, -80%, 0);\n      transform: translate3d(0, -80%, 0) rotateX(-70deg) translate3d(0, -80%, 0); }\n    \n    .reveal .slides > section > section[data-transition=concave].future,\n    .reveal .slides > section > section[data-transition~=concave-in].future,\n    .reveal.concave .slides > section > section:not([data-transition]).future {\n      -webkit-transform: translate3d(0, 80%, 0) rotateX(70deg) translate3d(0, 80%, 0);\n      transform: translate3d(0, 80%, 0) rotateX(70deg) translate3d(0, 80%, 0); }\n    \n    /*********************************************\n     * ZOOM TRANSITION\n     *********************************************/\n    .reveal .slides section[data-transition=zoom],\n    .reveal.zoom .slides section:not([data-transition]) {\n      transition-timing-function: ease; }\n    \n    .reveal .slides > section[data-transition=zoom].past,\n    .reveal .slides > section[data-transition~=zoom-out].past,\n    .reveal.zoom .slides > section:not([data-transition]).past {\n      visibility: hidden;\n      -webkit-transform: scale(16);\n      transform: scale(16); }\n    \n    .reveal .slides > section[data-transition=zoom].future,\n    .reveal .slides > section[data-transition~=zoom-in].future,\n    .reveal.zoom .slides > section:not([data-transition]).future {\n      visibility: hidden;\n      -webkit-transform: scale(0.2);\n      transform: scale(0.2); }\n    \n    .reveal .slides > section > section[data-transition=zoom].past,\n    .reveal .slides > section > section[data-transition~=zoom-out].past,\n    .reveal.zoom .slides > section > section:not([data-transition]).past {\n      -webkit-transform: translate(0, -150%);\n      transform: translate(0, -150%); }\n    \n    .reveal .slides > section > section[data-transition=zoom].future,\n    .reveal .slides > section > section[data-transition~=zoom-in].future,\n    .reveal.zoom .slides > section > section:not([data-transition]).future {\n      -webkit-transform: translate(0, 150%);\n      transform: translate(0, 150%); }\n    \n    /*********************************************\n     * CUBE TRANSITION\n     *\n     * WARNING:\n     * this is deprecated and will be removed in a\n     * future version.\n     *********************************************/\n    .reveal.cube .slides {\n      -webkit-perspective: 1300px;\n      perspective: 1300px; }\n    \n    .reveal.cube .slides section {\n      padding: 30px;\n      min-height: 700px;\n      -webkit-backface-visibility: hidden;\n      backface-visibility: hidden;\n      box-sizing: border-box;\n      -webkit-transform-style: preserve-3d;\n      transform-style: preserve-3d; }\n    \n    .reveal.center.cube .slides section {\n      min-height: 0; }\n    \n    .reveal.cube .slides section:not(.stack):before {\n      content: \'\';\n      position: absolute;\n      display: block;\n      width: 100%;\n      height: 100%;\n      left: 0;\n      top: 0;\n      background: rgba(0, 0, 0, 0.1);\n      border-radius: 4px;\n      -webkit-transform: translateZ(-20px);\n      transform: translateZ(-20px); }\n    \n    .reveal.cube .slides section:not(.stack):after {\n      content: \'\';\n      position: absolute;\n      display: block;\n      width: 90%;\n      height: 30px;\n      left: 5%;\n      bottom: 0;\n      background: none;\n      z-index: 1;\n      border-radius: 4px;\n      box-shadow: 0px 95px 25px rgba(0, 0, 0, 0.2);\n      -webkit-transform: translateZ(-90px) rotateX(65deg);\n      transform: translateZ(-90px) rotateX(65deg); }\n    \n    .reveal.cube .slides > section.stack {\n      padding: 0;\n      background: none; }\n    \n    .reveal.cube .slides > section.past {\n      -webkit-transform-origin: 100% 0%;\n      transform-origin: 100% 0%;\n      -webkit-transform: translate3d(-100%, 0, 0) rotateY(-90deg);\n      transform: translate3d(-100%, 0, 0) rotateY(-90deg); }\n    \n    .reveal.cube .slides > section.future {\n      -webkit-transform-origin: 0% 0%;\n      transform-origin: 0% 0%;\n      -webkit-transform: translate3d(100%, 0, 0) rotateY(90deg);\n      transform: translate3d(100%, 0, 0) rotateY(90deg); }\n    \n    .reveal.cube .slides > section > section.past {\n      -webkit-transform-origin: 0% 100%;\n      transform-origin: 0% 100%;\n      -webkit-transform: translate3d(0, -100%, 0) rotateX(90deg);\n      transform: translate3d(0, -100%, 0) rotateX(90deg); }\n    \n    .reveal.cube .slides > section > section.future {\n      -webkit-transform-origin: 0% 0%;\n      transform-origin: 0% 0%;\n      -webkit-transform: translate3d(0, 100%, 0) rotateX(-90deg);\n      transform: translate3d(0, 100%, 0) rotateX(-90deg); }\n    \n    /*********************************************\n     * PAGE TRANSITION\n     *\n     * WARNING:\n     * this is deprecated and will be removed in a\n     * future version.\n     *********************************************/\n    .reveal.page .slides {\n      -webkit-perspective-origin: 0% 50%;\n      perspective-origin: 0% 50%;\n      -webkit-perspective: 3000px;\n      perspective: 3000px; }\n    \n    .reveal.page .slides section {\n      padding: 30px;\n      min-height: 700px;\n      box-sizing: border-box;\n      -webkit-transform-style: preserve-3d;\n      transform-style: preserve-3d; }\n    \n    .reveal.page .slides section.past {\n      z-index: 12; }\n    \n    .reveal.page .slides section:not(.stack):before {\n      content: \'\';\n      position: absolute;\n      display: block;\n      width: 100%;\n      height: 100%;\n      left: 0;\n      top: 0;\n      background: rgba(0, 0, 0, 0.1);\n      -webkit-transform: translateZ(-20px);\n      transform: translateZ(-20px); }\n    \n    .reveal.page .slides section:not(.stack):after {\n      content: \'\';\n      position: absolute;\n      display: block;\n      width: 90%;\n      height: 30px;\n      left: 5%;\n      bottom: 0;\n      background: none;\n      z-index: 1;\n      border-radius: 4px;\n      box-shadow: 0px 95px 25px rgba(0, 0, 0, 0.2);\n      -webkit-transform: translateZ(-90px) rotateX(65deg); }\n    \n    .reveal.page .slides > section.stack {\n      padding: 0;\n      background: none; }\n    \n    .reveal.page .slides > section.past {\n      -webkit-transform-origin: 0% 0%;\n      transform-origin: 0% 0%;\n      -webkit-transform: translate3d(-40%, 0, 0) rotateY(-80deg);\n      transform: translate3d(-40%, 0, 0) rotateY(-80deg); }\n    \n    .reveal.page .slides > section.future {\n      -webkit-transform-origin: 100% 0%;\n      transform-origin: 100% 0%;\n      -webkit-transform: translate3d(0, 0, 0);\n      transform: translate3d(0, 0, 0); }\n    \n    .reveal.page .slides > section > section.past {\n      -webkit-transform-origin: 0% 0%;\n      transform-origin: 0% 0%;\n      -webkit-transform: translate3d(0, -40%, 0) rotateX(80deg);\n      transform: translate3d(0, -40%, 0) rotateX(80deg); }\n    \n    .reveal.page .slides > section > section.future {\n      -webkit-transform-origin: 0% 100%;\n      transform-origin: 0% 100%;\n      -webkit-transform: translate3d(0, 0, 0);\n      transform: translate3d(0, 0, 0); }\n    \n    /*********************************************\n     * FADE TRANSITION\n     *********************************************/\n    .reveal .slides section[data-transition=fade],\n    .reveal.fade .slides section:not([data-transition]),\n    .reveal.fade .slides > section > section:not([data-transition]) {\n      -webkit-transform: none;\n      transform: none;\n      transition: opacity 0.5s; }\n    \n    .reveal.fade.overview .slides section,\n    .reveal.fade.overview .slides > section > section {\n      transition: none; }\n    \n    /*********************************************\n     * NO TRANSITION\n     *********************************************/\n    .reveal .slides section[data-transition=none],\n    .reveal.none .slides section:not([data-transition]) {\n      -webkit-transform: none;\n      transform: none;\n      transition: none; }\n    \n    /*********************************************\n     * PAUSED MODE\n     *********************************************/\n    .reveal .pause-overlay {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background: black;\n      visibility: hidden;\n      opacity: 0;\n      z-index: 100;\n      transition: all 1s ease; }\n    \n    .reveal.paused .pause-overlay {\n      visibility: visible;\n      opacity: 1; }\n    \n    /*********************************************\n     * FALLBACK\n     *********************************************/\n    .no-transforms {\n      overflow-y: auto; }\n    \n    .no-transforms .reveal .slides {\n      position: relative;\n      width: 80%;\n      height: auto !important;\n      top: 0;\n      left: 50%;\n      margin: 0;\n      text-align: center; }\n    \n    .no-transforms .reveal .controls,\n    .no-transforms .reveal .progress {\n      display: none !important; }\n    \n    .no-transforms .reveal .slides section {\n      display: block !important;\n      opacity: 1 !important;\n      position: relative !important;\n      height: auto;\n      min-height: 0;\n      top: 0;\n      left: -50%;\n      margin: 70px 0;\n      -webkit-transform: none;\n      transform: none; }\n    \n    .no-transforms .reveal .slides section section {\n      left: 0; }\n    \n    .reveal .no-transition,\n    .reveal .no-transition * {\n      transition: none !important; }\n    \n    /*********************************************\n     * PER-SLIDE BACKGROUNDS\n     *********************************************/\n    .reveal .backgrounds {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      top: 0;\n      left: 0;\n      -webkit-perspective: 600px;\n      perspective: 600px; }\n    \n    .reveal .slide-background {\n      display: none;\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      opacity: 0;\n      visibility: hidden;\n      overflow: hidden;\n      background-color: transparent;\n      background-position: 50% 50%;\n      background-repeat: no-repeat;\n      background-size: cover;\n      transition: all 800ms cubic-bezier(0.26, 0.86, 0.44, 0.985); }\n    \n    .reveal .slide-background.stack {\n      display: block; }\n    \n    .reveal .slide-background.present {\n      opacity: 1;\n      visibility: visible;\n      z-index: 2; }\n    \n    .print-pdf .reveal .slide-background {\n      opacity: 1 !important;\n      visibility: visible !important; }\n    \n    /* Video backgrounds */\n    .reveal .slide-background video {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      max-width: none;\n      max-height: none;\n      top: 0;\n      left: 0;\n      -o-object-fit: cover;\n      object-fit: cover; }\n    \n    .reveal .slide-background[data-background-size="contain"] video {\n      -o-object-fit: contain;\n      object-fit: contain; }\n    \n    /* Immediate transition style */\n    .reveal[data-background-transition=none] > .backgrounds .slide-background,\n    .reveal > .backgrounds .slide-background[data-background-transition=none] {\n      transition: none; }\n    \n    /* Slide */\n    .reveal[data-background-transition=slide] > .backgrounds .slide-background,\n    .reveal > .backgrounds .slide-background[data-background-transition=slide] {\n      opacity: 1;\n      -webkit-backface-visibility: hidden;\n      backface-visibility: hidden; }\n    \n    .reveal[data-background-transition=slide] > .backgrounds .slide-background.past,\n    .reveal > .backgrounds .slide-background.past[data-background-transition=slide] {\n      -webkit-transform: translate(-100%, 0);\n      transform: translate(-100%, 0); }\n    \n    .reveal[data-background-transition=slide] > .backgrounds .slide-background.future,\n    .reveal > .backgrounds .slide-background.future[data-background-transition=slide] {\n      -webkit-transform: translate(100%, 0);\n      transform: translate(100%, 0); }\n    \n    .reveal[data-background-transition=slide] > .backgrounds .slide-background > .slide-background.past,\n    .reveal > .backgrounds .slide-background > .slide-background.past[data-background-transition=slide] {\n      -webkit-transform: translate(0, -100%);\n      transform: translate(0, -100%); }\n    \n    .reveal[data-background-transition=slide] > .backgrounds .slide-background > .slide-background.future,\n    .reveal > .backgrounds .slide-background > .slide-background.future[data-background-transition=slide] {\n      -webkit-transform: translate(0, 100%);\n      transform: translate(0, 100%); }\n    \n    /* Convex */\n    .reveal[data-background-transition=convex] > .backgrounds .slide-background.past,\n    .reveal > .backgrounds .slide-background.past[data-background-transition=convex] {\n      opacity: 0;\n      -webkit-transform: translate3d(-100%, 0, 0) rotateY(-90deg) translate3d(-100%, 0, 0);\n      transform: translate3d(-100%, 0, 0) rotateY(-90deg) translate3d(-100%, 0, 0); }\n    \n    .reveal[data-background-transition=convex] > .backgrounds .slide-background.future,\n    .reveal > .backgrounds .slide-background.future[data-background-transition=convex] {\n      opacity: 0;\n      -webkit-transform: translate3d(100%, 0, 0) rotateY(90deg) translate3d(100%, 0, 0);\n      transform: translate3d(100%, 0, 0) rotateY(90deg) translate3d(100%, 0, 0); }\n    \n    .reveal[data-background-transition=convex] > .backgrounds .slide-background > .slide-background.past,\n    .reveal > .backgrounds .slide-background > .slide-background.past[data-background-transition=convex] {\n      opacity: 0;\n      -webkit-transform: translate3d(0, -100%, 0) rotateX(90deg) translate3d(0, -100%, 0);\n      transform: translate3d(0, -100%, 0) rotateX(90deg) translate3d(0, -100%, 0); }\n    \n    .reveal[data-background-transition=convex] > .backgrounds .slide-background > .slide-background.future,\n    .reveal > .backgrounds .slide-background > .slide-background.future[data-background-transition=convex] {\n      opacity: 0;\n      -webkit-transform: translate3d(0, 100%, 0) rotateX(-90deg) translate3d(0, 100%, 0);\n      transform: translate3d(0, 100%, 0) rotateX(-90deg) translate3d(0, 100%, 0); }\n    \n    /* Concave */\n    .reveal[data-background-transition=concave] > .backgrounds .slide-background.past,\n    .reveal > .backgrounds .slide-background.past[data-background-transition=concave] {\n      opacity: 0;\n      -webkit-transform: translate3d(-100%, 0, 0) rotateY(90deg) translate3d(-100%, 0, 0);\n      transform: translate3d(-100%, 0, 0) rotateY(90deg) translate3d(-100%, 0, 0); }\n    \n    .reveal[data-background-transition=concave] > .backgrounds .slide-background.future,\n    .reveal > .backgrounds .slide-background.future[data-background-transition=concave] {\n      opacity: 0;\n      -webkit-transform: translate3d(100%, 0, 0) rotateY(-90deg) translate3d(100%, 0, 0);\n      transform: translate3d(100%, 0, 0) rotateY(-90deg) translate3d(100%, 0, 0); }\n    \n    .reveal[data-background-transition=concave] > .backgrounds .slide-background > .slide-background.past,\n    .reveal > .backgrounds .slide-background > .slide-background.past[data-background-transition=concave] {\n      opacity: 0;\n      -webkit-transform: translate3d(0, -100%, 0) rotateX(-90deg) translate3d(0, -100%, 0);\n      transform: translate3d(0, -100%, 0) rotateX(-90deg) translate3d(0, -100%, 0); }\n    \n    .reveal[data-background-transition=concave] > .backgrounds .slide-background > .slide-background.future,\n    .reveal > .backgrounds .slide-background > .slide-background.future[data-background-transition=concave] {\n      opacity: 0;\n      -webkit-transform: translate3d(0, 100%, 0) rotateX(90deg) translate3d(0, 100%, 0);\n      transform: translate3d(0, 100%, 0) rotateX(90deg) translate3d(0, 100%, 0); }\n    \n    /* Zoom */\n    .reveal[data-background-transition=zoom] > .backgrounds .slide-background,\n    .reveal > .backgrounds .slide-background[data-background-transition=zoom] {\n      transition-timing-function: ease; }\n    \n    .reveal[data-background-transition=zoom] > .backgrounds .slide-background.past,\n    .reveal > .backgrounds .slide-background.past[data-background-transition=zoom] {\n      opacity: 0;\n      visibility: hidden;\n      -webkit-transform: scale(16);\n      transform: scale(16); }\n    \n    .reveal[data-background-transition=zoom] > .backgrounds .slide-background.future,\n    .reveal > .backgrounds .slide-background.future[data-background-transition=zoom] {\n      opacity: 0;\n      visibility: hidden;\n      -webkit-transform: scale(0.2);\n      transform: scale(0.2); }\n    \n    .reveal[data-background-transition=zoom] > .backgrounds .slide-background > .slide-background.past,\n    .reveal > .backgrounds .slide-background > .slide-background.past[data-background-transition=zoom] {\n      opacity: 0;\n      visibility: hidden;\n      -webkit-transform: scale(16);\n      transform: scale(16); }\n    \n    .reveal[data-background-transition=zoom] > .backgrounds .slide-background > .slide-background.future,\n    .reveal > .backgrounds .slide-background > .slide-background.future[data-background-transition=zoom] {\n      opacity: 0;\n      visibility: hidden;\n      -webkit-transform: scale(0.2);\n      transform: scale(0.2); }\n    \n    /* Global transition speed settings */\n    .reveal[data-transition-speed="fast"] > .backgrounds .slide-background {\n      transition-duration: 400ms; }\n    \n    .reveal[data-transition-speed="slow"] > .backgrounds .slide-background {\n      transition-duration: 1200ms; }\n    \n    /*********************************************\n     * OVERVIEW\n     *********************************************/\n    .reveal.overview {\n      -webkit-perspective-origin: 50% 50%;\n      perspective-origin: 50% 50%;\n      -webkit-perspective: 700px;\n      perspective: 700px; }\n    .reveal.overview .slides {\n      -moz-transform-style: preserve-3d; }\n    .reveal.overview .slides section {\n      height: 100%;\n      top: 0 !important;\n      opacity: 1 !important;\n      overflow: hidden;\n      visibility: visible !important;\n      cursor: pointer;\n      box-sizing: border-box; }\n    .reveal.overview .slides section:hover,\n    .reveal.overview .slides section.present {\n      outline: 10px solid rgba(150, 150, 150, 0.4);\n      outline-offset: 10px; }\n    .reveal.overview .slides section .fragment {\n      opacity: 1;\n      transition: none; }\n    .reveal.overview .slides section:after,\n    .reveal.overview .slides section:before {\n      display: none !important; }\n    .reveal.overview .slides > section.stack {\n      padding: 0;\n      top: 0 !important;\n      background: none;\n      outline: none;\n      overflow: visible; }\n    .reveal.overview .backgrounds {\n      -webkit-perspective: inherit;\n      perspective: inherit;\n      -moz-transform-style: preserve-3d; }\n    .reveal.overview .backgrounds .slide-background {\n      opacity: 1;\n      visibility: visible;\n      outline: 10px solid rgba(150, 150, 150, 0.1);\n      outline-offset: 10px; }\n    .reveal.overview .backgrounds .slide-background.stack {\n      overflow: visible; }\n    \n    .reveal.overview .slides section,\n    .reveal.overview-deactivating .slides section {\n      transition: none; }\n    \n    .reveal.overview .backgrounds .slide-background,\n    .reveal.overview-deactivating .backgrounds .slide-background {\n      transition: none; }\n    \n    /*********************************************\n     * RTL SUPPORT\n     *********************************************/\n    .reveal.rtl .slides,\n    .reveal.rtl .slides h1,\n    .reveal.rtl .slides h2,\n    .reveal.rtl .slides h3,\n    .reveal.rtl .slides h4,\n    .reveal.rtl .slides h5,\n    .reveal.rtl .slides h6 {\n      direction: rtl;\n      font-family: sans-serif; }\n    \n    .reveal.rtl pre,\n    .reveal.rtl code {\n      direction: ltr; }\n    \n    .reveal.rtl ol,\n    .reveal.rtl ul {\n      text-align: right; }\n    \n    .reveal.rtl .progress span {\n      float: right; }\n    \n    /*********************************************\n     * PARALLAX BACKGROUND\n     *********************************************/\n    .reveal.has-parallax-background .backgrounds {\n      transition: all 0.8s ease; }\n    \n    /* Global transition speed settings */\n    .reveal.has-parallax-background[data-transition-speed="fast"] .backgrounds {\n      transition-duration: 400ms; }\n    \n    .reveal.has-parallax-background[data-transition-speed="slow"] .backgrounds {\n      transition-duration: 1200ms; }\n    \n    /*********************************************\n     * LINK PREVIEW OVERLAY\n     *********************************************/\n    .reveal .overlay {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      z-index: 1000;\n      background: rgba(0, 0, 0, 0.9);\n      opacity: 0;\n      visibility: hidden;\n      transition: all 0.3s ease; }\n    \n    .reveal .overlay.visible {\n      opacity: 1;\n      visibility: visible; }\n    \n    .reveal .overlay .spinner {\n      position: absolute;\n      display: block;\n      top: 50%;\n      left: 50%;\n      width: 32px;\n      height: 32px;\n      margin: -16px 0 0 -16px;\n      z-index: 10;\n      background-image: url(data:image/gif;base64,R0lGODlhIAAgAPMAAJmZmf%2F%2F%2F6%2Bvr8nJybW1tcDAwOjo6Nvb26ioqKOjo7Ozs%2FLy8vz8%2FAAAAAAAAAAAACH%2FC05FVFNDQVBFMi4wAwEAAAAh%2FhpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh%2BQQJCgAAACwAAAAAIAAgAAAE5xDISWlhperN52JLhSSdRgwVo1ICQZRUsiwHpTJT4iowNS8vyW2icCF6k8HMMBkCEDskxTBDAZwuAkkqIfxIQyhBQBFvAQSDITM5VDW6XNE4KagNh6Bgwe60smQUB3d4Rz1ZBApnFASDd0hihh12BkE9kjAJVlycXIg7CQIFA6SlnJ87paqbSKiKoqusnbMdmDC2tXQlkUhziYtyWTxIfy6BE8WJt5YJvpJivxNaGmLHT0VnOgSYf0dZXS7APdpB309RnHOG5gDqXGLDaC457D1zZ%2FV%2FnmOM82XiHRLYKhKP1oZmADdEAAAh%2BQQJCgAAACwAAAAAIAAgAAAE6hDISWlZpOrNp1lGNRSdRpDUolIGw5RUYhhHukqFu8DsrEyqnWThGvAmhVlteBvojpTDDBUEIFwMFBRAmBkSgOrBFZogCASwBDEY%2FCZSg7GSE0gSCjQBMVG023xWBhklAnoEdhQEfyNqMIcKjhRsjEdnezB%2BA4k8gTwJhFuiW4dokXiloUepBAp5qaKpp6%2BHo7aWW54wl7obvEe0kRuoplCGepwSx2jJvqHEmGt6whJpGpfJCHmOoNHKaHx61WiSR92E4lbFoq%2BB6QDtuetcaBPnW6%2BO7wDHpIiK9SaVK5GgV543tzjgGcghAgAh%2BQQJCgAAACwAAAAAIAAgAAAE7hDISSkxpOrN5zFHNWRdhSiVoVLHspRUMoyUakyEe8PTPCATW9A14E0UvuAKMNAZKYUZCiBMuBakSQKG8G2FzUWox2AUtAQFcBKlVQoLgQReZhQlCIJesQXI5B0CBnUMOxMCenoCfTCEWBsJColTMANldx15BGs8B5wlCZ9Po6OJkwmRpnqkqnuSrayqfKmqpLajoiW5HJq7FL1Gr2mMMcKUMIiJgIemy7xZtJsTmsM4xHiKv5KMCXqfyUCJEonXPN2rAOIAmsfB3uPoAK%2B%2BG%2Bw48edZPK%2BM6hLJpQg484enXIdQFSS1u6UhksENEQAAIfkECQoAAAAsAAAAACAAIAAABOcQyEmpGKLqzWcZRVUQnZYg1aBSh2GUVEIQ2aQOE%2BG%2BcD4ntpWkZQj1JIiZIogDFFyHI0UxQwFugMSOFIPJftfVAEoZLBbcLEFhlQiqGp1Vd140AUklUN3eCA51C1EWMzMCezCBBmkxVIVHBWd3HHl9JQOIJSdSnJ0TDKChCwUJjoWMPaGqDKannasMo6WnM562R5YluZRwur0wpgqZE7NKUm%2BFNRPIhjBJxKZteWuIBMN4zRMIVIhffcgojwCF117i4nlLnY5ztRLsnOk%2BaV%2BoJY7V7m76PdkS4trKcdg0Zc0tTcKkRAAAIfkECQoAAAAsAAAAACAAIAAABO4QyEkpKqjqzScpRaVkXZWQEximw1BSCUEIlDohrft6cpKCk5xid5MNJTaAIkekKGQkWyKHkvhKsR7ARmitkAYDYRIbUQRQjWBwJRzChi9CRlBcY1UN4g0%2FVNB0AlcvcAYHRyZPdEQFYV8ccwR5HWxEJ02YmRMLnJ1xCYp0Y5idpQuhopmmC2KgojKasUQDk5BNAwwMOh2RtRq5uQuPZKGIJQIGwAwGf6I0JXMpC8C7kXWDBINFMxS4DKMAWVWAGYsAdNqW5uaRxkSKJOZKaU3tPOBZ4DuK2LATgJhkPJMgTwKCdFjyPHEnKxFCDhEAACH5BAkKAAAALAAAAAAgACAAAATzEMhJaVKp6s2nIkolIJ2WkBShpkVRWqqQrhLSEu9MZJKK9y1ZrqYK9WiClmvoUaF8gIQSNeF1Er4MNFn4SRSDARWroAIETg1iVwuHjYB1kYc1mwruwXKC9gmsJXliGxc%2BXiUCby9ydh1sOSdMkpMTBpaXBzsfhoc5l58Gm5yToAaZhaOUqjkDgCWNHAULCwOLaTmzswadEqggQwgHuQsHIoZCHQMMQgQGubVEcxOPFAcMDAYUA85eWARmfSRQCdcMe0zeP1AAygwLlJtPNAAL19DARdPzBOWSm1brJBi45soRAWQAAkrQIykShQ9wVhHCwCQCACH5BAkKAAAALAAAAAAgACAAAATrEMhJaVKp6s2nIkqFZF2VIBWhUsJaTokqUCoBq%2BE71SRQeyqUToLA7VxF0JDyIQh%2FMVVPMt1ECZlfcjZJ9mIKoaTl1MRIl5o4CUKXOwmyrCInCKqcWtvadL2SYhyASyNDJ0uIiRMDjI0Fd30%2FiI2UA5GSS5UDj2l6NoqgOgN4gksEBgYFf0FDqKgHnyZ9OX8HrgYHdHpcHQULXAS2qKpENRg7eAMLC7kTBaixUYFkKAzWAAnLC7FLVxLWDBLKCwaKTULgEwbLA4hJtOkSBNqITT3xEgfLpBtzE%2FjiuL04RGEBgwWhShRgQExHBAAh%2BQQJCgAAACwAAAAAIAAgAAAE7xDISWlSqerNpyJKhWRdlSAVoVLCWk6JKlAqAavhO9UkUHsqlE6CwO1cRdCQ8iEIfzFVTzLdRAmZX3I2SfZiCqGk5dTESJeaOAlClzsJsqwiJwiqnFrb2nS9kmIcgEsjQydLiIlHehhpejaIjzh9eomSjZR%2BipslWIRLAgMDOR2DOqKogTB9pCUJBagDBXR6XB0EBkIIsaRsGGMMAxoDBgYHTKJiUYEGDAzHC9EACcUGkIgFzgwZ0QsSBcXHiQvOwgDdEwfFs0sDzt4S6BK4xYjkDOzn0unFeBzOBijIm1Dgmg5YFQwsCMjp1oJ8LyIAACH5BAkKAAAALAAAAAAgACAAAATwEMhJaVKp6s2nIkqFZF2VIBWhUsJaTokqUCoBq%2BE71SRQeyqUToLA7VxF0JDyIQh%2FMVVPMt1ECZlfcjZJ9mIKoaTl1MRIl5o4CUKXOwmyrCInCKqcWtvadL2SYhyASyNDJ0uIiUd6GGl6NoiPOH16iZKNlH6KmyWFOggHhEEvAwwMA0N9GBsEC6amhnVcEwavDAazGwIDaH1ipaYLBUTCGgQDA8NdHz0FpqgTBwsLqAbWAAnIA4FWKdMLGdYGEgraigbT0OITBcg5QwPT4xLrROZL6AuQAPUS7bxLpoWidY0JtxLHKhwwMJBTHgPKdEQAACH5BAkKAAAALAAAAAAgACAAAATrEMhJaVKp6s2nIkqFZF2VIBWhUsJaTokqUCoBq%2BE71SRQeyqUToLA7VxF0JDyIQh%2FMVVPMt1ECZlfcjZJ9mIKoaTl1MRIl5o4CUKXOwmyrCInCKqcWtvadL2SYhyASyNDJ0uIiUd6GAULDJCRiXo1CpGXDJOUjY%2BYip9DhToJA4RBLwMLCwVDfRgbBAaqqoZ1XBMHswsHtxtFaH1iqaoGNgAIxRpbFAgfPQSqpbgGBqUD1wBXeCYp1AYZ19JJOYgH1KwA4UBvQwXUBxPqVD9L3sbp2BNk2xvvFPJd%2BMFCN6HAAIKgNggY0KtEBAAh%2BQQJCgAAACwAAAAAIAAgAAAE6BDISWlSqerNpyJKhWRdlSAVoVLCWk6JKlAqAavhO9UkUHsqlE6CwO1cRdCQ8iEIfzFVTzLdRAmZX3I2SfYIDMaAFdTESJeaEDAIMxYFqrOUaNW4E4ObYcCXaiBVEgULe0NJaxxtYksjh2NLkZISgDgJhHthkpU4mW6blRiYmZOlh4JWkDqILwUGBnE6TYEbCgevr0N1gH4At7gHiRpFaLNrrq8HNgAJA70AWxQIH1%2BvsYMDAzZQPC9VCNkDWUhGkuE5PxJNwiUK4UfLzOlD4WvzAHaoG9nxPi5d%2BjYUqfAhhykOFwJWiAAAIfkECQoAAAAsAAAAACAAIAAABPAQyElpUqnqzaciSoVkXVUMFaFSwlpOCcMYlErAavhOMnNLNo8KsZsMZItJEIDIFSkLGQoQTNhIsFehRww2CQLKF0tYGKYSg%2BygsZIuNqJksKgbfgIGepNo2cIUB3V1B3IvNiBYNQaDSTtfhhx0CwVPI0UJe0%2Bbm4g5VgcGoqOcnjmjqDSdnhgEoamcsZuXO1aWQy8KAwOAuTYYGwi7w5h%2BKr0SJ8MFihpNbx%2B4Erq7BYBuzsdiH1jCAzoSfl0rVirNbRXlBBlLX%2BBP0XJLAPGzTkAuAOqb0WT5AH7OcdCm5B8TgRwSRKIHQtaLCwg1RAAAOwAAAAAAAAAAAA%3D%3D);\n      visibility: visible;\n      opacity: 0.6;\n      transition: all 0.3s ease; }\n    \n    .reveal .overlay header {\n      position: absolute;\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: 40px;\n      z-index: 2;\n      border-bottom: 1px solid #222; }\n    \n    .reveal .overlay header a {\n      display: inline-block;\n      width: 40px;\n      height: 40px;\n      line-height: 36px;\n      padding: 0 10px;\n      float: right;\n      opacity: 0.6;\n      box-sizing: border-box; }\n    \n    .reveal .overlay header a:hover {\n      opacity: 1; }\n    \n    .reveal .overlay header a .icon {\n      display: inline-block;\n      width: 20px;\n      height: 20px;\n      background-position: 50% 50%;\n      background-size: 100%;\n      background-repeat: no-repeat; }\n    \n    .reveal .overlay header a.close .icon {\n      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABkklEQVRYR8WX4VHDMAxG6wnoJrABZQPYBCaBTWAD2g1gE5gg6OOsXuxIlr40d81dfrSJ9V4c2VLK7spHuTJ/5wpM07QXuXc5X0opX2tEJcadjHuV80li/FgxTIEK/5QBCICBD6xEhSMGHgQPgBgLiYVAB1dpSqKDawxTohFw4JSEA3clzgIBPCURwE2JucBR7rhPJJv5OpJwDX+SfDjgx1wACQeJG1aChP9K/IMmdZ8DtESV1WyP3Bt4MwM6sj4NMxMYiqUWHQu4KYA/SYkIjOsm3BXYWMKFDwU2khjCQ4ELJUJ4SmClRArOCmSXGuKma0fYD5CbzHxFpCSGAhfAVSSUGDUk2BWZaff2g6GE15BsBQ9nwmpIGDiyHQddwNTMKkbZaf9fajXQca1EX44puJZUsnY0ObGmITE3GVLCbEhQUjGVt146j6oasWN+49Vph2w1pZ5EansNZqKBm1txbU57iRRcZ86RWMDdWtBJUHBHwoQPi1GV+JCbntmvok7iTX4/Up9mgyTc/FJYDTcndgH/AA5A/CHsyEkVAAAAAElFTkSuQmCC); }\n    \n    .reveal .overlay header a.external .icon {\n      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAcElEQVRYR+2WSQoAIQwEzf8f7XiOMkUQxUPlGkM3hVmiQfQR9GYnH1SsAQlI4DiBqkCMoNb9y2e90IAEJPAcgdznU9+engMaeJ7Azh5Y1U67gAho4DqBqmB1buAf0MB1AlVBek83ZPkmJMGc1wAR+AAqod/B97TRpQAAAABJRU5ErkJggg==); }\n    \n    .reveal .overlay .viewport {\n      position: absolute;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      top: 40px;\n      right: 0;\n      bottom: 0;\n      left: 0; }\n    \n    .reveal .overlay.overlay-preview .viewport iframe {\n      width: 100%;\n      height: 100%;\n      max-width: 100%;\n      max-height: 100%;\n      border: 0;\n      opacity: 0;\n      visibility: hidden;\n      transition: all 0.3s ease; }\n    \n    .reveal .overlay.overlay-preview.loaded .viewport iframe {\n      opacity: 1;\n      visibility: visible; }\n    \n    .reveal .overlay.overlay-preview.loaded .viewport-inner {\n      position: absolute;\n      z-index: -1;\n      left: 0;\n      top: 45%;\n      width: 100%;\n      text-align: center;\n      letter-spacing: normal; }\n    \n    .reveal .overlay.overlay-preview .x-frame-error {\n      opacity: 0;\n      transition: opacity 0.3s ease 0.3s; }\n    \n    .reveal .overlay.overlay-preview.loaded .x-frame-error {\n      opacity: 1; }\n    \n    .reveal .overlay.overlay-preview.loaded .spinner {\n      opacity: 0;\n      visibility: hidden;\n      -webkit-transform: scale(0.2);\n      transform: scale(0.2); }\n    \n    .reveal .overlay.overlay-help .viewport {\n      overflow: auto;\n      color: #fff; }\n    \n    .reveal .overlay.overlay-help .viewport .viewport-inner {\n      width: 600px;\n      margin: auto;\n      padding: 20px 20px 80px 20px;\n      text-align: center;\n      letter-spacing: normal; }\n    \n    .reveal .overlay.overlay-help .viewport .viewport-inner .title {\n      font-size: 20px; }\n    \n    .reveal .overlay.overlay-help .viewport .viewport-inner table {\n      border: 1px solid #fff;\n      border-collapse: collapse;\n      font-size: 16px; }\n    \n    .reveal .overlay.overlay-help .viewport .viewport-inner table th,\n    .reveal .overlay.overlay-help .viewport .viewport-inner table td {\n      width: 200px;\n      padding: 14px;\n      border: 1px solid #fff;\n      vertical-align: middle; }\n    \n    .reveal .overlay.overlay-help .viewport .viewport-inner table th {\n      padding-top: 20px;\n      padding-bottom: 20px; }\n    \n    /*********************************************\n     * PLAYBACK COMPONENT\n     *********************************************/\n    .reveal .playback {\n      position: absolute;\n      left: 15px;\n      bottom: 20px;\n      z-index: 30;\n      cursor: pointer;\n      transition: all 400ms ease;\n      -webkit-tap-highlight-color: transparent; }\n    \n    .reveal.overview .playback {\n      opacity: 0;\n      visibility: hidden; }\n    \n    /*********************************************\n     * ROLLING LINKS\n     *********************************************/\n    .reveal .roll {\n      display: inline-block;\n      line-height: 1.2;\n      overflow: hidden;\n      vertical-align: top;\n      -webkit-perspective: 400px;\n      perspective: 400px;\n      -webkit-perspective-origin: 50% 50%;\n      perspective-origin: 50% 50%; }\n    \n    .reveal .roll:hover {\n      background: none;\n      text-shadow: none; }\n    \n    .reveal .roll span {\n      display: block;\n      position: relative;\n      padding: 0 2px;\n      pointer-events: none;\n      transition: all 400ms ease;\n      -webkit-transform-origin: 50% 0%;\n      transform-origin: 50% 0%;\n      -webkit-transform-style: preserve-3d;\n      transform-style: preserve-3d;\n      -webkit-backface-visibility: hidden;\n      backface-visibility: hidden; }\n    \n    .reveal .roll:hover span {\n      background: rgba(0, 0, 0, 0.5);\n      -webkit-transform: translate3d(0px, 0px, -45px) rotateX(90deg);\n      transform: translate3d(0px, 0px, -45px) rotateX(90deg); }\n    \n    .reveal .roll span:after {\n      content: attr(data-title);\n      display: block;\n      position: absolute;\n      left: 0;\n      top: 0;\n      padding: 0 2px;\n      -webkit-backface-visibility: hidden;\n      backface-visibility: hidden;\n      -webkit-transform-origin: 50% 0%;\n      transform-origin: 50% 0%;\n      -webkit-transform: translate3d(0px, 110%, 0px) rotateX(-90deg);\n      transform: translate3d(0px, 110%, 0px) rotateX(-90deg); }\n    \n    /*********************************************\n     * SPEAKER NOTES\n     *********************************************/\n    .reveal aside.notes {\n      display: none; }\n    \n    .reveal .speaker-notes {\n      display: none;\n      position: absolute;\n      width: 25vw;\n      height: 100%;\n      top: 0;\n      left: 100%;\n      padding: 14px 18px 14px 18px;\n      z-index: 1;\n      font-size: 18px;\n      line-height: 1.4;\n      border: 1px solid rgba(0, 0, 0, 0.05);\n      color: #222;\n      background-color: #f5f5f5;\n      overflow: auto;\n      box-sizing: border-box;\n      text-align: left;\n      font-family: Helvetica, sans-serif;\n      -webkit-overflow-scrolling: touch; }\n    .reveal .speaker-notes .notes-placeholder {\n      color: #ccc;\n      font-style: italic; }\n    .reveal .speaker-notes:focus {\n      outline: none; }\n    .reveal .speaker-notes:before {\n      content: \'Speaker notes\';\n      display: block;\n      margin-bottom: 10px;\n      opacity: 0.5; }\n    \n    .reveal.show-notes {\n      max-width: 75vw;\n      overflow: visible; }\n    \n    .reveal.show-notes .speaker-notes {\n      display: block; }\n    \n    @media screen and (min-width: 1600px) {\n      .reveal .speaker-notes {\n        font-size: 20px; } }\n    \n    @media screen and (max-width: 1024px) {\n      .reveal.show-notes {\n        border-left: 0;\n        max-width: none;\n        max-height: 70%;\n        overflow: visible; }\n      .reveal.show-notes .speaker-notes {\n        top: 100%;\n        left: 0;\n        width: 100%;\n        height: 42.8571428571%; } }\n    \n    @media screen and (max-width: 600px) {\n      .reveal.show-notes {\n        max-height: 60%; }\n      .reveal.show-notes .speaker-notes {\n        top: 100%;\n        height: 66.6666666667%; }\n      .reveal .speaker-notes {\n        font-size: 14px; } }\n    \n    /*********************************************\n     * ZOOM PLUGIN\n     *********************************************/\n    .zoomed .reveal *,\n    .zoomed .reveal *:before,\n    .zoomed .reveal *:after {\n      -webkit-backface-visibility: visible !important;\n      backface-visibility: visible !important; }\n    \n    .zoomed .reveal .progress,\n    .zoomed .reveal .controls {\n      opacity: 0; }\n    \n    .zoomed .reveal .roll span {\n      background: none; }\n    \n    .zoomed .reveal .roll span:after {\n      visibility: hidden; }\n\n\n  </style>\n    <style>\n     .table-component INPUT {\n       display:none;\n     }\n     .table-component TD, .table-component TH {\n       font-size: 90%;\n     }\n     .reveal CANVAS {\n       margin-left: auto;\n       margin-right: auto;\n     }\n     .reveal .flip-container {\n       margin-left: auto;\n       margin-right: auto;\n       width: 80%;\n     }\n    </style>\n\t\t<link id="theme" rel="stylesheet" href="css/theme/' + theme + '.css">\n    \n\t\t<!-- Theme used for syntax highlighting of code -->\n\t\t<!--\n\t\t<link rel="stylesheet" href="lib/css/' + codeTheme + '.css">\n\t\t-->\n\t\t<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/highlight.js@9.12.0/styles/' + codeTheme + '.css">\n\t\t\n    <style type="text/css">\n    .section-link {\n      color: #4cb986;\n      font-weight: bold;\n      cursor: pointer;\n      text-decoration: none;\n      display: inline-block;\n    }\n    </style>\n  <script>\n    window.lconfig = {\n      "presentationName": \'' + name + '\',\n      "index": ' + index + ',\n      "appBase": true,\n      "showAppTitle": true,\n      "showHeader": true,\n      "docTitle": "",\n      "filename": "docs",\n      "firstNodeAsTitle": true,\n      "baseMode": "t",\n      "viewTypes": [\n        {"name": "Outline", "type": "t"},\n        {"name": "Inline", "type": "a"},\n        {"name": "Graphic Tree", "type": "d"},\n        {"name": "Dendrogram", "type": "z"},\n        {"name": "Nested Menu", "type": "n"}\n      ]\n    }\n  </script>\n\n  \t</head>\n\t<body>\n\t  <script type="template" id="slideContent">\n\t  ' + content + '\t  \n    </script>\n\t  <div id="app-base"></div>\n    <script src=\'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-MML-AM_CHTML\'></script>\n    <script src=\'https://unpkg.com/mermaid@7.1.0/dist/mermaid.min.js\'></script>\n    \n\t\t<script src="lib/js/head.min.js"></script>\n\t\t<script src="js/reveal.min.js"></script>\n    <!--\n\t\t<script src="https://cdn.jsdelivr.net/npm/reveal.js@3.6.0/js/manifest.js"></script>\n\t\t<script src="js/vendor.js"></script>\n\t\t<script src="js/app.js"></script>\n    -->\n    \n    <!-- reveal.js if local\n\t\t<script src="js/reveal.js"></script>\n\t\t<script src="lib/js/head.min.js"></script>\n\t\t-->\n\t\t\n\t\t<script src="https://cdn.jsdelivr.net/npm/leo-vue/dist/static/js/manifest.js"></script>\n\t\t<script src="https://cdn.jsdelivr.net/npm/leo-vue/dist/static/js/vendor.js"></script>\n\t\t<script src="https://cdn.jsdelivr.net/npm/leo-vue/dist/static/js/app.js"></script>\n\t\t<script>\n\t\t  Reveal.addEventListener( \'slidechanged\', function( event ) {\n        MathJax.Hub.Rerender(event.currentSlide);\n      });\n    </script>\n    \n\t</body>\n</html>\n\n  ';
  return html;
}

exports.presentation = presentation;

/***/ }),

/***/ 853:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pane",attrs:{"id":"dx"}},[(_vm.textContent)?_c('div',[_c('div',{staticClass:"handle",attrs:{"id":"lhandle"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasPrev),expression:"hasPrev"}],staticClass:"handle-button",on:{"click":_vm.goPrev}},[_c('icon',{staticClass:"icon",attrs:{"name":"chevron-left"}})],1)]),_vm._v(" "),_c('div',{attrs:{"id":"tlayout"}},[_c('div',{style:({position:'relative', overflow: 'hidden', width: '100%', height: 'calc(100vh - 33px)'})},[_c('div',{staticClass:"inner-container",staticStyle:{"width":"100%","overflow":"hidden"},attrs:{"id":"content-inner-container"}},[_c('div',{staticClass:"right-cpane",style:({overflowY: 'auto'}),attrs:{"id":"content-inner-containerb"},on:{"scroll":_vm.onScroll}},[_c('div',{style:({width: _vm.cpWidth, marginLeft: 'auto', marginRight: 'auto'})},[_c(_vm.dynComponent,_vm._b({tag:"component"},'component',_vm.$props,false))],1)])])])]),_vm._v(" "),_c('div',{staticClass:"handle",attrs:{"id":"rhandle"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasNext),expression:"hasNext"}],staticClass:"handle-button",on:{"click":_vm.goNext}},[_c('icon',{staticClass:"icon",attrs:{"name":"chevron-right"}})],1)])]):_vm._e(),_vm._v(" "),(_vm.boardContent)?_c('div',{staticStyle:{"display":"flex","background":"#fff","width":"100%"},attrs:{"id":"bpane"}},[_c('div',{staticStyle:{"width":"100%"}},[_c(_vm.dynComponent,_vm._b({tag:"component"},'component',_vm.$props,false))],1)]):_vm._e(),_vm._v(" "),(_vm.iframeContent)?_c('div',{staticStyle:{"display":"flex","background":"#fff","width":"100%"},attrs:{"id":"vpane"},domProps:{"innerHTML":_vm._s(_vm.iframeHTML)}}):_vm._e()])}
var staticRenderFns = []


/***/ }),

/***/ 854:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 855:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panes-container"},[_c('div',{staticClass:"left-pane unselectable",style:(_vm.leftPaneStyle),attrs:{"id":"left-pane"}},[_c('div',{style:({position:'relative', overflow: 'hidden', width: '800px', height: 'calc(100vh - 33px)'})},[_c('div',{staticClass:"inner-container"},[_c('div',{staticStyle:{"height":"calc(100vh - 33px)","padding-top":"30px"}},[_vm._t("left")],2)])])]),_vm._v(" "),_c('div',{staticClass:"panes-separator",attrs:{"id":"panes-separator"}},[_c('div',{staticClass:"split-left",on:{"click":function($event){_vm.slide('left')}}},[_c('icon',{attrs:{"name":"angle-double-left"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRightButton),expression:"showRightButton"}],staticClass:"split-right",on:{"click":function($event){_vm.slide('right')}}},[_c('icon',{attrs:{"name":"angle-double-right"}})],1)]),_vm._v(" "),_c('div',{staticClass:"right-pane",style:(_vm.rightPaneStyle),attrs:{"id":"right-pane"}},[_vm._t("right")],2)])}
var staticRenderFns = []


/***/ }),

/***/ 856:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"treeviewer"},[_c('splitpane',{attrs:{"leftPaneStyle":_vm.leftPaneStyle}},[_c('ul',{staticClass:"left-pane",style:(_vm.ulStyle),attrs:{"slot":"left"},slot:"left"},_vm._l((_vm.data),function(itemdata,index){return _c('div',[_c('item',{staticClass:"item",attrs:{"model":itemdata,"top":_vm.getTop(index),"textItems":_vm.text,"targetEl":_vm.target.el}})],1)})),_vm._v(" "),_c('contentpane',{attrs:{"slot":"right"},slot:"right"})],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 857:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3Viewer_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3Viewer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3Viewer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3Viewer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3Viewer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7cf7586_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D3Viewer_vue__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(858)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c7cf7586"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3Viewer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7cf7586_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D3Viewer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7cf7586_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D3Viewer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 858:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 859:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3tree_vue__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3tree_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3tree_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3tree_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3tree_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9db952a4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D3tree_vue__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(860)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3tree_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9db952a4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D3tree_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9db952a4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D3tree_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 860:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  size: function size(tree, _size, margin, _ref) {
    var last = _ref.last,
        first = _ref.first;

    tree.size([_size.height - margin.y * 2, _size.width - margin.x * 2 - (last + first)]);
  },
  transformNode: function transformNode(x, y) {
    return y + ',' + x;
  },
  transformSvg: function transformSvg(svg, margin, size, _ref2) {
    var first = _ref2.first;

    return svg.attr('transform', 'translate(' + margin.x + first + ',' + margin.y + ')');
  },
  updateTransform: function updateTransform(transform, _ref3, size, _ref4) {
    var x = _ref3.x,
        y = _ref3.y;
    var first = _ref4.first;

    return transform.translate(x + first, y);
  },
  transformText: function transformText(text, children) {
    return {
      x: !children ? 6 : -6,
      rotate: 0,
      anchor: !children ? 'start' : 'end'
    };
  }
};

/***/ }),

/***/ 890:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  size: function size(tree, _ref, _ref2, _ref3) {
    var width = _ref.width,
        height = _ref.height;
    var x = _ref2.x,
        y = _ref2.y;
    var last = _ref3.last;

    var ray = Math.min(width - x, height - y) / 2 - last;
    tree.size([360, ray]).separation(function (a, b) {
      return (a.parent === b.parent ? 1 : 2) / (a.depth !== 0 ? a.depth : 1);
    });
  },
  transformNode: function transformNode(x, y) {
    var angle = (x - 90) / 180 * Math.PI;
    var radius = y;
    return [radius * Math.cos(angle), radius * Math.sin(angle)];
  },
  transformSvg: function transformSvg(svg, margin, _ref4) {
    var width = _ref4.width,
        height = _ref4.height;

    return svg.attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');
  },
  updateTransform: function updateTransform(transform, margin, _ref5) {
    var width = _ref5.width,
        height = _ref5.height;

    return transform.translate(width / 2, height / 2);
  },
  transformText: function transformText(d, children) {
    return {
      x: d.x < 180 === !children ? 6 : -6,
      rotate: d.x < 180 ? d.x - 90 : d.x + 90,
      anchor: d.x < 180 === !children ? 'start' : 'end'
    };
  }
};

/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findInParents = exports.toPromise = exports.anchorTodx = exports.compareString = undefined;

var _promise = __webpack_require__(66);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function compareString(a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
}

function anchorTodx(d, el) {
  if (d === 'middle') {
    return -el.getBBox().width / 2;
  } else if (d === 'end') {
    return -(el.getBBox().width + 4);
  }
  return 0;
}

function findInParents(node, nodes) {
  if (nodes.indexOf(node) !== -1) {
    return node;
  }

  var parent = node.parent;
  return parent === null ? node : findInParents(parent, nodes);
}

function toPromise(transition) {
  var count = 0;
  var interrupted = false;
  transition.each(function () {
    return count++;
  });
  return new _promise2.default(function (resolve, reject) {
    if (count === 0) {
      resolve('ended');
      return;
    }
    var check = function check() {
      if (--count === 0) {
        resolve(interrupted ? 'interrupted' : 'ended');
      }
    };
    transition.on('end', check);
    transition.on('interrupt', function () {
      interrupted = true;
      check();
    });
  });
}

exports.compareString = compareString;
exports.anchorTodx = anchorTodx;
exports.toPromise = toPromise;
exports.findInParents = findInParents;

/***/ })

},[552]);


// WEBPACK FOOTER //
// static/js/app.js?9408f1cb3e7d711ad740